import React, { useCallback, useState, lazy, Suspense } from 'react';
import {
  Button,
  TextInput,
  NumberInput,
  Select,
  SelectItem,
  Checkbox,
  DataTable,
  TableRow,
  TableHead,
  TableHeader,
  TableContainer,
  TableCell,
  Table,
  TableBody,
  TableToolbar,
  TableToolbarContent,
} from 'carbon-components-react';

import Collapsible from 'react-collapsible';
import { Tabs, Tab, TabPanel, TabList } from 'react-web-tabs';
import { Tooltip as ReactTooltip } from "react-tooltip";


import { safeLoad, getDivHeight, jsonToYaml, updateStyle, updateStyle2, validateField, toggleDescription } from '../../helpers';

const IdentityauthChallengeRedirectparametersDeleteModal = lazy(() => import('./identityauth_challenge_redirectparametersDeleteModal'));
const IdentityauthChallengeRedirectparametersAdd = lazy(() => import('./identityauth_challenge_redirectparametersAdd'));
const IdentityauthChallengeRedirectparametersEdit = lazy(() => import('./identityauth_challenge_redirectparametersEdit'));
const IdentityauthCompleteRedirectparametersDeleteModal = lazy(() => import('./identityauth_complete_redirectparametersDeleteModal'));
const IdentityauthCompleteRedirectparametersAdd = lazy(() => import('./identityauth_complete_redirectparametersAdd'));
const IdentityauthCompleteRedirectparametersEdit = lazy(() => import('./identityauth_complete_redirectparametersEdit'));
const IdentityciOidcallowedQueryArgsDeleteModal = lazy(() => import('./identityci_oidcallowed_query_argsDeleteModal'));
const IdentityciOidcallowedQueryArgsAdd = lazy(() => import('./identityci_oidcallowed_query_argsAdd'));
const IdentityciOidcallowedQueryArgsEdit = lazy(() => import('./identityci_oidcallowed_query_argsEdit'));
const IdentityciOidcbearerTokenAttrsDeleteModal = lazy(() => import('./identityci_oidcbearer_token_attrsDeleteModal'));
const IdentityciOidcbearerTokenAttrsAdd = lazy(() => import('./identityci_oidcbearer_token_attrsAdd'));
const IdentityciOidcbearerTokenAttrsEdit = lazy(() => import('./identityci_oidcbearer_token_attrsEdit'));
const IdentityciOidcidTokenAttrsDeleteModal = lazy(() => import('./identityci_oidcid_token_attrsDeleteModal'));
const IdentityciOidcidTokenAttrsAdd = lazy(() => import('./identityci_oidcid_token_attrsAdd'));
const IdentityciOidcidTokenAttrsEdit = lazy(() => import('./identityci_oidcid_token_attrsEdit'));
const IdentityciOidcscopesDeleteModal = lazy(() => import('./identityci_oidcscopesDeleteModal'));
const IdentityciOidcscopesAdd = lazy(() => import('./identityci_oidcscopesAdd'));
const IdentityciOidcscopesEdit = lazy(() => import('./identityci_oidcscopesEdit'));
const IdentityeaitriggersDeleteModal = lazy(() => import('./identityeaitriggersDeleteModal'));
const IdentityeaitriggersAdd = lazy(() => import('./identityeaitriggersAdd'));
const IdentityeaitriggersEdit = lazy(() => import('./identityeaitriggersEdit'));
const IdentityoauthDeleteModal = lazy(() => import('./identityoauthDeleteModal'));
const IdentityoauthAdd = lazy(() => import('./identityoauthAdd'));
const IdentityoauthEdit = lazy(() => import('./identityoauthEdit'));
const IdentityoauthattributesDeleteModal = lazy(() => import('./identityoauthattributesDeleteModal'));
const IdentityoauthattributesAdd = lazy(() => import('./identityoauthattributesAdd'));
const IdentityoauthattributesEdit = lazy(() => import('./identityoauthattributesEdit'));
const IdentityoauthheadersDeleteModal = lazy(() => import('./identityoauthheadersDeleteModal'));
const IdentityoauthheadersAdd = lazy(() => import('./identityoauthheadersAdd'));
const IdentityoauthheadersEdit = lazy(() => import('./identityoauthheadersEdit'));
const IdentityoauthsslcertificateDeleteModal = lazy(() => import('./identityoauthsslcertificateDeleteModal'));
const IdentityoauthsslcertificateAdd = lazy(() => import('./identityoauthsslcertificateAdd'));
const IdentityoauthsslcertificateEdit = lazy(() => import('./identityoauthsslcertificateEdit'));
const IdentityoidcDeleteModal = lazy(() => import('./identityoidcDeleteModal'));
const IdentityoidcAdd = lazy(() => import('./identityoidcAdd'));
const IdentityoidcEdit = lazy(() => import('./identityoidcEdit'));
const IdentityoidcallowedQueryArgsDeleteModal = lazy(() => import('./identityoidcallowed_query_argsDeleteModal'));
const IdentityoidcallowedQueryArgsAdd = lazy(() => import('./identityoidcallowed_query_argsAdd'));
const IdentityoidcallowedQueryArgsEdit = lazy(() => import('./identityoidcallowed_query_argsEdit'));
const IdentityoidcbearerTokenAttrsDeleteModal = lazy(() => import('./identityoidcbearer_token_attrsDeleteModal'));
const IdentityoidcbearerTokenAttrsAdd = lazy(() => import('./identityoidcbearer_token_attrsAdd'));
const IdentityoidcbearerTokenAttrsEdit = lazy(() => import('./identityoidcbearer_token_attrsEdit'));
const IdentityoidcidTokenAttrsDeleteModal = lazy(() => import('./identityoidcid_token_attrsDeleteModal'));
const IdentityoidcidTokenAttrsAdd = lazy(() => import('./identityoidcid_token_attrsAdd'));
const IdentityoidcidTokenAttrsEdit = lazy(() => import('./identityoidcid_token_attrsEdit'));
const IdentityoidcscopesDeleteModal = lazy(() => import('./identityoidcscopesDeleteModal'));
const IdentityoidcscopesAdd = lazy(() => import('./identityoidcscopesAdd'));
const IdentityoidcscopesEdit = lazy(() => import('./identityoidcscopesEdit'));
const IdentityoidcsslcertificateDeleteModal = lazy(() => import('./identityoidcsslcertificateDeleteModal'));
const IdentityoidcsslcertificateAdd = lazy(() => import('./identityoidcsslcertificateAdd'));
const IdentityoidcsslcertificateEdit = lazy(() => import('./identityoidcsslcertificateEdit'));


const handleChange = () =>{
    var yamlText = window.iagyaml;

    var json = {};

    if(yamlText !== null && yamlText !== undefined) {
        json = safeLoad(yamlText);
        if(json === undefined || json === null) {
          json = {};
        }
    }

    var newElem = {};
    var newauth_challenge_redirect = {};
    if(document.getElementById("identity_auth_challenge_redirect_url_id").value.endsWith(":") !== true) {
    newauth_challenge_redirect["url"] = document.getElementById("identity_auth_challenge_redirect_url_id").value;
    }
    newauth_challenge_redirect["parameters"] = identity_auth_challenge_redirect_parametersrowData.identity_auth_challenge_redirect_parameters;
    newElem["auth_challenge_redirect"] = newauth_challenge_redirect;
    var newauth_complete_redirect = {};
    if(document.getElementById("identity_auth_complete_redirect_url_id").value.endsWith(":") !== true) {
    newauth_complete_redirect["url"] = document.getElementById("identity_auth_complete_redirect_url_id").value;
    }
    newauth_complete_redirect["parameters"] = identity_auth_complete_redirect_parametersrowData.identity_auth_complete_redirect_parameters;
    newElem["auth_complete_redirect"] = newauth_complete_redirect;
    var newci_oidc = {};
    if(document.getElementById("identity_ci_oidc_client_id_id").value.endsWith(":") !== true) {
    newci_oidc["client_id"] = document.getElementById("identity_ci_oidc_client_id_id").value;
    }
    if(document.getElementById("identity_ci_oidc_client_secret_id").value.endsWith(":") !== true) {
    newci_oidc["client_secret"] = document.getElementById("identity_ci_oidc_client_secret_id").value;
    }
    if(document.getElementById("identity_ci_oidc_hostname_id").value.endsWith(":") !== true) {
    newci_oidc["hostname"] = document.getElementById("identity_ci_oidc_hostname_id").value;
    }
    if(document.getElementById("identity_ci_oidc_mapped_identity_id").value.endsWith(":") !== true) {
    newci_oidc["mapped_identity"] = document.getElementById("identity_ci_oidc_mapped_identity_id").value;
    }
    if(document.getElementById("identity_ci_oidc_proxy_id").value.endsWith(":") !== true) {
    newci_oidc["proxy"] = document.getElementById("identity_ci_oidc_proxy_id").value;
    }
    if(document.getElementById("identity_ci_oidc_redirect_uri_host_id").value.endsWith(":") !== true) {
    newci_oidc["redirect_uri_host"] = document.getElementById("identity_ci_oidc_redirect_uri_host_id").value;
    }
    newci_oidc["response_mode"] = document.getElementById("identity_ci_oidc_response_mode_id").value;
    newci_oidc["response_type"] = document.getElementById("identity_ci_oidc_response_type_id").value;
    newci_oidc["id_token_attrs"] = identity_ci_oidc_id_token_attrsrowData.identity_ci_oidc_id_token_attrs;
    newci_oidc["allowed_query_args"] = identity_ci_oidc_allowed_query_argsrowData.identity_ci_oidc_allowed_query_args;
    newci_oidc["scopes"] = identity_ci_oidc_scopesrowData.identity_ci_oidc_scopes;
    newci_oidc["bearer_token_attrs"] = identity_ci_oidc_bearer_token_attrsrowData.identity_ci_oidc_bearer_token_attrs;
    newElem["ci_oidc"] = newci_oidc;
    var neweai = {};
    neweai["triggers"] = identity_eai_triggersrowData.identity_eai_triggers;
    newElem["eai"] = neweai;
    newElem["id_token_attrs"] = identity_ci_oidc_id_token_attrsrowData.identity_ci_oidc_id_token_attrs;
    newElem["parameters"] = identity_auth_complete_redirect_parametersrowData.identity_auth_complete_redirect_parameters;
    newElem["parameters"] = identity_auth_challenge_redirect_parametersrowData.identity_auth_challenge_redirect_parameters;
    newElem["allowed_query_args"] = identity_ci_oidc_allowed_query_argsrowData.identity_ci_oidc_allowed_query_args;
    newElem["scopes"] = identity_ci_oidc_scopesrowData.identity_ci_oidc_scopes;
    newElem["triggers"] = identity_eai_triggersrowData.identity_eai_triggers;
    newElem["oauth"] = identity_oauthrowData.identity_oauth;
    newElem["bearer_token_attrs"] = identity_ci_oidc_bearer_token_attrsrowData.identity_ci_oidc_bearer_token_attrs;
    newElem["oidc"] = identity_oidcrowData.identity_oidc;
    json["identity"] = newElem;

    var yamlop = jsonToYaml(json);
    window.iagyaml = yamlop;
};

  const closeAdd = (idPrefix) => {

      if(idPrefix === undefined) idPrefix = "";

      updateStyle("identity_div" + idPrefix, "display", "block");
      document.getElementById("identity_tab" + idPrefix).style.display = "flex";

  };

const identity_auth_challenge_redirect_parametersheaderData = [
    {
    header: 'Name',
    key: 'name',
  },
{
    header: 'Source',
    key: 'source',
  },
{
    header: 'Value',
    key: 'value',
  },

];

const identity_auth_challenge_redirect_parametersrowData = {identity_auth_challenge_redirect_parameters: []};

const identity_auth_challenge_redirect_parametershandleAdd = (idPrefix, clearFields) => {
    if(idPrefix === undefined) idPrefix = "";

    // Set the fields to empty
    if(clearFields) {
      for(var i = 0; i < clearFields.length; i++) {
        eval(clearFields[i]);
      }
    }

    document.getElementById("identity_auth_challenge_redirect_parameters_name_id" + idPrefix).value = "";
    document.getElementById("identity_auth_challenge_redirect_parameters_source_id" + idPrefix).value = "";
    document.getElementById("identity_auth_challenge_redirect_parameters_value_id" + idPrefix).value = "";
    // Hide the tab page
    updateStyle("identity_div" + idPrefix, "display", "none");
    // Show the add page
    document.getElementById("addidentityauth_challenge_redirect_parametersPage" + idPrefix).style.display = "block";
    // Hide the remaining fields
    document.getElementById("identity_tab" + idPrefix).style.display = "none";

  };
const identity_auth_complete_redirect_parametersheaderData = [
    {
    header: 'Name',
    key: 'name',
  },
{
    header: 'Source',
    key: 'source',
  },
{
    header: 'Value',
    key: 'value',
  },

];

const identity_auth_complete_redirect_parametersrowData = {identity_auth_complete_redirect_parameters: []};

const identity_auth_complete_redirect_parametershandleAdd = (idPrefix, clearFields) => {
    if(idPrefix === undefined) idPrefix = "";

    // Set the fields to empty
    if(clearFields) {
      for(var i = 0; i < clearFields.length; i++) {
        eval(clearFields[i]);
      }
    }

    document.getElementById("identity_auth_complete_redirect_parameters_name_id" + idPrefix).value = "";
    document.getElementById("identity_auth_complete_redirect_parameters_source_id" + idPrefix).value = "";
    document.getElementById("identity_auth_complete_redirect_parameters_value_id" + idPrefix).value = "";
    // Hide the tab page
    updateStyle("identity_div" + idPrefix, "display", "none");
    // Show the add page
    document.getElementById("addidentityauth_complete_redirect_parametersPage" + idPrefix).style.display = "block";
    // Hide the remaining fields
    document.getElementById("identity_tab" + idPrefix).style.display = "none";

  };
const identity_ci_oidc_allowed_query_argsheaderData = [
    {
    header: 'Allowed Query Argument',
    key: 'allowed_query_args',
  },

];

const identity_ci_oidc_allowed_query_argsrowData = {identity_ci_oidc_allowed_query_args: []};

const identity_ci_oidc_allowed_query_argshandleAdd = (idPrefix, clearFields) => {
    if(idPrefix === undefined) idPrefix = "";

    // Set the fields to empty
    if(clearFields) {
      for(var i = 0; i < clearFields.length; i++) {
        eval(clearFields[i]);
      }
    }

    document.getElementById("identity_ci_oidc_allowed_query_args_allowed_query_args_id" + idPrefix).value = "";
    // Hide the tab page
    updateStyle("identity_div" + idPrefix, "display", "none");
    // Show the add page
    document.getElementById("addidentityci_oidc_allowed_query_argsPage" + idPrefix).style.display = "block";
    // Hide the remaining fields
    document.getElementById("identity_tab" + idPrefix).style.display = "none";

  };
const identity_ci_oidc_bearer_token_attrsheaderData = [
    {
    header: 'Bearer Token Attribute',
    key: 'bearer_token_attrs',
  },

];

const identity_ci_oidc_bearer_token_attrsrowData = {identity_ci_oidc_bearer_token_attrs: []};

const identity_ci_oidc_bearer_token_attrshandleAdd = (idPrefix, clearFields) => {
    if(idPrefix === undefined) idPrefix = "";

    // Set the fields to empty
    if(clearFields) {
      for(var i = 0; i < clearFields.length; i++) {
        eval(clearFields[i]);
      }
    }

    document.getElementById("identity_ci_oidc_bearer_token_attrs_bearer_token_attrs_id" + idPrefix).value = "";
    // Hide the tab page
    updateStyle("identity_div" + idPrefix, "display", "none");
    // Show the add page
    document.getElementById("addidentityci_oidc_bearer_token_attrsPage" + idPrefix).style.display = "block";
    // Hide the remaining fields
    document.getElementById("identity_tab" + idPrefix).style.display = "none";

  };
const identity_ci_oidc_id_token_attrsheaderData = [
    {
    header: 'ID Token Attribute',
    key: 'id_token_attrs',
  },

];

const identity_ci_oidc_id_token_attrsrowData = {identity_ci_oidc_id_token_attrs: []};

const identity_ci_oidc_id_token_attrshandleAdd = (idPrefix, clearFields) => {
    if(idPrefix === undefined) idPrefix = "";

    // Set the fields to empty
    if(clearFields) {
      for(var i = 0; i < clearFields.length; i++) {
        eval(clearFields[i]);
      }
    }

    document.getElementById("identity_ci_oidc_id_token_attrs_id_token_attrs_id" + idPrefix).value = "";
    // Hide the tab page
    updateStyle("identity_div" + idPrefix, "display", "none");
    // Show the add page
    document.getElementById("addidentityci_oidc_id_token_attrsPage" + idPrefix).style.display = "block";
    // Hide the remaining fields
    document.getElementById("identity_tab" + idPrefix).style.display = "none";

  };
const identity_ci_oidc_scopesheaderData = [
    {
    header: 'Scope',
    key: 'scopes',
  },

];

const identity_ci_oidc_scopesrowData = {identity_ci_oidc_scopes: []};

const identity_ci_oidc_scopeshandleAdd = (idPrefix, clearFields) => {
    if(idPrefix === undefined) idPrefix = "";

    // Set the fields to empty
    if(clearFields) {
      for(var i = 0; i < clearFields.length; i++) {
        eval(clearFields[i]);
      }
    }

    document.getElementById("identity_ci_oidc_scopes_scopes_id" + idPrefix).value = "";
    // Hide the tab page
    updateStyle("identity_div" + idPrefix, "display", "none");
    // Show the add page
    document.getElementById("addidentityci_oidc_scopesPage" + idPrefix).style.display = "block";
    // Hide the remaining fields
    document.getElementById("identity_tab" + idPrefix).style.display = "none";

  };
const identity_eai_triggersheaderData = [
    {
    header: 'Trigger',
    key: 'triggers',
  },

];

const identity_eai_triggersrowData = {identity_eai_triggers: []};

const identity_eai_triggershandleAdd = (idPrefix, clearFields) => {
    if(idPrefix === undefined) idPrefix = "";

    // Set the fields to empty
    if(clearFields) {
      for(var i = 0; i < clearFields.length; i++) {
        eval(clearFields[i]);
      }
    }

    document.getElementById("identity_eai_triggers_triggers_id" + idPrefix).value = "";
    // Hide the tab page
    updateStyle("identity_div" + idPrefix, "display", "none");
    // Show the add page
    document.getElementById("addidentityeai_triggersPage" + idPrefix).style.display = "block";
    // Hide the remaining fields
    document.getElementById("identity_tab" + idPrefix).style.display = "none";

  };
const identity_oauthheaderData = [
    {
    header: 'Authentication Method',
    key: 'auth_method',
  },
{
    header: 'Client ID',
    key: 'client_id',
  },
{
    header: 'Client ID Header',
    key: 'client_id_hdr',
  },
{
    header: 'Client Secret',
    key: 'client_secret',
  },
{
    header: 'Introspection Endpoint',
    key: 'introspection_endpoint',
  },
{
    header: 'Mapped Identity',
    key: 'mapped_identity',
  },
{
    header: 'Multi Valued Scope',
    key: 'multi_valued_scope',
  },
{
    header: 'Name',
    key: 'name',
  },
{
    header: 'Proxy',
    key: 'proxy',
  },
{
    header: 'Restricted',
    key: 'restricted',
  },
{
    header: 'Token Type Hint',
    key: 'token_type_hint',
  },

];

const identity_oauthrowData = {identity_oauth: []};

const identity_oauthhandleAdd = (idPrefix, clearFields) => {
    if(idPrefix === undefined) idPrefix = "";

    // Set the fields to empty
    if(clearFields) {
      for(var i = 0; i < clearFields.length; i++) {
        eval(clearFields[i]);
      }
    }

    document.getElementById("identity_oauth_auth_method_id" + idPrefix).value = "";
    document.getElementById("identity_oauth_client_id_id" + idPrefix).value = "";
    document.getElementById("identity_oauth_client_id_hdr_id" + idPrefix).value = "";
    document.getElementById("identity_oauth_client_secret_id" + idPrefix).value = "";
    document.getElementById("identity_oauth_introspection_endpoint_id" + idPrefix).value = "";
    document.getElementById("identity_oauth_mapped_identity_id" + idPrefix).value = "";
    document.getElementById("identity_oauth_multi_valued_scope_id" + idPrefix).value = "";
    document.getElementById("identity_oauth_name_id" + idPrefix).value = "";
    document.getElementById("identity_oauth_proxy_id" + idPrefix).value = "";
    document.getElementById("identity_oauth_restricted_id" + idPrefix).value = "";
    document.getElementById("identity_oauth_token_type_hint_id" + idPrefix).value = "";
    // Hide the tab page
    updateStyle("identity_div" + idPrefix, "display", "none");
    // Show the add page
    document.getElementById("addidentity_oauthPage" + idPrefix).style.display = "block";
    // Hide the remaining fields
    document.getElementById("identity_tab" + idPrefix).style.display = "none";

  };
const identity_oauth_attributesheaderData = [
    {
    header: 'Attribute',
    key: 'attributes',
  },

];

const identity_oauth_attributesrowData = {identity_oauth_attributes: []};

const identity_oauth_attributeshandleAdd = (idPrefix, clearFields) => {
    if(idPrefix === undefined) idPrefix = "";

    // Set the fields to empty
    if(clearFields) {
      for(var i = 0; i < clearFields.length; i++) {
        eval(clearFields[i]);
      }
    }

    document.getElementById("identity_oauth_attributes_attributes_id" + idPrefix).value = "";
    // Hide the tab page
    updateStyle("identity_div" + idPrefix, "display", "none");
    // Show the add page
    document.getElementById("addidentityoauth_attributesPage" + idPrefix).style.display = "block";
    // Hide the remaining fields
    document.getElementById("identity_tab" + idPrefix).style.display = "none";

  };
const identity_oauth_headersheaderData = [
    {
    header: 'Name',
    key: 'name',
  },
{
    header: 'Source',
    key: 'source',
  },
{
    header: 'Value',
    key: 'value',
  },

];

const identity_oauth_headersrowData = {identity_oauth_headers: []};

const identity_oauth_headershandleAdd = (idPrefix, clearFields) => {
    if(idPrefix === undefined) idPrefix = "";

    // Set the fields to empty
    if(clearFields) {
      for(var i = 0; i < clearFields.length; i++) {
        eval(clearFields[i]);
      }
    }

    document.getElementById("identity_oauth_headers_name_id" + idPrefix).value = "";
    document.getElementById("identity_oauth_headers_source_id" + idPrefix).value = "";
    document.getElementById("identity_oauth_headers_value_id" + idPrefix).value = "";
    // Hide the tab page
    updateStyle("identity_div" + idPrefix, "display", "none");
    // Show the add page
    document.getElementById("addidentityoauth_headersPage" + idPrefix).style.display = "block";
    // Hide the remaining fields
    document.getElementById("identity_tab" + idPrefix).style.display = "none";

  };
const identity_oauth_ssl_certificateheaderData = [
    {
    header: 'Certificate',
    key: 'certificate',
  },

];

const identity_oauth_ssl_certificaterowData = {identity_oauth_ssl_certificate: []};

const identity_oauth_ssl_certificatehandleAdd = (idPrefix, clearFields) => {
    if(idPrefix === undefined) idPrefix = "";

    // Set the fields to empty
    if(clearFields) {
      for(var i = 0; i < clearFields.length; i++) {
        eval(clearFields[i]);
      }
    }

    document.getElementById("identity_oauth_ssl_certificate_certificate_id" + idPrefix).value = "";
    // Hide the tab page
    updateStyle("identity_div" + idPrefix, "display", "none");
    // Show the add page
    document.getElementById("addidentityoauthssl_certificatePage" + idPrefix).style.display = "block";
    // Hide the remaining fields
    document.getElementById("identity_tab" + idPrefix).style.display = "none";

  };
const identity_oidcheaderData = [
    {
    header: 'Client ID',
    key: 'client_id',
  },
{
    header: 'Client Secret',
    key: 'client_secret',
  },
{
    header: 'Discovery Endpoint',
    key: 'discovery_endpoint',
  },
{
    header: 'Mapped Identity',
    key: 'mapped_identity',
  },
{
    header: 'Name',
    key: 'name',
  },
{
    header: 'PKCE',
    key: 'pkce',
  },
{
    header: 'Proxy',
    key: 'proxy',
  },
{
    header: 'Redirect URI Host',
    key: 'redirect_uri_host',
  },
{
    header: 'Response Mode',
    key: 'response_mode',
  },
{
    header: 'Response Type',
    key: 'response_type',
  },

];

const identity_oidcrowData = {identity_oidc: []};

const identity_oidchandleAdd = (idPrefix, clearFields) => {
    if(idPrefix === undefined) idPrefix = "";

    // Set the fields to empty
    if(clearFields) {
      for(var i = 0; i < clearFields.length; i++) {
        eval(clearFields[i]);
      }
    }

    document.getElementById("identity_oidc_client_id_id" + idPrefix).value = "";
    document.getElementById("identity_oidc_client_secret_id" + idPrefix).value = "";
    document.getElementById("identity_oidc_discovery_endpoint_id" + idPrefix).value = "";
    document.getElementById("identity_oidc_mapped_identity_id" + idPrefix).value = "";
    document.getElementById("identity_oidc_name_id" + idPrefix).value = "";
    document.getElementById("identity_oidc_pkce_id" + idPrefix).value = "";
    document.getElementById("identity_oidc_proxy_id" + idPrefix).value = "";
    document.getElementById("identity_oidc_redirect_uri_host_id" + idPrefix).value = "";
    document.getElementById("identity_oidc_response_mode_id" + idPrefix).value = "";
    document.getElementById("identity_oidc_response_type_id" + idPrefix).value = "";
    // Hide the tab page
    updateStyle("identity_div" + idPrefix, "display", "none");
    // Show the add page
    document.getElementById("addidentity_oidcPage" + idPrefix).style.display = "block";
    // Hide the remaining fields
    document.getElementById("identity_tab" + idPrefix).style.display = "none";

  };
const identity_oidc_allowed_query_argsheaderData = [
    {
    header: 'Allowed Query Argument',
    key: 'allowed_query_args',
  },

];

const identity_oidc_allowed_query_argsrowData = {identity_oidc_allowed_query_args: []};

const identity_oidc_allowed_query_argshandleAdd = (idPrefix, clearFields) => {
    if(idPrefix === undefined) idPrefix = "";

    // Set the fields to empty
    if(clearFields) {
      for(var i = 0; i < clearFields.length; i++) {
        eval(clearFields[i]);
      }
    }

    document.getElementById("identity_oidc_allowed_query_args_allowed_query_args_id" + idPrefix).value = "";
    // Hide the tab page
    updateStyle("identity_div" + idPrefix, "display", "none");
    // Show the add page
    document.getElementById("addidentityoidc_allowed_query_argsPage" + idPrefix).style.display = "block";
    // Hide the remaining fields
    document.getElementById("identity_tab" + idPrefix).style.display = "none";

  };
const identity_oidc_bearer_token_attrsheaderData = [
    {
    header: 'Bearer Token Attribute',
    key: 'bearer_token_attrs',
  },

];

const identity_oidc_bearer_token_attrsrowData = {identity_oidc_bearer_token_attrs: []};

const identity_oidc_bearer_token_attrshandleAdd = (idPrefix, clearFields) => {
    if(idPrefix === undefined) idPrefix = "";

    // Set the fields to empty
    if(clearFields) {
      for(var i = 0; i < clearFields.length; i++) {
        eval(clearFields[i]);
      }
    }

    document.getElementById("identity_oidc_bearer_token_attrs_bearer_token_attrs_id" + idPrefix).value = "";
    // Hide the tab page
    updateStyle("identity_div" + idPrefix, "display", "none");
    // Show the add page
    document.getElementById("addidentityoidc_bearer_token_attrsPage" + idPrefix).style.display = "block";
    // Hide the remaining fields
    document.getElementById("identity_tab" + idPrefix).style.display = "none";

  };
const identity_oidc_id_token_attrsheaderData = [
    {
    header: 'ID Token Attribute',
    key: 'id_token_attrs',
  },

];

const identity_oidc_id_token_attrsrowData = {identity_oidc_id_token_attrs: []};

const identity_oidc_id_token_attrshandleAdd = (idPrefix, clearFields) => {
    if(idPrefix === undefined) idPrefix = "";

    // Set the fields to empty
    if(clearFields) {
      for(var i = 0; i < clearFields.length; i++) {
        eval(clearFields[i]);
      }
    }

    document.getElementById("identity_oidc_id_token_attrs_id_token_attrs_id" + idPrefix).value = "";
    // Hide the tab page
    updateStyle("identity_div" + idPrefix, "display", "none");
    // Show the add page
    document.getElementById("addidentityoidc_id_token_attrsPage" + idPrefix).style.display = "block";
    // Hide the remaining fields
    document.getElementById("identity_tab" + idPrefix).style.display = "none";

  };
const identity_oidc_scopesheaderData = [
    {
    header: 'Scope',
    key: 'scopes',
  },

];

const identity_oidc_scopesrowData = {identity_oidc_scopes: []};

const identity_oidc_scopeshandleAdd = (idPrefix, clearFields) => {
    if(idPrefix === undefined) idPrefix = "";

    // Set the fields to empty
    if(clearFields) {
      for(var i = 0; i < clearFields.length; i++) {
        eval(clearFields[i]);
      }
    }

    document.getElementById("identity_oidc_scopes_scopes_id" + idPrefix).value = "";
    // Hide the tab page
    updateStyle("identity_div" + idPrefix, "display", "none");
    // Show the add page
    document.getElementById("addidentityoidc_scopesPage" + idPrefix).style.display = "block";
    // Hide the remaining fields
    document.getElementById("identity_tab" + idPrefix).style.display = "none";

  };
const identity_oidc_ssl_certificateheaderData = [
    {
    header: 'Certificate',
    key: 'certificate',
  },

];

const identity_oidc_ssl_certificaterowData = {identity_oidc_ssl_certificate: []};

const identity_oidc_ssl_certificatehandleAdd = (idPrefix, clearFields) => {
    if(idPrefix === undefined) idPrefix = "";

    // Set the fields to empty
    if(clearFields) {
      for(var i = 0; i < clearFields.length; i++) {
        eval(clearFields[i]);
      }
    }

    document.getElementById("identity_oidc_ssl_certificate_certificate_id" + idPrefix).value = "";
    // Hide the tab page
    updateStyle("identity_div" + idPrefix, "display", "none");
    // Show the add page
    document.getElementById("addidentityoidcssl_certificatePage" + idPrefix).style.display = "block";
    // Hide the remaining fields
    document.getElementById("identity_tab" + idPrefix).style.display = "none";

  };


const IdentityPage = () => {

  const idPrefix = "";

  if(window.iagpage != "IdentityPage") {
    delete(window.editing);
    delete(window.rowId);
    window.iagpage = "IdentityPage";
  }

    const [identity_auth_challenge_redirect_parameters, setidentity_auth_challenge_redirect_parameters] = React.useState([]);
    const [fetchedidentity_auth_challenge_redirect_parameters, setFetchedidentity_auth_challenge_redirect_parameters] = React.useState(false);

    React.useEffect(() => {
      identity_auth_challenge_redirect_parametersloadGrid();
    }, [fetchedidentity_auth_challenge_redirect_parameters]);

    const identity_auth_challenge_redirect_parametersloadGrid = React.useCallback(async (identity_auth_challenge_redirect_parameters_name, identity_auth_challenge_redirect_parameters_source, identity_auth_challenge_redirect_parameters_value, add) => {
      try {
        var attrs = [];
        if(identity_auth_challenge_redirect_parameters_value || identity_auth_challenge_redirect_parameters_source) {
          if(add) {
            for(var i = 0; i < identity_auth_challenge_redirect_parametersrowData.identity_auth_challenge_redirect_parameters.length; i++) {
              var tempId = ((identity_auth_challenge_redirect_parametersrowData.identity_auth_challenge_redirect_parameters[i].value)?identity_auth_challenge_redirect_parametersrowData.identity_auth_challenge_redirect_parameters[i].value:"") + ((identity_auth_challenge_redirect_parametersrowData.identity_auth_challenge_redirect_parameters[i].source)?identity_auth_challenge_redirect_parametersrowData.identity_auth_challenge_redirect_parameters[i].source:"") + "";
              if((window.identity_auth_challenge_redirect_parametersediting != true && window.identity_auth_challenge_redirect_parametersediting != "true") || tempId != window.identity_auth_challenge_redirect_parametersrowId) {
                attrs.push(identity_auth_challenge_redirect_parametersrowData.identity_auth_challenge_redirect_parameters[i]);
              }
            }
            var newId = ((identity_auth_challenge_redirect_parameters_value)?identity_auth_challenge_redirect_parameters_value:"") + ((identity_auth_challenge_redirect_parameters_source)?identity_auth_challenge_redirect_parameters_source:"") + "";
            attrs.push({
              id: newId,
              name: identity_auth_challenge_redirect_parameters_name,
source: identity_auth_challenge_redirect_parameters_source,
value: identity_auth_challenge_redirect_parameters_value,
            });
          } else {
            // Must be a delete
            for(var i = 0; i < identity_auth_challenge_redirect_parametersrowData.identity_auth_challenge_redirect_parameters.length; i++) {
              if(identity_auth_challenge_redirect_parametersrowData.identity_auth_challenge_redirect_parameters[i].value !== identity_auth_challenge_redirect_parameters_value  && identity_auth_challenge_redirect_parametersrowData.identity_auth_challenge_redirect_parameters[i].source !== identity_auth_challenge_redirect_parameters_source ) {
                attrs.push(identity_auth_challenge_redirect_parametersrowData.identity_auth_challenge_redirect_parameters[i]);
              }
            }
          }
        } else {
          attrs = identity_auth_challenge_redirect_parametersrowData.identity_auth_challenge_redirect_parameters;
        }
        identity_auth_challenge_redirect_parametersrowData.identity_auth_challenge_redirect_parameters = attrs;
        const data = {identity_auth_challenge_redirect_parameters: attrs};
        setidentity_auth_challenge_redirect_parameters(data.identity_auth_challenge_redirect_parameters);

        if(identity_auth_challenge_redirect_parameters_value !== undefined && identity_auth_challenge_redirect_parameters_value !== null  && identity_auth_challenge_redirect_parameters_source !== undefined && identity_auth_challenge_redirect_parameters_source !== null ) {
            handleChange();

        }

      } catch (e) {
        console.log(e);
      }
      return true;
    });

    const [identity_auth_complete_redirect_parameters, setidentity_auth_complete_redirect_parameters] = React.useState([]);
    const [fetchedidentity_auth_complete_redirect_parameters, setFetchedidentity_auth_complete_redirect_parameters] = React.useState(false);

    React.useEffect(() => {
      identity_auth_complete_redirect_parametersloadGrid();
    }, [fetchedidentity_auth_complete_redirect_parameters]);

    const identity_auth_complete_redirect_parametersloadGrid = React.useCallback(async (identity_auth_complete_redirect_parameters_name, identity_auth_complete_redirect_parameters_source, identity_auth_complete_redirect_parameters_value, add) => {
      try {
        var attrs = [];
        if(identity_auth_complete_redirect_parameters_source || identity_auth_complete_redirect_parameters_value) {
          if(add) {
            for(var i = 0; i < identity_auth_complete_redirect_parametersrowData.identity_auth_complete_redirect_parameters.length; i++) {
              var tempId = ((identity_auth_complete_redirect_parametersrowData.identity_auth_complete_redirect_parameters[i].source)?identity_auth_complete_redirect_parametersrowData.identity_auth_complete_redirect_parameters[i].source:"") + ((identity_auth_complete_redirect_parametersrowData.identity_auth_complete_redirect_parameters[i].value)?identity_auth_complete_redirect_parametersrowData.identity_auth_complete_redirect_parameters[i].value:"") + "";
              if((window.identity_auth_complete_redirect_parametersediting != true && window.identity_auth_complete_redirect_parametersediting != "true") || tempId != window.identity_auth_complete_redirect_parametersrowId) {
                attrs.push(identity_auth_complete_redirect_parametersrowData.identity_auth_complete_redirect_parameters[i]);
              }
            }
            var newId = ((identity_auth_complete_redirect_parameters_source)?identity_auth_complete_redirect_parameters_source:"") + ((identity_auth_complete_redirect_parameters_value)?identity_auth_complete_redirect_parameters_value:"") + "";
            attrs.push({
              id: newId,
              name: identity_auth_complete_redirect_parameters_name,
source: identity_auth_complete_redirect_parameters_source,
value: identity_auth_complete_redirect_parameters_value,
            });
          } else {
            // Must be a delete
            for(var i = 0; i < identity_auth_complete_redirect_parametersrowData.identity_auth_complete_redirect_parameters.length; i++) {
              if(identity_auth_complete_redirect_parametersrowData.identity_auth_complete_redirect_parameters[i].source !== identity_auth_complete_redirect_parameters_source  && identity_auth_complete_redirect_parametersrowData.identity_auth_complete_redirect_parameters[i].value !== identity_auth_complete_redirect_parameters_value ) {
                attrs.push(identity_auth_complete_redirect_parametersrowData.identity_auth_complete_redirect_parameters[i]);
              }
            }
          }
        } else {
          attrs = identity_auth_complete_redirect_parametersrowData.identity_auth_complete_redirect_parameters;
        }
        identity_auth_complete_redirect_parametersrowData.identity_auth_complete_redirect_parameters = attrs;
        const data = {identity_auth_complete_redirect_parameters: attrs};
        setidentity_auth_complete_redirect_parameters(data.identity_auth_complete_redirect_parameters);

        if(identity_auth_complete_redirect_parameters_source !== undefined && identity_auth_complete_redirect_parameters_source !== null  && identity_auth_complete_redirect_parameters_value !== undefined && identity_auth_complete_redirect_parameters_value !== null ) {
            handleChange();

        }

      } catch (e) {
        console.log(e);
      }
      return true;
    });

    const [identity_ci_oidc_allowed_query_args, setidentity_ci_oidc_allowed_query_args] = React.useState([]);
    const [fetchedidentity_ci_oidc_allowed_query_args, setFetchedidentity_ci_oidc_allowed_query_args] = React.useState(false);

    React.useEffect(() => {
      identity_ci_oidc_allowed_query_argsloadGrid();
    }, [fetchedidentity_ci_oidc_allowed_query_args]);

    const identity_ci_oidc_allowed_query_argsloadGrid = React.useCallback(async (identity_ci_oidc_allowed_query_args_allowed_query_args, add) => {
      try {
        var attrs = [];
        if(identity_ci_oidc_allowed_query_args_allowed_query_args) {
          if(add) {
            for(var i = 0; i < identity_ci_oidc_allowed_query_argsrowData.identity_ci_oidc_allowed_query_args.length; i++) {
              var tempId = ((identity_ci_oidc_allowed_query_argsrowData.identity_ci_oidc_allowed_query_args[i].allowed_query_args)?identity_ci_oidc_allowed_query_argsrowData.identity_ci_oidc_allowed_query_args[i].allowed_query_args:"") + "";
              if((window.identity_ci_oidc_allowed_query_argsediting != true && window.identity_ci_oidc_allowed_query_argsediting != "true") || tempId != window.identity_ci_oidc_allowed_query_argsrowId) {
                attrs.push(identity_ci_oidc_allowed_query_argsrowData.identity_ci_oidc_allowed_query_args[i]);
              }
            }
            var newId = ((identity_ci_oidc_allowed_query_args_allowed_query_args)?identity_ci_oidc_allowed_query_args_allowed_query_args:"") + "";
            attrs.push({
              id: newId,
              allowed_query_args: identity_ci_oidc_allowed_query_args_allowed_query_args,
            });
          } else {
            // Must be a delete
            for(var i = 0; i < identity_ci_oidc_allowed_query_argsrowData.identity_ci_oidc_allowed_query_args.length; i++) {
              if(identity_ci_oidc_allowed_query_argsrowData.identity_ci_oidc_allowed_query_args[i].allowed_query_args !== identity_ci_oidc_allowed_query_args_allowed_query_args ) {
                attrs.push(identity_ci_oidc_allowed_query_argsrowData.identity_ci_oidc_allowed_query_args[i]);
              }
            }
          }
        } else {
          attrs = identity_ci_oidc_allowed_query_argsrowData.identity_ci_oidc_allowed_query_args;
        }
        identity_ci_oidc_allowed_query_argsrowData.identity_ci_oidc_allowed_query_args = attrs;
        const data = {identity_ci_oidc_allowed_query_args: attrs};
        setidentity_ci_oidc_allowed_query_args(data.identity_ci_oidc_allowed_query_args);

        if(identity_ci_oidc_allowed_query_args_allowed_query_args !== undefined && identity_ci_oidc_allowed_query_args_allowed_query_args !== null ) {
            handleChange();

        }

      } catch (e) {
        console.log(e);
      }
      return true;
    });

    const [identity_ci_oidc_bearer_token_attrs, setidentity_ci_oidc_bearer_token_attrs] = React.useState([]);
    const [fetchedidentity_ci_oidc_bearer_token_attrs, setFetchedidentity_ci_oidc_bearer_token_attrs] = React.useState(false);

    React.useEffect(() => {
      identity_ci_oidc_bearer_token_attrsloadGrid();
    }, [fetchedidentity_ci_oidc_bearer_token_attrs]);

    const identity_ci_oidc_bearer_token_attrsloadGrid = React.useCallback(async (identity_ci_oidc_bearer_token_attrs_bearer_token_attrs, add) => {
      try {
        var attrs = [];
        if(identity_ci_oidc_bearer_token_attrs_bearer_token_attrs) {
          if(add) {
            for(var i = 0; i < identity_ci_oidc_bearer_token_attrsrowData.identity_ci_oidc_bearer_token_attrs.length; i++) {
              var tempId = ((identity_ci_oidc_bearer_token_attrsrowData.identity_ci_oidc_bearer_token_attrs[i].bearer_token_attrs)?identity_ci_oidc_bearer_token_attrsrowData.identity_ci_oidc_bearer_token_attrs[i].bearer_token_attrs:"") + "";
              if((window.identity_ci_oidc_bearer_token_attrsediting != true && window.identity_ci_oidc_bearer_token_attrsediting != "true") || tempId != window.identity_ci_oidc_bearer_token_attrsrowId) {
                attrs.push(identity_ci_oidc_bearer_token_attrsrowData.identity_ci_oidc_bearer_token_attrs[i]);
              }
            }
            var newId = ((identity_ci_oidc_bearer_token_attrs_bearer_token_attrs)?identity_ci_oidc_bearer_token_attrs_bearer_token_attrs:"") + "";
            attrs.push({
              id: newId,
              bearer_token_attrs: identity_ci_oidc_bearer_token_attrs_bearer_token_attrs,
            });
          } else {
            // Must be a delete
            for(var i = 0; i < identity_ci_oidc_bearer_token_attrsrowData.identity_ci_oidc_bearer_token_attrs.length; i++) {
              if(identity_ci_oidc_bearer_token_attrsrowData.identity_ci_oidc_bearer_token_attrs[i].bearer_token_attrs !== identity_ci_oidc_bearer_token_attrs_bearer_token_attrs ) {
                attrs.push(identity_ci_oidc_bearer_token_attrsrowData.identity_ci_oidc_bearer_token_attrs[i]);
              }
            }
          }
        } else {
          attrs = identity_ci_oidc_bearer_token_attrsrowData.identity_ci_oidc_bearer_token_attrs;
        }
        identity_ci_oidc_bearer_token_attrsrowData.identity_ci_oidc_bearer_token_attrs = attrs;
        const data = {identity_ci_oidc_bearer_token_attrs: attrs};
        setidentity_ci_oidc_bearer_token_attrs(data.identity_ci_oidc_bearer_token_attrs);

        if(identity_ci_oidc_bearer_token_attrs_bearer_token_attrs !== undefined && identity_ci_oidc_bearer_token_attrs_bearer_token_attrs !== null ) {
            handleChange();

        }

      } catch (e) {
        console.log(e);
      }
      return true;
    });

    const [identity_ci_oidc_id_token_attrs, setidentity_ci_oidc_id_token_attrs] = React.useState([]);
    const [fetchedidentity_ci_oidc_id_token_attrs, setFetchedidentity_ci_oidc_id_token_attrs] = React.useState(false);

    React.useEffect(() => {
      identity_ci_oidc_id_token_attrsloadGrid();
    }, [fetchedidentity_ci_oidc_id_token_attrs]);

    const identity_ci_oidc_id_token_attrsloadGrid = React.useCallback(async (identity_ci_oidc_id_token_attrs_id_token_attrs, add) => {
      try {
        var attrs = [];
        if(identity_ci_oidc_id_token_attrs_id_token_attrs) {
          if(add) {
            for(var i = 0; i < identity_ci_oidc_id_token_attrsrowData.identity_ci_oidc_id_token_attrs.length; i++) {
              var tempId = ((identity_ci_oidc_id_token_attrsrowData.identity_ci_oidc_id_token_attrs[i].id_token_attrs)?identity_ci_oidc_id_token_attrsrowData.identity_ci_oidc_id_token_attrs[i].id_token_attrs:"") + "";
              if((window.identity_ci_oidc_id_token_attrsediting != true && window.identity_ci_oidc_id_token_attrsediting != "true") || tempId != window.identity_ci_oidc_id_token_attrsrowId) {
                attrs.push(identity_ci_oidc_id_token_attrsrowData.identity_ci_oidc_id_token_attrs[i]);
              }
            }
            var newId = ((identity_ci_oidc_id_token_attrs_id_token_attrs)?identity_ci_oidc_id_token_attrs_id_token_attrs:"") + "";
            attrs.push({
              id: newId,
              id_token_attrs: identity_ci_oidc_id_token_attrs_id_token_attrs,
            });
          } else {
            // Must be a delete
            for(var i = 0; i < identity_ci_oidc_id_token_attrsrowData.identity_ci_oidc_id_token_attrs.length; i++) {
              if(identity_ci_oidc_id_token_attrsrowData.identity_ci_oidc_id_token_attrs[i].id_token_attrs !== identity_ci_oidc_id_token_attrs_id_token_attrs ) {
                attrs.push(identity_ci_oidc_id_token_attrsrowData.identity_ci_oidc_id_token_attrs[i]);
              }
            }
          }
        } else {
          attrs = identity_ci_oidc_id_token_attrsrowData.identity_ci_oidc_id_token_attrs;
        }
        identity_ci_oidc_id_token_attrsrowData.identity_ci_oidc_id_token_attrs = attrs;
        const data = {identity_ci_oidc_id_token_attrs: attrs};
        setidentity_ci_oidc_id_token_attrs(data.identity_ci_oidc_id_token_attrs);

        if(identity_ci_oidc_id_token_attrs_id_token_attrs !== undefined && identity_ci_oidc_id_token_attrs_id_token_attrs !== null ) {
            handleChange();

        }

      } catch (e) {
        console.log(e);
      }
      return true;
    });

    const [identity_ci_oidc_scopes, setidentity_ci_oidc_scopes] = React.useState([]);
    const [fetchedidentity_ci_oidc_scopes, setFetchedidentity_ci_oidc_scopes] = React.useState(false);

    React.useEffect(() => {
      identity_ci_oidc_scopesloadGrid();
    }, [fetchedidentity_ci_oidc_scopes]);

    const identity_ci_oidc_scopesloadGrid = React.useCallback(async (identity_ci_oidc_scopes_scopes, add) => {
      try {
        var attrs = [];
        if(identity_ci_oidc_scopes_scopes) {
          if(add) {
            for(var i = 0; i < identity_ci_oidc_scopesrowData.identity_ci_oidc_scopes.length; i++) {
              var tempId = ((identity_ci_oidc_scopesrowData.identity_ci_oidc_scopes[i].scopes)?identity_ci_oidc_scopesrowData.identity_ci_oidc_scopes[i].scopes:"") + "";
              if((window.identity_ci_oidc_scopesediting != true && window.identity_ci_oidc_scopesediting != "true") || tempId != window.identity_ci_oidc_scopesrowId) {
                attrs.push(identity_ci_oidc_scopesrowData.identity_ci_oidc_scopes[i]);
              }
            }
            var newId = ((identity_ci_oidc_scopes_scopes)?identity_ci_oidc_scopes_scopes:"") + "";
            attrs.push({
              id: newId,
              scopes: identity_ci_oidc_scopes_scopes,
            });
          } else {
            // Must be a delete
            for(var i = 0; i < identity_ci_oidc_scopesrowData.identity_ci_oidc_scopes.length; i++) {
              if(identity_ci_oidc_scopesrowData.identity_ci_oidc_scopes[i].scopes !== identity_ci_oidc_scopes_scopes ) {
                attrs.push(identity_ci_oidc_scopesrowData.identity_ci_oidc_scopes[i]);
              }
            }
          }
        } else {
          attrs = identity_ci_oidc_scopesrowData.identity_ci_oidc_scopes;
        }
        identity_ci_oidc_scopesrowData.identity_ci_oidc_scopes = attrs;
        const data = {identity_ci_oidc_scopes: attrs};
        setidentity_ci_oidc_scopes(data.identity_ci_oidc_scopes);

        if(identity_ci_oidc_scopes_scopes !== undefined && identity_ci_oidc_scopes_scopes !== null ) {
            handleChange();

        }

      } catch (e) {
        console.log(e);
      }
      return true;
    });

    const [identity_eai_triggers, setidentity_eai_triggers] = React.useState([]);
    const [fetchedidentity_eai_triggers, setFetchedidentity_eai_triggers] = React.useState(false);

    React.useEffect(() => {
      identity_eai_triggersloadGrid();
    }, [fetchedidentity_eai_triggers]);

    const identity_eai_triggersloadGrid = React.useCallback(async (identity_eai_triggers_triggers, add) => {
      try {
        var attrs = [];
        if(identity_eai_triggers_triggers) {
          if(add) {
            for(var i = 0; i < identity_eai_triggersrowData.identity_eai_triggers.length; i++) {
              var tempId = ((identity_eai_triggersrowData.identity_eai_triggers[i].triggers)?identity_eai_triggersrowData.identity_eai_triggers[i].triggers:"") + "";
              if((window.identity_eai_triggersediting != true && window.identity_eai_triggersediting != "true") || tempId != window.identity_eai_triggersrowId) {
                attrs.push(identity_eai_triggersrowData.identity_eai_triggers[i]);
              }
            }
            var newId = ((identity_eai_triggers_triggers)?identity_eai_triggers_triggers:"") + "";
            attrs.push({
              id: newId,
              triggers: identity_eai_triggers_triggers,
            });
          } else {
            // Must be a delete
            for(var i = 0; i < identity_eai_triggersrowData.identity_eai_triggers.length; i++) {
              if(identity_eai_triggersrowData.identity_eai_triggers[i].triggers !== identity_eai_triggers_triggers ) {
                attrs.push(identity_eai_triggersrowData.identity_eai_triggers[i]);
              }
            }
          }
        } else {
          attrs = identity_eai_triggersrowData.identity_eai_triggers;
        }
        identity_eai_triggersrowData.identity_eai_triggers = attrs;
        const data = {identity_eai_triggers: attrs};
        setidentity_eai_triggers(data.identity_eai_triggers);

        if(identity_eai_triggers_triggers !== undefined && identity_eai_triggers_triggers !== null ) {
            handleChange();

        }

      } catch (e) {
        console.log(e);
      }
      return true;
    });

    const [identity_oauth, setidentity_oauth] = React.useState([]);
    const [fetchedidentity_oauth, setFetchedidentity_oauth] = React.useState(false);

    React.useEffect(() => {
      identity_oauthloadGrid();
    }, [fetchedidentity_oauth]);

    const identity_oauthloadGrid = React.useCallback(async (identity_oauth_auth_method, identity_oauth_client_id, identity_oauth_client_id_hdr, identity_oauth_client_secret, identity_oauth_introspection_endpoint, identity_oauth_mapped_identity, identity_oauth_multi_valued_scope, identity_oauth_name, identity_oauth_proxy, identity_oauth_restricted, identity_oauth_token_type_hint, identity_oauth_ssl_certificate,identity_oauth_headers,identity_oauth_attributes,add) => {
      try {
        var attrs = [];
        if(identity_oauth_name) {
          if(add) {
            for(var i = 0; i < identity_oauthrowData.identity_oauth.length; i++) {
              var tempId = ((identity_oauthrowData.identity_oauth[i].name)?identity_oauthrowData.identity_oauth[i].name:"") + "";
              if((window.identity_oauthediting != true && window.identity_oauthediting != "true") || tempId != window.identity_oauthrowId) {
                attrs.push(identity_oauthrowData.identity_oauth[i]);
              }
            }
            var newId = ((identity_oauth_name)?identity_oauth_name:"") + "";
            attrs.push({
              id: newId,
              attributes: identity_oauth_attributes,
auth_method: identity_oauth_auth_method,
client_id: identity_oauth_client_id,
client_id_hdr: identity_oauth_client_id_hdr,
client_secret: identity_oauth_client_secret,
headers: identity_oauth_headers,
introspection_endpoint: identity_oauth_introspection_endpoint,
mapped_identity: identity_oauth_mapped_identity,
multi_valued_scope: identity_oauth_multi_valued_scope,
name: identity_oauth_name,
proxy: identity_oauth_proxy,
restricted: identity_oauth_restricted,
    ssl: {
certificate: identity_oauth_ssl_certificate,
    },
token_type_hint: identity_oauth_token_type_hint,
            });
          } else {
            // Must be a delete
            for(var i = 0; i < identity_oauthrowData.identity_oauth.length; i++) {
              if(identity_oauthrowData.identity_oauth[i].name !== identity_oauth_name ) {
                attrs.push(identity_oauthrowData.identity_oauth[i]);
              }
            }
          }
        } else {
          attrs = identity_oauthrowData.identity_oauth;
        }
        identity_oauthrowData.identity_oauth = attrs;
        const data = {identity_oauth: attrs};
        setidentity_oauth(data.identity_oauth);

        if(identity_oauth_name !== undefined && identity_oauth_name !== null ) {
            handleChange();

        }

      } catch (e) {
        console.log(e);
      }
      return true;
    });

    const [identity_oauth_attributes, setidentity_oauth_attributes] = React.useState([]);
    const [fetchedidentity_oauth_attributes, setFetchedidentity_oauth_attributes] = React.useState(false);

    React.useEffect(() => {
      identity_oauth_attributesloadGrid();
    }, [fetchedidentity_oauth_attributes]);

    const identity_oauth_attributesloadGrid = React.useCallback(async (identity_oauth_attributes_attributes, add) => {
      try {
        var attrs = [];
        if(identity_oauth_attributes_attributes) {
          if(add) {
            for(var i = 0; i < identity_oauth_attributesrowData.identity_oauth_attributes.length; i++) {
              var tempId = ((identity_oauth_attributesrowData.identity_oauth_attributes[i].attributes)?identity_oauth_attributesrowData.identity_oauth_attributes[i].attributes:"") + "";
              if((window.identity_oauth_attributesediting != true && window.identity_oauth_attributesediting != "true") || tempId != window.identity_oauth_attributesrowId) {
                attrs.push(identity_oauth_attributesrowData.identity_oauth_attributes[i]);
              }
            }
            var newId = ((identity_oauth_attributes_attributes)?identity_oauth_attributes_attributes:"") + "";
            attrs.push({
              id: newId,
              attributes: identity_oauth_attributes_attributes,
            });
          } else {
            // Must be a delete
            for(var i = 0; i < identity_oauth_attributesrowData.identity_oauth_attributes.length; i++) {
              if(identity_oauth_attributesrowData.identity_oauth_attributes[i].attributes !== identity_oauth_attributes_attributes ) {
                attrs.push(identity_oauth_attributesrowData.identity_oauth_attributes[i]);
              }
            }
          }
        } else {
          attrs = identity_oauth_attributesrowData.identity_oauth_attributes;
        }
        identity_oauth_attributesrowData.identity_oauth_attributes = attrs;
        const data = {identity_oauth_attributes: attrs};
        setidentity_oauth_attributes(data.identity_oauth_attributes);

        if(identity_oauth_attributes_attributes !== undefined && identity_oauth_attributes_attributes !== null ) {
            handleChange();

        }

      } catch (e) {
        console.log(e);
      }
      return true;
    });

    const [identity_oauth_headers, setidentity_oauth_headers] = React.useState([]);
    const [fetchedidentity_oauth_headers, setFetchedidentity_oauth_headers] = React.useState(false);

    React.useEffect(() => {
      identity_oauth_headersloadGrid();
    }, [fetchedidentity_oauth_headers]);

    const identity_oauth_headersloadGrid = React.useCallback(async (identity_oauth_headers_name, identity_oauth_headers_source, identity_oauth_headers_value, add) => {
      try {
        var attrs = [];
        if(identity_oauth_headers_value || identity_oauth_headers_source || identity_oauth_headers_name) {
          if(add) {
            for(var i = 0; i < identity_oauth_headersrowData.identity_oauth_headers.length; i++) {
              var tempId = ((identity_oauth_headersrowData.identity_oauth_headers[i].value)?identity_oauth_headersrowData.identity_oauth_headers[i].value:"") + ((identity_oauth_headersrowData.identity_oauth_headers[i].source)?identity_oauth_headersrowData.identity_oauth_headers[i].source:"") + ((identity_oauth_headersrowData.identity_oauth_headers[i].name)?identity_oauth_headersrowData.identity_oauth_headers[i].name:"") + "";
              if((window.identity_oauth_headersediting != true && window.identity_oauth_headersediting != "true") || tempId != window.identity_oauth_headersrowId) {
                attrs.push(identity_oauth_headersrowData.identity_oauth_headers[i]);
              }
            }
            var newId = ((identity_oauth_headers_value)?identity_oauth_headers_value:"") + ((identity_oauth_headers_source)?identity_oauth_headers_source:"") + ((identity_oauth_headers_name)?identity_oauth_headers_name:"") + "";
            attrs.push({
              id: newId,
              name: identity_oauth_headers_name,
source: identity_oauth_headers_source,
value: identity_oauth_headers_value,
            });
          } else {
            // Must be a delete
            for(var i = 0; i < identity_oauth_headersrowData.identity_oauth_headers.length; i++) {
              if(identity_oauth_headersrowData.identity_oauth_headers[i].value !== identity_oauth_headers_value  && identity_oauth_headersrowData.identity_oauth_headers[i].source !== identity_oauth_headers_source  && identity_oauth_headersrowData.identity_oauth_headers[i].name !== identity_oauth_headers_name ) {
                attrs.push(identity_oauth_headersrowData.identity_oauth_headers[i]);
              }
            }
          }
        } else {
          attrs = identity_oauth_headersrowData.identity_oauth_headers;
        }
        identity_oauth_headersrowData.identity_oauth_headers = attrs;
        const data = {identity_oauth_headers: attrs};
        setidentity_oauth_headers(data.identity_oauth_headers);

        if(identity_oauth_headers_value !== undefined && identity_oauth_headers_value !== null  && identity_oauth_headers_source !== undefined && identity_oauth_headers_source !== null  && identity_oauth_headers_name !== undefined && identity_oauth_headers_name !== null ) {
            handleChange();

        }

      } catch (e) {
        console.log(e);
      }
      return true;
    });

    const [identity_oauth_ssl_certificate, setidentity_oauth_ssl_certificate] = React.useState([]);
    const [fetchedidentity_oauth_ssl_certificate, setFetchedidentity_oauth_ssl_certificate] = React.useState(false);

    React.useEffect(() => {
      identity_oauth_ssl_certificateloadGrid();
    }, [fetchedidentity_oauth_ssl_certificate]);

    const identity_oauth_ssl_certificateloadGrid = React.useCallback(async (identity_oauth_ssl_certificate_certificate, add) => {
      try {
        var attrs = [];
        if(identity_oauth_ssl_certificate_certificate) {
          if(add) {
            for(var i = 0; i < identity_oauth_ssl_certificaterowData.identity_oauth_ssl_certificate.length; i++) {
              var tempId = ((identity_oauth_ssl_certificaterowData.identity_oauth_ssl_certificate[i].certificate)?identity_oauth_ssl_certificaterowData.identity_oauth_ssl_certificate[i].certificate:"") + "";
              if((window.identity_oauth_ssl_certificateediting != true && window.identity_oauth_ssl_certificateediting != "true") || tempId != window.identity_oauth_ssl_certificaterowId) {
                attrs.push(identity_oauth_ssl_certificaterowData.identity_oauth_ssl_certificate[i]);
              }
            }
            var newId = ((identity_oauth_ssl_certificate_certificate)?identity_oauth_ssl_certificate_certificate:"") + "";
            attrs.push({
              id: newId,
              certificate: identity_oauth_ssl_certificate_certificate,
            });
          } else {
            // Must be a delete
            for(var i = 0; i < identity_oauth_ssl_certificaterowData.identity_oauth_ssl_certificate.length; i++) {
              if(identity_oauth_ssl_certificaterowData.identity_oauth_ssl_certificate[i].certificate !== identity_oauth_ssl_certificate_certificate ) {
                attrs.push(identity_oauth_ssl_certificaterowData.identity_oauth_ssl_certificate[i]);
              }
            }
          }
        } else {
          attrs = identity_oauth_ssl_certificaterowData.identity_oauth_ssl_certificate;
        }
        identity_oauth_ssl_certificaterowData.identity_oauth_ssl_certificate = attrs;
        const data = {identity_oauth_ssl_certificate: attrs};
        setidentity_oauth_ssl_certificate(data.identity_oauth_ssl_certificate);

        if(identity_oauth_ssl_certificate_certificate !== undefined && identity_oauth_ssl_certificate_certificate !== null ) {
            handleChange();

        }

      } catch (e) {
        console.log(e);
      }
      return true;
    });

    const [identity_oidc, setidentity_oidc] = React.useState([]);
    const [fetchedidentity_oidc, setFetchedidentity_oidc] = React.useState(false);

    React.useEffect(() => {
      identity_oidcloadGrid();
    }, [fetchedidentity_oidc]);

    const identity_oidcloadGrid = React.useCallback(async (identity_oidc_client_id, identity_oidc_client_secret, identity_oidc_discovery_endpoint, identity_oidc_mapped_identity, identity_oidc_name, identity_oidc_pkce, identity_oidc_proxy, identity_oidc_redirect_uri_host, identity_oidc_response_mode, identity_oidc_response_type, identity_oidc_id_token_attrs,identity_oidc_allowed_query_args,identity_oidc_bearer_token_attrs,identity_oidc_scopes,identity_oidc_ssl_certificate,add) => {
      try {
        var attrs = [];
        if(identity_oidc_discovery_endpoint) {
          if(add) {
            for(var i = 0; i < identity_oidcrowData.identity_oidc.length; i++) {
              var tempId = ((identity_oidcrowData.identity_oidc[i].discovery_endpoint)?identity_oidcrowData.identity_oidc[i].discovery_endpoint:"") + "";
              if((window.identity_oidcediting != true && window.identity_oidcediting != "true") || tempId != window.identity_oidcrowId) {
                attrs.push(identity_oidcrowData.identity_oidc[i]);
              }
            }
            var newId = ((identity_oidc_discovery_endpoint)?identity_oidc_discovery_endpoint:"") + "";
            attrs.push({
              id: newId,
              allowed_query_args: identity_oidc_allowed_query_args,
bearer_token_attrs: identity_oidc_bearer_token_attrs,
client_id: identity_oidc_client_id,
client_secret: identity_oidc_client_secret,
discovery_endpoint: identity_oidc_discovery_endpoint,
id_token_attrs: identity_oidc_id_token_attrs,
mapped_identity: identity_oidc_mapped_identity,
name: identity_oidc_name,
pkce: identity_oidc_pkce,
proxy: identity_oidc_proxy,
redirect_uri_host: identity_oidc_redirect_uri_host,
response_mode: identity_oidc_response_mode,
response_type: identity_oidc_response_type,
scopes: identity_oidc_scopes,
    ssl: {
certificate: identity_oidc_ssl_certificate,
    },
            });
          } else {
            // Must be a delete
            for(var i = 0; i < identity_oidcrowData.identity_oidc.length; i++) {
              if(identity_oidcrowData.identity_oidc[i].discovery_endpoint !== identity_oidc_discovery_endpoint ) {
                attrs.push(identity_oidcrowData.identity_oidc[i]);
              }
            }
          }
        } else {
          attrs = identity_oidcrowData.identity_oidc;
        }
        identity_oidcrowData.identity_oidc = attrs;
        const data = {identity_oidc: attrs};
        setidentity_oidc(data.identity_oidc);

        if(identity_oidc_discovery_endpoint !== undefined && identity_oidc_discovery_endpoint !== null ) {
            handleChange();

        }

      } catch (e) {
        console.log(e);
      }
      return true;
    });

    const [identity_oidc_allowed_query_args, setidentity_oidc_allowed_query_args] = React.useState([]);
    const [fetchedidentity_oidc_allowed_query_args, setFetchedidentity_oidc_allowed_query_args] = React.useState(false);

    React.useEffect(() => {
      identity_oidc_allowed_query_argsloadGrid();
    }, [fetchedidentity_oidc_allowed_query_args]);

    const identity_oidc_allowed_query_argsloadGrid = React.useCallback(async (identity_oidc_allowed_query_args_allowed_query_args, add) => {
      try {
        var attrs = [];
        if(identity_oidc_allowed_query_args_allowed_query_args) {
          if(add) {
            for(var i = 0; i < identity_oidc_allowed_query_argsrowData.identity_oidc_allowed_query_args.length; i++) {
              var tempId = ((identity_oidc_allowed_query_argsrowData.identity_oidc_allowed_query_args[i].allowed_query_args)?identity_oidc_allowed_query_argsrowData.identity_oidc_allowed_query_args[i].allowed_query_args:"") + "";
              if((window.identity_oidc_allowed_query_argsediting != true && window.identity_oidc_allowed_query_argsediting != "true") || tempId != window.identity_oidc_allowed_query_argsrowId) {
                attrs.push(identity_oidc_allowed_query_argsrowData.identity_oidc_allowed_query_args[i]);
              }
            }
            var newId = ((identity_oidc_allowed_query_args_allowed_query_args)?identity_oidc_allowed_query_args_allowed_query_args:"") + "";
            attrs.push({
              id: newId,
              allowed_query_args: identity_oidc_allowed_query_args_allowed_query_args,
            });
          } else {
            // Must be a delete
            for(var i = 0; i < identity_oidc_allowed_query_argsrowData.identity_oidc_allowed_query_args.length; i++) {
              if(identity_oidc_allowed_query_argsrowData.identity_oidc_allowed_query_args[i].allowed_query_args !== identity_oidc_allowed_query_args_allowed_query_args ) {
                attrs.push(identity_oidc_allowed_query_argsrowData.identity_oidc_allowed_query_args[i]);
              }
            }
          }
        } else {
          attrs = identity_oidc_allowed_query_argsrowData.identity_oidc_allowed_query_args;
        }
        identity_oidc_allowed_query_argsrowData.identity_oidc_allowed_query_args = attrs;
        const data = {identity_oidc_allowed_query_args: attrs};
        setidentity_oidc_allowed_query_args(data.identity_oidc_allowed_query_args);

        if(identity_oidc_allowed_query_args_allowed_query_args !== undefined && identity_oidc_allowed_query_args_allowed_query_args !== null ) {
            handleChange();

        }

      } catch (e) {
        console.log(e);
      }
      return true;
    });

    const [identity_oidc_bearer_token_attrs, setidentity_oidc_bearer_token_attrs] = React.useState([]);
    const [fetchedidentity_oidc_bearer_token_attrs, setFetchedidentity_oidc_bearer_token_attrs] = React.useState(false);

    React.useEffect(() => {
      identity_oidc_bearer_token_attrsloadGrid();
    }, [fetchedidentity_oidc_bearer_token_attrs]);

    const identity_oidc_bearer_token_attrsloadGrid = React.useCallback(async (identity_oidc_bearer_token_attrs_bearer_token_attrs, add) => {
      try {
        var attrs = [];
        if(identity_oidc_bearer_token_attrs_bearer_token_attrs) {
          if(add) {
            for(var i = 0; i < identity_oidc_bearer_token_attrsrowData.identity_oidc_bearer_token_attrs.length; i++) {
              var tempId = ((identity_oidc_bearer_token_attrsrowData.identity_oidc_bearer_token_attrs[i].bearer_token_attrs)?identity_oidc_bearer_token_attrsrowData.identity_oidc_bearer_token_attrs[i].bearer_token_attrs:"") + "";
              if((window.identity_oidc_bearer_token_attrsediting != true && window.identity_oidc_bearer_token_attrsediting != "true") || tempId != window.identity_oidc_bearer_token_attrsrowId) {
                attrs.push(identity_oidc_bearer_token_attrsrowData.identity_oidc_bearer_token_attrs[i]);
              }
            }
            var newId = ((identity_oidc_bearer_token_attrs_bearer_token_attrs)?identity_oidc_bearer_token_attrs_bearer_token_attrs:"") + "";
            attrs.push({
              id: newId,
              bearer_token_attrs: identity_oidc_bearer_token_attrs_bearer_token_attrs,
            });
          } else {
            // Must be a delete
            for(var i = 0; i < identity_oidc_bearer_token_attrsrowData.identity_oidc_bearer_token_attrs.length; i++) {
              if(identity_oidc_bearer_token_attrsrowData.identity_oidc_bearer_token_attrs[i].bearer_token_attrs !== identity_oidc_bearer_token_attrs_bearer_token_attrs ) {
                attrs.push(identity_oidc_bearer_token_attrsrowData.identity_oidc_bearer_token_attrs[i]);
              }
            }
          }
        } else {
          attrs = identity_oidc_bearer_token_attrsrowData.identity_oidc_bearer_token_attrs;
        }
        identity_oidc_bearer_token_attrsrowData.identity_oidc_bearer_token_attrs = attrs;
        const data = {identity_oidc_bearer_token_attrs: attrs};
        setidentity_oidc_bearer_token_attrs(data.identity_oidc_bearer_token_attrs);

        if(identity_oidc_bearer_token_attrs_bearer_token_attrs !== undefined && identity_oidc_bearer_token_attrs_bearer_token_attrs !== null ) {
            handleChange();

        }

      } catch (e) {
        console.log(e);
      }
      return true;
    });

    const [identity_oidc_id_token_attrs, setidentity_oidc_id_token_attrs] = React.useState([]);
    const [fetchedidentity_oidc_id_token_attrs, setFetchedidentity_oidc_id_token_attrs] = React.useState(false);

    React.useEffect(() => {
      identity_oidc_id_token_attrsloadGrid();
    }, [fetchedidentity_oidc_id_token_attrs]);

    const identity_oidc_id_token_attrsloadGrid = React.useCallback(async (identity_oidc_id_token_attrs_id_token_attrs, add) => {
      try {
        var attrs = [];
        if(identity_oidc_id_token_attrs_id_token_attrs) {
          if(add) {
            for(var i = 0; i < identity_oidc_id_token_attrsrowData.identity_oidc_id_token_attrs.length; i++) {
              var tempId = ((identity_oidc_id_token_attrsrowData.identity_oidc_id_token_attrs[i].id_token_attrs)?identity_oidc_id_token_attrsrowData.identity_oidc_id_token_attrs[i].id_token_attrs:"") + "";
              if((window.identity_oidc_id_token_attrsediting != true && window.identity_oidc_id_token_attrsediting != "true") || tempId != window.identity_oidc_id_token_attrsrowId) {
                attrs.push(identity_oidc_id_token_attrsrowData.identity_oidc_id_token_attrs[i]);
              }
            }
            var newId = ((identity_oidc_id_token_attrs_id_token_attrs)?identity_oidc_id_token_attrs_id_token_attrs:"") + "";
            attrs.push({
              id: newId,
              id_token_attrs: identity_oidc_id_token_attrs_id_token_attrs,
            });
          } else {
            // Must be a delete
            for(var i = 0; i < identity_oidc_id_token_attrsrowData.identity_oidc_id_token_attrs.length; i++) {
              if(identity_oidc_id_token_attrsrowData.identity_oidc_id_token_attrs[i].id_token_attrs !== identity_oidc_id_token_attrs_id_token_attrs ) {
                attrs.push(identity_oidc_id_token_attrsrowData.identity_oidc_id_token_attrs[i]);
              }
            }
          }
        } else {
          attrs = identity_oidc_id_token_attrsrowData.identity_oidc_id_token_attrs;
        }
        identity_oidc_id_token_attrsrowData.identity_oidc_id_token_attrs = attrs;
        const data = {identity_oidc_id_token_attrs: attrs};
        setidentity_oidc_id_token_attrs(data.identity_oidc_id_token_attrs);

        if(identity_oidc_id_token_attrs_id_token_attrs !== undefined && identity_oidc_id_token_attrs_id_token_attrs !== null ) {
            handleChange();

        }

      } catch (e) {
        console.log(e);
      }
      return true;
    });

    const [identity_oidc_scopes, setidentity_oidc_scopes] = React.useState([]);
    const [fetchedidentity_oidc_scopes, setFetchedidentity_oidc_scopes] = React.useState(false);

    React.useEffect(() => {
      identity_oidc_scopesloadGrid();
    }, [fetchedidentity_oidc_scopes]);

    const identity_oidc_scopesloadGrid = React.useCallback(async (identity_oidc_scopes_scopes, add) => {
      try {
        var attrs = [];
        if(identity_oidc_scopes_scopes) {
          if(add) {
            for(var i = 0; i < identity_oidc_scopesrowData.identity_oidc_scopes.length; i++) {
              var tempId = ((identity_oidc_scopesrowData.identity_oidc_scopes[i].scopes)?identity_oidc_scopesrowData.identity_oidc_scopes[i].scopes:"") + "";
              if((window.identity_oidc_scopesediting != true && window.identity_oidc_scopesediting != "true") || tempId != window.identity_oidc_scopesrowId) {
                attrs.push(identity_oidc_scopesrowData.identity_oidc_scopes[i]);
              }
            }
            var newId = ((identity_oidc_scopes_scopes)?identity_oidc_scopes_scopes:"") + "";
            attrs.push({
              id: newId,
              scopes: identity_oidc_scopes_scopes,
            });
          } else {
            // Must be a delete
            for(var i = 0; i < identity_oidc_scopesrowData.identity_oidc_scopes.length; i++) {
              if(identity_oidc_scopesrowData.identity_oidc_scopes[i].scopes !== identity_oidc_scopes_scopes ) {
                attrs.push(identity_oidc_scopesrowData.identity_oidc_scopes[i]);
              }
            }
          }
        } else {
          attrs = identity_oidc_scopesrowData.identity_oidc_scopes;
        }
        identity_oidc_scopesrowData.identity_oidc_scopes = attrs;
        const data = {identity_oidc_scopes: attrs};
        setidentity_oidc_scopes(data.identity_oidc_scopes);

        if(identity_oidc_scopes_scopes !== undefined && identity_oidc_scopes_scopes !== null ) {
            handleChange();

        }

      } catch (e) {
        console.log(e);
      }
      return true;
    });

    const [identity_oidc_ssl_certificate, setidentity_oidc_ssl_certificate] = React.useState([]);
    const [fetchedidentity_oidc_ssl_certificate, setFetchedidentity_oidc_ssl_certificate] = React.useState(false);

    React.useEffect(() => {
      identity_oidc_ssl_certificateloadGrid();
    }, [fetchedidentity_oidc_ssl_certificate]);

    const identity_oidc_ssl_certificateloadGrid = React.useCallback(async (identity_oidc_ssl_certificate_certificate, add) => {
      try {
        var attrs = [];
        if(identity_oidc_ssl_certificate_certificate) {
          if(add) {
            for(var i = 0; i < identity_oidc_ssl_certificaterowData.identity_oidc_ssl_certificate.length; i++) {
              var tempId = ((identity_oidc_ssl_certificaterowData.identity_oidc_ssl_certificate[i].certificate)?identity_oidc_ssl_certificaterowData.identity_oidc_ssl_certificate[i].certificate:"") + "";
              if((window.identity_oidc_ssl_certificateediting != true && window.identity_oidc_ssl_certificateediting != "true") || tempId != window.identity_oidc_ssl_certificaterowId) {
                attrs.push(identity_oidc_ssl_certificaterowData.identity_oidc_ssl_certificate[i]);
              }
            }
            var newId = ((identity_oidc_ssl_certificate_certificate)?identity_oidc_ssl_certificate_certificate:"") + "";
            attrs.push({
              id: newId,
              certificate: identity_oidc_ssl_certificate_certificate,
            });
          } else {
            // Must be a delete
            for(var i = 0; i < identity_oidc_ssl_certificaterowData.identity_oidc_ssl_certificate.length; i++) {
              if(identity_oidc_ssl_certificaterowData.identity_oidc_ssl_certificate[i].certificate !== identity_oidc_ssl_certificate_certificate ) {
                attrs.push(identity_oidc_ssl_certificaterowData.identity_oidc_ssl_certificate[i]);
              }
            }
          }
        } else {
          attrs = identity_oidc_ssl_certificaterowData.identity_oidc_ssl_certificate;
        }
        identity_oidc_ssl_certificaterowData.identity_oidc_ssl_certificate = attrs;
        const data = {identity_oidc_ssl_certificate: attrs};
        setidentity_oidc_ssl_certificate(data.identity_oidc_ssl_certificate);

        if(identity_oidc_ssl_certificate_certificate !== undefined && identity_oidc_ssl_certificate_certificate !== null ) {
            handleChange();

        }

      } catch (e) {
        console.log(e);
      }
      return true;
    });



    const [identity_auth_challenge_redirect_parameters_name, setidentity_auth_challenge_redirect_parameters_name] = useState(''),
    updateidentity_auth_challenge_redirect_parameters_name = useCallback((evt) => setidentity_auth_challenge_redirect_parameters_name(evt.target.value), []);

    const [identity_auth_challenge_redirect_parameters_source, setidentity_auth_challenge_redirect_parameters_source] = useState(''),
    updateidentity_auth_challenge_redirect_parameters_source = useCallback((evt) => {
      setidentity_auth_challenge_redirect_parameters_source(evt.target.value);
      var valueWdgt = document.getElementById("identity_auth_challenge_redirect_parameters_value_id" + idPrefix);
      var valueVal = (valueWdgt)?valueWdgt.value:"";
      var tempId = valueVal + evt.target.value;
      validateField(identity_auth_challenge_redirect_parametersrowData.identity_auth_challenge_redirect_parameters, setidentity_auth_challenge_redirect_parameters_value_valid, setidentity_auth_challenge_redirect_parameters_value_invalid_text, "Identity Auth Challenge Redirect Parameters", "unique values", tempId);
      validateField(identity_auth_challenge_redirect_parametersrowData.identity_auth_challenge_redirect_parameters, setidentity_auth_challenge_redirect_parameters_source_valid, setidentity_auth_challenge_redirect_parameters_source_invalid_text, "Identity Auth Challenge Redirect Parameters", "unique values", tempId);
    }, []);

    const [identity_auth_challenge_redirect_parameters_source_valid, setidentity_auth_challenge_redirect_parameters_source_valid] = useState(true);
    const [identity_auth_challenge_redirect_parameters_source_invalid_text, setidentity_auth_challenge_redirect_parameters_source_invalid_text] = useState("");


    const [identity_auth_challenge_redirect_parameters_value, setidentity_auth_challenge_redirect_parameters_value] = useState(''),
    updateidentity_auth_challenge_redirect_parameters_value = useCallback((evt) => {
      setidentity_auth_challenge_redirect_parameters_value(evt.target.value);
      var sourceWdgt = document.getElementById("identity_auth_challenge_redirect_parameters_source_id" + idPrefix);
      var sourceVal = (sourceWdgt)?sourceWdgt.value:"";
      var tempId = evt.target.value + sourceVal;
      validateField(identity_auth_challenge_redirect_parametersrowData.identity_auth_challenge_redirect_parameters, setidentity_auth_challenge_redirect_parameters_source_valid, setidentity_auth_challenge_redirect_parameters_source_invalid_text, "Identity Auth Challenge Redirect Parameters", "unique values", tempId);
      validateField(identity_auth_challenge_redirect_parametersrowData.identity_auth_challenge_redirect_parameters, setidentity_auth_challenge_redirect_parameters_value_valid, setidentity_auth_challenge_redirect_parameters_value_invalid_text, "Identity Auth Challenge Redirect Parameters", "unique values", tempId);
    }, []);

    const [identity_auth_challenge_redirect_parameters_value_valid, setidentity_auth_challenge_redirect_parameters_value_valid] = useState(true);
    const [identity_auth_challenge_redirect_parameters_value_invalid_text, setidentity_auth_challenge_redirect_parameters_value_invalid_text] = useState("");


    const [identity_auth_challenge_redirect_url, setidentity_auth_challenge_redirect_url] = useState(''),
    updateidentity_auth_challenge_redirect_url = useCallback((evt) => setidentity_auth_challenge_redirect_url(evt.target.value), []);

    const [identity_auth_complete_redirect_parameters_name, setidentity_auth_complete_redirect_parameters_name] = useState(''),
    updateidentity_auth_complete_redirect_parameters_name = useCallback((evt) => setidentity_auth_complete_redirect_parameters_name(evt.target.value), []);

    const [identity_auth_complete_redirect_parameters_source, setidentity_auth_complete_redirect_parameters_source] = useState(''),
    updateidentity_auth_complete_redirect_parameters_source = useCallback((evt) => {
      setidentity_auth_complete_redirect_parameters_source(evt.target.value);
      var valueWdgt = document.getElementById("identity_auth_complete_redirect_parameters_value_id" + idPrefix);
      var valueVal = (valueWdgt)?valueWdgt.value:"";
      var tempId = evt.target.value + valueVal;
      validateField(identity_auth_complete_redirect_parametersrowData.identity_auth_complete_redirect_parameters, setidentity_auth_complete_redirect_parameters_value_valid, setidentity_auth_complete_redirect_parameters_value_invalid_text, "Identity Auth Complete Redirect Parameters", "unique values", tempId);
      validateField(identity_auth_complete_redirect_parametersrowData.identity_auth_complete_redirect_parameters, setidentity_auth_complete_redirect_parameters_source_valid, setidentity_auth_complete_redirect_parameters_source_invalid_text, "Identity Auth Complete Redirect Parameters", "unique values", tempId);
    }, []);

    const [identity_auth_complete_redirect_parameters_source_valid, setidentity_auth_complete_redirect_parameters_source_valid] = useState(true);
    const [identity_auth_complete_redirect_parameters_source_invalid_text, setidentity_auth_complete_redirect_parameters_source_invalid_text] = useState("");


    const [identity_auth_complete_redirect_parameters_value, setidentity_auth_complete_redirect_parameters_value] = useState(''),
    updateidentity_auth_complete_redirect_parameters_value = useCallback((evt) => {
      setidentity_auth_complete_redirect_parameters_value(evt.target.value);
      var sourceWdgt = document.getElementById("identity_auth_complete_redirect_parameters_source_id" + idPrefix);
      var sourceVal = (sourceWdgt)?sourceWdgt.value:"";
      var tempId = sourceVal + evt.target.value;
      validateField(identity_auth_complete_redirect_parametersrowData.identity_auth_complete_redirect_parameters, setidentity_auth_complete_redirect_parameters_source_valid, setidentity_auth_complete_redirect_parameters_source_invalid_text, "Identity Auth Complete Redirect Parameters", "unique values", tempId);
      validateField(identity_auth_complete_redirect_parametersrowData.identity_auth_complete_redirect_parameters, setidentity_auth_complete_redirect_parameters_value_valid, setidentity_auth_complete_redirect_parameters_value_invalid_text, "Identity Auth Complete Redirect Parameters", "unique values", tempId);
    }, []);

    const [identity_auth_complete_redirect_parameters_value_valid, setidentity_auth_complete_redirect_parameters_value_valid] = useState(true);
    const [identity_auth_complete_redirect_parameters_value_invalid_text, setidentity_auth_complete_redirect_parameters_value_invalid_text] = useState("");


    const [identity_auth_complete_redirect_url, setidentity_auth_complete_redirect_url] = useState(''),
    updateidentity_auth_complete_redirect_url = useCallback((evt) => setidentity_auth_complete_redirect_url(evt.target.value), []);

    const [identity_ci_oidc_allowed_query_args_allowed_query_args, setidentity_ci_oidc_allowed_query_args_allowed_query_args] = useState(''),
    updateidentity_ci_oidc_allowed_query_args_allowed_query_args = useCallback((evt) => {
      setidentity_ci_oidc_allowed_query_args_allowed_query_args(evt.target.value);
      var tempId = evt.target.value;
      validateField(identity_ci_oidc_allowed_query_argsrowData.identity_ci_oidc_allowed_query_args, setidentity_ci_oidc_allowed_query_args_allowed_query_args_valid, setidentity_ci_oidc_allowed_query_args_allowed_query_args_invalid_text, "Identity Ci Oidc Allowed Query Args", "allowed_query_args", tempId);
    }, []);

    const [identity_ci_oidc_allowed_query_args_allowed_query_args_valid, setidentity_ci_oidc_allowed_query_args_allowed_query_args_valid] = useState(true);
    const [identity_ci_oidc_allowed_query_args_allowed_query_args_invalid_text, setidentity_ci_oidc_allowed_query_args_allowed_query_args_invalid_text] = useState("");


    const [identity_ci_oidc_bearer_token_attrs_bearer_token_attrs, setidentity_ci_oidc_bearer_token_attrs_bearer_token_attrs] = useState(''),
    updateidentity_ci_oidc_bearer_token_attrs_bearer_token_attrs = useCallback((evt) => {
      setidentity_ci_oidc_bearer_token_attrs_bearer_token_attrs(evt.target.value);
      var tempId = evt.target.value;
      validateField(identity_ci_oidc_bearer_token_attrsrowData.identity_ci_oidc_bearer_token_attrs, setidentity_ci_oidc_bearer_token_attrs_bearer_token_attrs_valid, setidentity_ci_oidc_bearer_token_attrs_bearer_token_attrs_invalid_text, "Identity Ci Oidc Bearer Token Attrs", "bearer_token_attrs", tempId);
    }, []);

    const [identity_ci_oidc_bearer_token_attrs_bearer_token_attrs_valid, setidentity_ci_oidc_bearer_token_attrs_bearer_token_attrs_valid] = useState(true);
    const [identity_ci_oidc_bearer_token_attrs_bearer_token_attrs_invalid_text, setidentity_ci_oidc_bearer_token_attrs_bearer_token_attrs_invalid_text] = useState("");


    const [identity_ci_oidc_client_id, setidentity_ci_oidc_client_id] = useState(''),
    updateidentity_ci_oidc_client_id = useCallback((evt) => setidentity_ci_oidc_client_id(evt.target.value), []);

    const [identity_ci_oidc_client_secret, setidentity_ci_oidc_client_secret] = useState(''),
    updateidentity_ci_oidc_client_secret = useCallback((evt) => setidentity_ci_oidc_client_secret(evt.target.value), []);

    const [identity_ci_oidc_hostname, setidentity_ci_oidc_hostname] = useState(''),
    updateidentity_ci_oidc_hostname = useCallback((evt) => setidentity_ci_oidc_hostname(evt.target.value), []);

    const [identity_ci_oidc_id_token_attrs_id_token_attrs, setidentity_ci_oidc_id_token_attrs_id_token_attrs] = useState(''),
    updateidentity_ci_oidc_id_token_attrs_id_token_attrs = useCallback((evt) => {
      setidentity_ci_oidc_id_token_attrs_id_token_attrs(evt.target.value);
      var tempId = evt.target.value;
      validateField(identity_ci_oidc_id_token_attrsrowData.identity_ci_oidc_id_token_attrs, setidentity_ci_oidc_id_token_attrs_id_token_attrs_valid, setidentity_ci_oidc_id_token_attrs_id_token_attrs_invalid_text, "Identity Ci Oidc Id Token Attrs", "id_token_attrs", tempId);
    }, []);

    const [identity_ci_oidc_id_token_attrs_id_token_attrs_valid, setidentity_ci_oidc_id_token_attrs_id_token_attrs_valid] = useState(true);
    const [identity_ci_oidc_id_token_attrs_id_token_attrs_invalid_text, setidentity_ci_oidc_id_token_attrs_id_token_attrs_invalid_text] = useState("");


    const [identity_ci_oidc_mapped_identity, setidentity_ci_oidc_mapped_identity] = useState('{sub}'),
    updateidentity_ci_oidc_mapped_identity = useCallback((evt) => setidentity_ci_oidc_mapped_identity(evt.target.value), []);

    const [identity_ci_oidc_proxy, setidentity_ci_oidc_proxy] = useState(''),
    updateidentity_ci_oidc_proxy = useCallback((evt) => setidentity_ci_oidc_proxy(evt.target.value), []);

    const [identity_ci_oidc_redirect_uri_host, setidentity_ci_oidc_redirect_uri_host] = useState(''),
    updateidentity_ci_oidc_redirect_uri_host = useCallback((evt) => setidentity_ci_oidc_redirect_uri_host(evt.target.value), []);

    const [identity_ci_oidc_response_mode, setidentity_ci_oidc_response_mode] = useState(''),
    updateidentity_ci_oidc_response_mode = useCallback((evt) => setidentity_ci_oidc_response_mode(evt.target.value), []);

    const [identity_ci_oidc_response_type, setidentity_ci_oidc_response_type] = useState('code'),
    updateidentity_ci_oidc_response_type = useCallback((evt) => setidentity_ci_oidc_response_type(evt.target.value), []);

    const [identity_ci_oidc_scopes_scopes, setidentity_ci_oidc_scopes_scopes] = useState(''),
    updateidentity_ci_oidc_scopes_scopes = useCallback((evt) => {
      setidentity_ci_oidc_scopes_scopes(evt.target.value);
      var tempId = evt.target.value;
      validateField(identity_ci_oidc_scopesrowData.identity_ci_oidc_scopes, setidentity_ci_oidc_scopes_scopes_valid, setidentity_ci_oidc_scopes_scopes_invalid_text, "Identity Ci Oidc Scopes", "scopes", tempId);
    }, []);

    const [identity_ci_oidc_scopes_scopes_valid, setidentity_ci_oidc_scopes_scopes_valid] = useState(true);
    const [identity_ci_oidc_scopes_scopes_invalid_text, setidentity_ci_oidc_scopes_scopes_invalid_text] = useState("");


    const [identity_eai_triggers_triggers, setidentity_eai_triggers_triggers] = useState(''),
    updateidentity_eai_triggers_triggers = useCallback((evt) => {
      setidentity_eai_triggers_triggers(evt.target.value);
      var tempId = evt.target.value;
      validateField(identity_eai_triggersrowData.identity_eai_triggers, setidentity_eai_triggers_triggers_valid, setidentity_eai_triggers_triggers_invalid_text, "Identity Eai Triggers", "triggers", tempId);
    }, []);

    const [identity_eai_triggers_triggers_valid, setidentity_eai_triggers_triggers_valid] = useState(true);
    const [identity_eai_triggers_triggers_invalid_text, setidentity_eai_triggers_triggers_invalid_text] = useState("");


    const [identity_oauth_auth_method, setidentity_oauth_auth_method] = useState('client_secret_post'),
    updateidentity_oauth_auth_method = useCallback((evt) => setidentity_oauth_auth_method(evt.target.value), []);

    const [identity_oauth_client_id, setidentity_oauth_client_id] = useState(''),
    updateidentity_oauth_client_id = useCallback((evt) => setidentity_oauth_client_id(evt.target.value), []);

    const [identity_oauth_client_id_hdr, setidentity_oauth_client_id_hdr] = useState(''),
    updateidentity_oauth_client_id_hdr = useCallback((evt) => setidentity_oauth_client_id_hdr(evt.target.value), []);

    const [identity_oauth_client_secret, setidentity_oauth_client_secret] = useState(''),
    updateidentity_oauth_client_secret = useCallback((evt) => setidentity_oauth_client_secret(evt.target.value), []);

    const [identity_oauth_introspection_endpoint, setidentity_oauth_introspection_endpoint] = useState(''),
    updateidentity_oauth_introspection_endpoint = useCallback((evt) => setidentity_oauth_introspection_endpoint(evt.target.value), []);

    const [identity_oauth_mapped_identity, setidentity_oauth_mapped_identity] = useState('{sub}'),
    updateidentity_oauth_mapped_identity = useCallback((evt) => setidentity_oauth_mapped_identity(evt.target.value), []);

    const [identity_oauth_multi_valued_scope, setidentity_oauth_multi_valued_scope] = useState(true),
    updateidentity_oauth_multi_valued_scope = useCallback((evt) => setidentity_oauth_multi_valued_scope(evt), []);

    const [identity_oauth_name, setidentity_oauth_name] = useState(''),
    updateidentity_oauth_name = useCallback((evt) => {
      setidentity_oauth_name(evt.target.value);
      var tempId = evt.target.value;
      validateField(identity_oauthrowData.identity_oauth, setidentity_oauth_name_valid, setidentity_oauth_name_invalid_text, "Identity Oauth", "name", tempId);
    }, []);

    const [identity_oauth_name_valid, setidentity_oauth_name_valid] = useState(true);
    const [identity_oauth_name_invalid_text, setidentity_oauth_name_invalid_text] = useState("");


    const [identity_oauth_proxy, setidentity_oauth_proxy] = useState(''),
    updateidentity_oauth_proxy = useCallback((evt) => setidentity_oauth_proxy(evt.target.value), []);

    const [identity_oauth_restricted, setidentity_oauth_restricted] = useState(false),
    updateidentity_oauth_restricted = useCallback((evt) => setidentity_oauth_restricted(evt), []);

    const [identity_oauth_token_type_hint, setidentity_oauth_token_type_hint] = useState('access_token'),
    updateidentity_oauth_token_type_hint = useCallback((evt) => setidentity_oauth_token_type_hint(evt.target.value), []);

    const [identity_oidc_client_id, setidentity_oidc_client_id] = useState(''),
    updateidentity_oidc_client_id = useCallback((evt) => setidentity_oidc_client_id(evt.target.value), []);

    const [identity_oidc_client_secret, setidentity_oidc_client_secret] = useState(''),
    updateidentity_oidc_client_secret = useCallback((evt) => setidentity_oidc_client_secret(evt.target.value), []);

    const [identity_oidc_discovery_endpoint, setidentity_oidc_discovery_endpoint] = useState(''),
    updateidentity_oidc_discovery_endpoint = useCallback((evt) => {
      setidentity_oidc_discovery_endpoint(evt.target.value);
      var tempId = evt.target.value;
      validateField(identity_oidcrowData.identity_oidc, setidentity_oidc_discovery_endpoint_valid, setidentity_oidc_discovery_endpoint_invalid_text, "Identity Oidc", "discovery_endpoint", tempId);
    }, []);

    const [identity_oidc_discovery_endpoint_valid, setidentity_oidc_discovery_endpoint_valid] = useState(true);
    const [identity_oidc_discovery_endpoint_invalid_text, setidentity_oidc_discovery_endpoint_invalid_text] = useState("");


    const [identity_oidc_mapped_identity, setidentity_oidc_mapped_identity] = useState('{sub}'),
    updateidentity_oidc_mapped_identity = useCallback((evt) => setidentity_oidc_mapped_identity(evt.target.value), []);

    const [identity_oidc_name, setidentity_oidc_name] = useState('default'),
    updateidentity_oidc_name = useCallback((evt) => setidentity_oidc_name(evt.target.value), []);

    const [identity_oidc_pkce, setidentity_oidc_pkce] = useState(),
    updateidentity_oidc_pkce = useCallback((evt) => setidentity_oidc_pkce(evt), []);

    const [identity_oidc_proxy, setidentity_oidc_proxy] = useState(''),
    updateidentity_oidc_proxy = useCallback((evt) => setidentity_oidc_proxy(evt.target.value), []);

    const [identity_oidc_redirect_uri_host, setidentity_oidc_redirect_uri_host] = useState(''),
    updateidentity_oidc_redirect_uri_host = useCallback((evt) => setidentity_oidc_redirect_uri_host(evt.target.value), []);

    const [identity_oidc_response_mode, setidentity_oidc_response_mode] = useState(''),
    updateidentity_oidc_response_mode = useCallback((evt) => setidentity_oidc_response_mode(evt.target.value), []);

    const [identity_oidc_response_type, setidentity_oidc_response_type] = useState('code'),
    updateidentity_oidc_response_type = useCallback((evt) => setidentity_oidc_response_type(evt.target.value), []);


  if(window.iagpage != "IdentityPage") {
    delete(window.editing);
    delete(window.rowId);
    window.iagpage = "IdentityPage";
  }

    const [fetcheddata, setFetcheddata] = React.useState(false);
    React.useEffect(() => {
      dataLoad();
    }, [fetcheddata]);
    const dataLoad = () => {
      var yamlText = window.iagyaml;
      var json = {};
      if(yamlText !== null && yamlText !== undefined) {
        json = safeLoad(yamlText);
        if(json === undefined || json === null) {
          json = {};
        }
      }

      for(var i = 0; i < identity_auth_challenge_redirect_parametersrowData.identity_auth_challenge_redirect_parameters.length; i++) {
        if(identity_auth_challenge_redirect_parametersrowData.identity_auth_challenge_redirect_parameters[i].id === window.identity_auth_challenge_redirect_parametersrowId) {
        setidentity_auth_challenge_redirect_parameters_name((identity_auth_challenge_redirect_parametersrowData.identity_auth_challenge_redirect_parameters[i] !== undefined && identity_auth_challenge_redirect_parametersrowData.identity_auth_challenge_redirect_parameters[i].name !== undefined )?identity_auth_challenge_redirect_parametersrowData.identity_auth_challenge_redirect_parameters[i].name:"");
        setidentity_auth_challenge_redirect_parameters_source((identity_auth_challenge_redirect_parametersrowData.identity_auth_challenge_redirect_parameters[i] !== undefined && identity_auth_challenge_redirect_parametersrowData.identity_auth_challenge_redirect_parameters[i].source !== undefined )?identity_auth_challenge_redirect_parametersrowData.identity_auth_challenge_redirect_parameters[i].source:"");
        setidentity_auth_challenge_redirect_parameters_value((identity_auth_challenge_redirect_parametersrowData.identity_auth_challenge_redirect_parameters[i] !== undefined && identity_auth_challenge_redirect_parametersrowData.identity_auth_challenge_redirect_parameters[i].value !== undefined )?identity_auth_challenge_redirect_parametersrowData.identity_auth_challenge_redirect_parameters[i].value:"");
        }
      }

      for(var i = 0; i < identity_auth_complete_redirect_parametersrowData.identity_auth_complete_redirect_parameters.length; i++) {
        if(identity_auth_complete_redirect_parametersrowData.identity_auth_complete_redirect_parameters[i].id === window.identity_auth_complete_redirect_parametersrowId) {
        setidentity_auth_complete_redirect_parameters_name((identity_auth_complete_redirect_parametersrowData.identity_auth_complete_redirect_parameters[i] !== undefined && identity_auth_complete_redirect_parametersrowData.identity_auth_complete_redirect_parameters[i].name !== undefined )?identity_auth_complete_redirect_parametersrowData.identity_auth_complete_redirect_parameters[i].name:"");
        setidentity_auth_complete_redirect_parameters_source((identity_auth_complete_redirect_parametersrowData.identity_auth_complete_redirect_parameters[i] !== undefined && identity_auth_complete_redirect_parametersrowData.identity_auth_complete_redirect_parameters[i].source !== undefined )?identity_auth_complete_redirect_parametersrowData.identity_auth_complete_redirect_parameters[i].source:"");
        setidentity_auth_complete_redirect_parameters_value((identity_auth_complete_redirect_parametersrowData.identity_auth_complete_redirect_parameters[i] !== undefined && identity_auth_complete_redirect_parametersrowData.identity_auth_complete_redirect_parameters[i].value !== undefined )?identity_auth_complete_redirect_parametersrowData.identity_auth_complete_redirect_parameters[i].value:"");
        }
      }

      for(var i = 0; i < identity_ci_oidc_allowed_query_argsrowData.identity_ci_oidc_allowed_query_args.length; i++) {
        if(identity_ci_oidc_allowed_query_argsrowData.identity_ci_oidc_allowed_query_args[i].id === window.identity_ci_oidc_allowed_query_argsrowId) {
        setidentity_ci_oidc_allowed_query_args_allowed_query_args((identity_ci_oidc_allowed_query_argsrowData.identity_ci_oidc_allowed_query_args[i] !== undefined && identity_ci_oidc_allowed_query_argsrowData.identity_ci_oidc_allowed_query_args[i].allowed_query_args !== undefined )?identity_ci_oidc_allowed_query_argsrowData.identity_ci_oidc_allowed_query_args[i].allowed_query_args:"");
        }
      }

      for(var i = 0; i < identity_ci_oidc_bearer_token_attrsrowData.identity_ci_oidc_bearer_token_attrs.length; i++) {
        if(identity_ci_oidc_bearer_token_attrsrowData.identity_ci_oidc_bearer_token_attrs[i].id === window.identity_ci_oidc_bearer_token_attrsrowId) {
        setidentity_ci_oidc_bearer_token_attrs_bearer_token_attrs((identity_ci_oidc_bearer_token_attrsrowData.identity_ci_oidc_bearer_token_attrs[i] !== undefined && identity_ci_oidc_bearer_token_attrsrowData.identity_ci_oidc_bearer_token_attrs[i].bearer_token_attrs !== undefined )?identity_ci_oidc_bearer_token_attrsrowData.identity_ci_oidc_bearer_token_attrs[i].bearer_token_attrs:"");
        }
      }

      for(var i = 0; i < identity_ci_oidc_id_token_attrsrowData.identity_ci_oidc_id_token_attrs.length; i++) {
        if(identity_ci_oidc_id_token_attrsrowData.identity_ci_oidc_id_token_attrs[i].id === window.identity_ci_oidc_id_token_attrsrowId) {
        setidentity_ci_oidc_id_token_attrs_id_token_attrs((identity_ci_oidc_id_token_attrsrowData.identity_ci_oidc_id_token_attrs[i] !== undefined && identity_ci_oidc_id_token_attrsrowData.identity_ci_oidc_id_token_attrs[i].id_token_attrs !== undefined )?identity_ci_oidc_id_token_attrsrowData.identity_ci_oidc_id_token_attrs[i].id_token_attrs:"");
        }
      }

      for(var i = 0; i < identity_ci_oidc_scopesrowData.identity_ci_oidc_scopes.length; i++) {
        if(identity_ci_oidc_scopesrowData.identity_ci_oidc_scopes[i].id === window.identity_ci_oidc_scopesrowId) {
        setidentity_ci_oidc_scopes_scopes((identity_ci_oidc_scopesrowData.identity_ci_oidc_scopes[i] !== undefined && identity_ci_oidc_scopesrowData.identity_ci_oidc_scopes[i].scopes !== undefined )?identity_ci_oidc_scopesrowData.identity_ci_oidc_scopes[i].scopes:"");
        }
      }

      for(var i = 0; i < identity_eai_triggersrowData.identity_eai_triggers.length; i++) {
        if(identity_eai_triggersrowData.identity_eai_triggers[i].id === window.identity_eai_triggersrowId) {
        setidentity_eai_triggers_triggers((identity_eai_triggersrowData.identity_eai_triggers[i] !== undefined && identity_eai_triggersrowData.identity_eai_triggers[i].triggers !== undefined )?identity_eai_triggersrowData.identity_eai_triggers[i].triggers:"");
        }
      }

      for(var i = 0; i < identity_oauthrowData.identity_oauth.length; i++) {
        if(identity_oauthrowData.identity_oauth[i].id === window.identity_oauthrowId) {
        setidentity_oauth_auth_method((identity_oauthrowData.identity_oauth[i] !== undefined && identity_oauthrowData.identity_oauth[i].auth_method !== undefined )?identity_oauthrowData.identity_oauth[i].auth_method:"");
        setidentity_oauth_client_id((identity_oauthrowData.identity_oauth[i] !== undefined && identity_oauthrowData.identity_oauth[i].client_id !== undefined )?identity_oauthrowData.identity_oauth[i].client_id:"");
        setidentity_oauth_client_id_hdr((identity_oauthrowData.identity_oauth[i] !== undefined && identity_oauthrowData.identity_oauth[i].client_id_hdr !== undefined )?identity_oauthrowData.identity_oauth[i].client_id_hdr:"");
        setidentity_oauth_client_secret((identity_oauthrowData.identity_oauth[i] !== undefined && identity_oauthrowData.identity_oauth[i].client_secret !== undefined )?identity_oauthrowData.identity_oauth[i].client_secret:"");
        setidentity_oauth_introspection_endpoint((identity_oauthrowData.identity_oauth[i] !== undefined && identity_oauthrowData.identity_oauth[i].introspection_endpoint !== undefined )?identity_oauthrowData.identity_oauth[i].introspection_endpoint:"");
        setidentity_oauth_mapped_identity((identity_oauthrowData.identity_oauth[i] !== undefined && identity_oauthrowData.identity_oauth[i].mapped_identity !== undefined )?identity_oauthrowData.identity_oauth[i].mapped_identity:"");
        setidentity_oauth_multi_valued_scope((identity_oauthrowData.identity_oauth[i] !== undefined && identity_oauthrowData.identity_oauth[i].multi_valued_scope !== undefined )?(identity_oauthrowData.identity_oauth[i].multi_valued_scope == true || identity_oauthrowData.identity_oauth[i].multi_valued_scope == "true"):false);
        setidentity_oauth_name((identity_oauthrowData.identity_oauth[i] !== undefined && identity_oauthrowData.identity_oauth[i].name !== undefined )?identity_oauthrowData.identity_oauth[i].name:"");
        setidentity_oauth_proxy((identity_oauthrowData.identity_oauth[i] !== undefined && identity_oauthrowData.identity_oauth[i].proxy !== undefined )?identity_oauthrowData.identity_oauth[i].proxy:"");
        setidentity_oauth_restricted((identity_oauthrowData.identity_oauth[i] !== undefined && identity_oauthrowData.identity_oauth[i].restricted !== undefined )?(identity_oauthrowData.identity_oauth[i].restricted == true || identity_oauthrowData.identity_oauth[i].restricted == "true"):false);
        setidentity_oauth_token_type_hint((identity_oauthrowData.identity_oauth[i] !== undefined && identity_oauthrowData.identity_oauth[i].token_type_hint !== undefined )?identity_oauthrowData.identity_oauth[i].token_type_hint:"");
        }
      }

      for(var i = 0; i < identity_oidcrowData.identity_oidc.length; i++) {
        if(identity_oidcrowData.identity_oidc[i].id === window.identity_oidcrowId) {
        setidentity_oidc_client_id((identity_oidcrowData.identity_oidc[i] !== undefined && identity_oidcrowData.identity_oidc[i].client_id !== undefined )?identity_oidcrowData.identity_oidc[i].client_id:"");
        setidentity_oidc_client_secret((identity_oidcrowData.identity_oidc[i] !== undefined && identity_oidcrowData.identity_oidc[i].client_secret !== undefined )?identity_oidcrowData.identity_oidc[i].client_secret:"");
        setidentity_oidc_discovery_endpoint((identity_oidcrowData.identity_oidc[i] !== undefined && identity_oidcrowData.identity_oidc[i].discovery_endpoint !== undefined )?identity_oidcrowData.identity_oidc[i].discovery_endpoint:"");
        setidentity_oidc_mapped_identity((identity_oidcrowData.identity_oidc[i] !== undefined && identity_oidcrowData.identity_oidc[i].mapped_identity !== undefined )?identity_oidcrowData.identity_oidc[i].mapped_identity:"");
        setidentity_oidc_name((identity_oidcrowData.identity_oidc[i] !== undefined && identity_oidcrowData.identity_oidc[i].name !== undefined )?identity_oidcrowData.identity_oidc[i].name:"");
        setidentity_oidc_pkce((identity_oidcrowData.identity_oidc[i] !== undefined && identity_oidcrowData.identity_oidc[i].pkce !== undefined )?(identity_oidcrowData.identity_oidc[i].pkce == true || identity_oidcrowData.identity_oidc[i].pkce == "true"):false);
        setidentity_oidc_proxy((identity_oidcrowData.identity_oidc[i] !== undefined && identity_oidcrowData.identity_oidc[i].proxy !== undefined )?identity_oidcrowData.identity_oidc[i].proxy:"");
        setidentity_oidc_redirect_uri_host((identity_oidcrowData.identity_oidc[i] !== undefined && identity_oidcrowData.identity_oidc[i].redirect_uri_host !== undefined )?identity_oidcrowData.identity_oidc[i].redirect_uri_host:"");
        setidentity_oidc_response_mode((identity_oidcrowData.identity_oidc[i] !== undefined && identity_oidcrowData.identity_oidc[i].response_mode !== undefined )?identity_oidcrowData.identity_oidc[i].response_mode:"");
        setidentity_oidc_response_type((identity_oidcrowData.identity_oidc[i] !== undefined && identity_oidcrowData.identity_oidc[i].response_type !== undefined )?identity_oidcrowData.identity_oidc[i].response_type:"");
        }
      }


      return true;
    };
    const [fetchedidentity, setFetchedidentity] = React.useState(false);
    React.useEffect(() => {
      getidentity();
    }, [fetchedidentity]);

    const getidentity = () => {

      var yamlText = window.iagyaml;
      var json = {};
      if(yamlText !== null && yamlText !== undefined) {
        json = safeLoad(yamlText);
        if(json === undefined || json === null) {
          json = {};
        }
      }

              identity_auth_challenge_redirect_parametersrowData.identity_auth_challenge_redirect_parameters = [];
              identity_auth_complete_redirect_parametersrowData.identity_auth_complete_redirect_parameters = [];
              identity_ci_oidc_allowed_query_argsrowData.identity_ci_oidc_allowed_query_args = [];
              identity_ci_oidc_bearer_token_attrsrowData.identity_ci_oidc_bearer_token_attrs = [];
              identity_ci_oidc_id_token_attrsrowData.identity_ci_oidc_id_token_attrs = [];
              identity_ci_oidc_scopesrowData.identity_ci_oidc_scopes = [];
              identity_eai_triggersrowData.identity_eai_triggers = [];
            identity_oauthrowData.identity_oauth = [];
            identity_oidcrowData.identity_oidc = [];

        if(json !== undefined && json.identity !== undefined ) {
          var newauth_challenge_redirect = {};
          if(json !== undefined && json.identity !== undefined && json.identity.auth_challenge_redirect !== undefined ) {
            if(json !== undefined && json.identity !== undefined && json.identity.auth_challenge_redirect !== undefined && json.identity.auth_challenge_redirect.parameters !== undefined ) {
              var newparameterss = [];
              for(var i = 0; i < json.identity.auth_challenge_redirect.parameters.length; i++) {
                var newauth_challenge_redirect = {};
                var tempId = ((json.identity.auth_challenge_redirect.parameters[i].value)?json.identity.auth_challenge_redirect.parameters[i].value:"") + ((json.identity.auth_challenge_redirect.parameters[i].source)?json.identity.auth_challenge_redirect.parameters[i].source:"");
                newauth_challenge_redirect["id"] = tempId;
                newauth_challenge_redirect["name"] = json.identity.auth_challenge_redirect.parameters[i].name;
                newauth_challenge_redirect["source"] = json.identity.auth_challenge_redirect.parameters[i].source;
                newauth_challenge_redirect["value"] = json.identity.auth_challenge_redirect.parameters[i].value;
              }
              identity_auth_challenge_redirect_parametersrowData.identity_auth_challenge_redirect_parameters.push(newauth_challenge_redirect);
              }
            if(json !== undefined && json.identity !== undefined && json.identity.auth_challenge_redirect !== undefined && json.identity.auth_challenge_redirect.url !== undefined ) {
              setidentity_auth_challenge_redirect_url(json.identity.auth_challenge_redirect.url);
            }
          }
          var newauth_complete_redirect = {};
          if(json !== undefined && json.identity !== undefined && json.identity.auth_complete_redirect !== undefined ) {
            if(json !== undefined && json.identity !== undefined && json.identity.auth_complete_redirect !== undefined && json.identity.auth_complete_redirect.parameters !== undefined ) {
              var newparameterss = [];
              for(var i = 0; i < json.identity.auth_complete_redirect.parameters.length; i++) {
                var newauth_complete_redirect = {};
                var tempId = ((json.identity.auth_complete_redirect.parameters[i].source)?json.identity.auth_complete_redirect.parameters[i].source:"") + ((json.identity.auth_complete_redirect.parameters[i].value)?json.identity.auth_complete_redirect.parameters[i].value:"");
                newauth_complete_redirect["id"] = tempId;
                newauth_complete_redirect["name"] = json.identity.auth_complete_redirect.parameters[i].name;
                newauth_complete_redirect["source"] = json.identity.auth_complete_redirect.parameters[i].source;
                newauth_complete_redirect["value"] = json.identity.auth_complete_redirect.parameters[i].value;
              }
              identity_auth_complete_redirect_parametersrowData.identity_auth_complete_redirect_parameters.push(newauth_complete_redirect);
              }
            if(json !== undefined && json.identity !== undefined && json.identity.auth_complete_redirect !== undefined && json.identity.auth_complete_redirect.url !== undefined ) {
              setidentity_auth_complete_redirect_url(json.identity.auth_complete_redirect.url);
            }
          }
          var newci_oidc = {};
          if(json !== undefined && json.identity !== undefined && json.identity.ci_oidc !== undefined ) {
            if(json !== undefined && json.identity !== undefined && json.identity.ci_oidc !== undefined && json.identity.ci_oidc.allowed_query_args !== undefined ) {
              var newallowed_query_argss = [];
              for(var i = 0; i < json.identity.ci_oidc.allowed_query_args.length; i++) {
                  var newallowed_query_args = {};
                  newallowed_query_args["id"] = json.identity.ci_oidc.allowed_query_args[i];
                  newallowed_query_args["allowed_query_args"] = json.identity.ci_oidc.allowed_query_args[i];
                  newallowed_query_argss.push(newallowed_query_args);
                  identity_ci_oidc_allowed_query_argsrowData.identity_ci_oidc_allowed_query_args.push(newallowed_query_args);
              }
              }
            if(json !== undefined && json.identity !== undefined && json.identity.ci_oidc !== undefined && json.identity.ci_oidc.bearer_token_attrs !== undefined ) {
              var newbearer_token_attrss = [];
              for(var i = 0; i < json.identity.ci_oidc.bearer_token_attrs.length; i++) {
                  var newbearer_token_attrs = {};
                  newbearer_token_attrs["id"] = json.identity.ci_oidc.bearer_token_attrs[i];
                  newbearer_token_attrs["bearer_token_attrs"] = json.identity.ci_oidc.bearer_token_attrs[i];
                  newbearer_token_attrss.push(newbearer_token_attrs);
                  identity_ci_oidc_bearer_token_attrsrowData.identity_ci_oidc_bearer_token_attrs.push(newbearer_token_attrs);
              }
              }
            if(json !== undefined && json.identity !== undefined && json.identity.ci_oidc !== undefined && json.identity.ci_oidc.client_id !== undefined ) {
              setidentity_ci_oidc_client_id(json.identity.ci_oidc.client_id);
            }
            if(json !== undefined && json.identity !== undefined && json.identity.ci_oidc !== undefined && json.identity.ci_oidc.client_secret !== undefined ) {
              setidentity_ci_oidc_client_secret(json.identity.ci_oidc.client_secret);
            }
            if(json !== undefined && json.identity !== undefined && json.identity.ci_oidc !== undefined && json.identity.ci_oidc.hostname !== undefined ) {
              setidentity_ci_oidc_hostname(json.identity.ci_oidc.hostname);
            }
            if(json !== undefined && json.identity !== undefined && json.identity.ci_oidc !== undefined && json.identity.ci_oidc.id_token_attrs !== undefined ) {
              var newid_token_attrss = [];
              for(var i = 0; i < json.identity.ci_oidc.id_token_attrs.length; i++) {
                  var newid_token_attrs = {};
                  newid_token_attrs["id"] = json.identity.ci_oidc.id_token_attrs[i];
                  newid_token_attrs["id_token_attrs"] = json.identity.ci_oidc.id_token_attrs[i];
                  newid_token_attrss.push(newid_token_attrs);
                  identity_ci_oidc_id_token_attrsrowData.identity_ci_oidc_id_token_attrs.push(newid_token_attrs);
              }
              }
            if(json !== undefined && json.identity !== undefined && json.identity.ci_oidc !== undefined && json.identity.ci_oidc.mapped_identity !== undefined ) {
              setidentity_ci_oidc_mapped_identity(json.identity.ci_oidc.mapped_identity);
            }
            if(json !== undefined && json.identity !== undefined && json.identity.ci_oidc !== undefined && json.identity.ci_oidc.proxy !== undefined ) {
              setidentity_ci_oidc_proxy(json.identity.ci_oidc.proxy);
            }
            if(json !== undefined && json.identity !== undefined && json.identity.ci_oidc !== undefined && json.identity.ci_oidc.redirect_uri_host !== undefined ) {
              setidentity_ci_oidc_redirect_uri_host(json.identity.ci_oidc.redirect_uri_host);
            }
            if(json !== undefined && json.identity !== undefined && json.identity.ci_oidc !== undefined && json.identity.ci_oidc.response_mode !== undefined ) {
              setidentity_ci_oidc_response_mode(json.identity.ci_oidc.response_mode);
            }
            if(json !== undefined && json.identity !== undefined && json.identity.ci_oidc !== undefined && json.identity.ci_oidc.response_type !== undefined ) {
              setidentity_ci_oidc_response_type(json.identity.ci_oidc.response_type);
            }
            if(json !== undefined && json.identity !== undefined && json.identity.ci_oidc !== undefined && json.identity.ci_oidc.scopes !== undefined ) {
              var newscopess = [];
              for(var i = 0; i < json.identity.ci_oidc.scopes.length; i++) {
                  var newscopes = {};
                  newscopes["id"] = json.identity.ci_oidc.scopes[i];
                  newscopes["scopes"] = json.identity.ci_oidc.scopes[i];
                  newscopess.push(newscopes);
                  identity_ci_oidc_scopesrowData.identity_ci_oidc_scopes.push(newscopes);
              }
              }
          }
          var neweai = {};
          if(json !== undefined && json.identity !== undefined && json.identity.eai !== undefined ) {
            if(json !== undefined && json.identity !== undefined && json.identity.eai !== undefined && json.identity.eai.triggers !== undefined ) {
              var newtriggerss = [];
              for(var i = 0; i < json.identity.eai.triggers.length; i++) {
                  var newtriggers = {};
                  newtriggers["id"] = json.identity.eai.triggers[i];
                  newtriggers["triggers"] = json.identity.eai.triggers[i];
                  newtriggerss.push(newtriggers);
                  identity_eai_triggersrowData.identity_eai_triggers.push(newtriggers);
              }
              }
          }
          if(json !== undefined && json.identity !== undefined && json.identity.oauth !== undefined ) {
            var newoauths = [];
            for(var i = 0; i < json.identity.oauth.length; i++) {
              var newItem = {};
              if(json !== undefined && json.identity !== undefined && json.identity.oauth[i] !== undefined && json.identity.oauth[i].attributes !== undefined ) {
                var newattributess = [];
                for(var i2 = 0; i2 < json.identity.oauth[i].attributes.length; i2++) {
                    var newattributes = {};
                    newattributes["id"] = json.identity.oauth[i].attributes[i2];
                    newattributes["attributes"] = json.identity.oauth[i].attributes[i2];
                    newattributess.push(newattributes);
                }
                newItem["attributes"] = newattributess;
                }
              var tempId = ((json.identity.oauth[i].name)?json.identity.oauth[i].name:"");
              newItem["id"] = tempId;
              newItem["auth_method"] = json.identity.oauth[i].auth_method;
              newItem["client_id"] = json.identity.oauth[i].client_id;
              newItem["client_id_hdr"] = json.identity.oauth[i].client_id_hdr;
              newItem["client_secret"] = json.identity.oauth[i].client_secret;
              if(json !== undefined && json.identity !== undefined && json.identity.oauth[i] !== undefined && json.identity.oauth[i].headers !== undefined ) {
                var newheaderss = [];
                for(var i2 = 0; i2 < json.identity.oauth[i].headers.length; i2++) {
                  var newItem = {};
                  var tempId = ((json.identity.oauth[i].headers[i2].value)?json.identity.oauth[i].headers[i2].value:"") + ((json.identity.oauth[i].headers[i2].source)?json.identity.oauth[i].headers[i2].source:"") + ((json.identity.oauth[i].headers[i2].name)?json.identity.oauth[i].headers[i2].name:"");
                  newItem["id"] = tempId;
                  newItem["name"] = json.identity.oauth[i].headers[i2].name;
                  newItem["source"] = json.identity.oauth[i].headers[i2].source;
                  newItem["value"] = json.identity.oauth[i].headers[i2].value;
                }
                newItem["headers"] = newheaderss;
                }
              newItem["introspection_endpoint"] = json.identity.oauth[i].introspection_endpoint;
              newItem["mapped_identity"] = json.identity.oauth[i].mapped_identity;
              newItem["multi_valued_scope"] = json.identity.oauth[i].multi_valued_scope;
              newItem["name"] = json.identity.oauth[i].name;
              newItem["proxy"] = json.identity.oauth[i].proxy;
              newItem["restricted"] = json.identity.oauth[i].restricted;
              var newssl = {};
              if(json !== undefined && json.identity !== undefined && json.identity.oauth[i] !== undefined && json.identity.oauth[i].ssl !== undefined ) {
                if(json !== undefined && json.identity !== undefined && json.identity.oauth[i] !== undefined && json.identity.oauth[i].ssl !== undefined && json.identity.oauth[i].ssl.certificate !== undefined ) {
                  var newcertificates = [];
                  for(var i2 = 0; i2 < json.identity.oauth[i].ssl.certificate.length; i2++) {
                      var newcertificate = {};
                      newcertificate["id"] = json.identity.oauth[i].ssl.certificate[i2];
                      newcertificate["certificate"] = json.identity.oauth[i].ssl.certificate[i2];
                      newcertificates.push(newcertificate);
                  }
                  newssl["certificate"] = newcertificates;
                  }
              }
              newItem["ssl"] = newssl;
              newItem["token_type_hint"] = json.identity.oauth[i].token_type_hint;
              identity_oauthrowData.identity_oauth.push(newItem);
            }
            }
          if(json !== undefined && json.identity !== undefined && json.identity.oidc !== undefined ) {
            var newoidcs = [];
            for(var i = 0; i < json.identity.oidc.length; i++) {
              var newItem = {};
              if(json !== undefined && json.identity !== undefined && json.identity.oidc[i] !== undefined && json.identity.oidc[i].allowed_query_args !== undefined ) {
                var newallowed_query_argss = [];
                for(var i2 = 0; i2 < json.identity.oidc[i].allowed_query_args.length; i2++) {
                    var newallowed_query_args = {};
                    newallowed_query_args["id"] = json.identity.oidc[i].allowed_query_args[i2];
                    newallowed_query_args["allowed_query_args"] = json.identity.oidc[i].allowed_query_args[i2];
                    newallowed_query_argss.push(newallowed_query_args);
                }
                newItem["allowed_query_args"] = newallowed_query_argss;
                }
              if(json !== undefined && json.identity !== undefined && json.identity.oidc[i] !== undefined && json.identity.oidc[i].bearer_token_attrs !== undefined ) {
                var newbearer_token_attrss = [];
                for(var i2 = 0; i2 < json.identity.oidc[i].bearer_token_attrs.length; i2++) {
                    var newbearer_token_attrs = {};
                    newbearer_token_attrs["id"] = json.identity.oidc[i].bearer_token_attrs[i2];
                    newbearer_token_attrs["bearer_token_attrs"] = json.identity.oidc[i].bearer_token_attrs[i2];
                    newbearer_token_attrss.push(newbearer_token_attrs);
                }
                newItem["bearer_token_attrs"] = newbearer_token_attrss;
                }
              var tempId = ((json.identity.oidc[i].discovery_endpoint)?json.identity.oidc[i].discovery_endpoint:"");
              newItem["id"] = tempId;
              newItem["client_id"] = json.identity.oidc[i].client_id;
              newItem["client_secret"] = json.identity.oidc[i].client_secret;
              newItem["discovery_endpoint"] = json.identity.oidc[i].discovery_endpoint;
              if(json !== undefined && json.identity !== undefined && json.identity.oidc[i] !== undefined && json.identity.oidc[i].id_token_attrs !== undefined ) {
                var newid_token_attrss = [];
                for(var i2 = 0; i2 < json.identity.oidc[i].id_token_attrs.length; i2++) {
                    var newid_token_attrs = {};
                    newid_token_attrs["id"] = json.identity.oidc[i].id_token_attrs[i2];
                    newid_token_attrs["id_token_attrs"] = json.identity.oidc[i].id_token_attrs[i2];
                    newid_token_attrss.push(newid_token_attrs);
                }
                newItem["id_token_attrs"] = newid_token_attrss;
                }
              newItem["mapped_identity"] = json.identity.oidc[i].mapped_identity;
              newItem["name"] = json.identity.oidc[i].name;
              newItem["pkce"] = json.identity.oidc[i].pkce;
              newItem["proxy"] = json.identity.oidc[i].proxy;
              newItem["redirect_uri_host"] = json.identity.oidc[i].redirect_uri_host;
              newItem["response_mode"] = json.identity.oidc[i].response_mode;
              newItem["response_type"] = json.identity.oidc[i].response_type;
              if(json !== undefined && json.identity !== undefined && json.identity.oidc[i] !== undefined && json.identity.oidc[i].scopes !== undefined ) {
                var newscopess = [];
                for(var i2 = 0; i2 < json.identity.oidc[i].scopes.length; i2++) {
                    var newscopes = {};
                    newscopes["id"] = json.identity.oidc[i].scopes[i2];
                    newscopes["scopes"] = json.identity.oidc[i].scopes[i2];
                    newscopess.push(newscopes);
                }
                newItem["scopes"] = newscopess;
                }
              var newssl = {};
              if(json !== undefined && json.identity !== undefined && json.identity.oidc[i] !== undefined && json.identity.oidc[i].ssl !== undefined ) {
                if(json !== undefined && json.identity !== undefined && json.identity.oidc[i] !== undefined && json.identity.oidc[i].ssl !== undefined && json.identity.oidc[i].ssl.certificate !== undefined ) {
                  var newcertificates = [];
                  for(var i2 = 0; i2 < json.identity.oidc[i].ssl.certificate.length; i2++) {
                      var newcertificate = {};
                      newcertificate["id"] = json.identity.oidc[i].ssl.certificate[i2];
                      newcertificate["certificate"] = json.identity.oidc[i].ssl.certificate[i2];
                      newcertificates.push(newcertificate);
                  }
                  newssl["certificate"] = newcertificates;
                  }
              }
              newItem["ssl"] = newssl;
              identity_oidcrowData.identity_oidc.push(newItem);
            }
            }
        }
    };



    const setDataMain = (functionName, data) => {
      if(functionName && data) {
        eval(functionName)(data);
      }
    };

    return (
        <div className="bx--grid--no-gutter bx--grid--full-width landing-page">
          <div className="bx--row landing-page__banner" style={{paddingBottom:"3rem"}}>
            <div className="bx--col-lg-13 bx--offset-lg-1">
              <h1 className="landing-page__heading">
                Identity
              </h1>
            </div>
            <div className="bx--col-lg-13 bx--offset-lg-1">
              <h4 className="landing-page__desc" style={{marginTop:"30px"}}>This node defines how users will authenticate to the reverse proxy.
</h4>
            </div>            <div id="warning_div" className="bx--col-lg-13" style={{display:'none', color:'red', position:'absolute', bottom:'0', marginBottom: '10px'}}></div>
          </div>
          <div className="bx--row landing-page__r2">
            <div className="bx--col bx--no-gutter">
              <div id="identityPage" className="bx--col">
                <br/><br/><br/>
            <Tabs id={"identity_tab" + idPrefix} defaultTab={"auth_challenge_redirect_tab" + idPrefix} vertical className="vertical-tabs" style={{overflow:'auto'}}>
              <TabList>
                <Tab tabFor={"auth_challenge_redirect_tab" + idPrefix}>Auth Challenge Redirect</Tab>
                <Tab tabFor={"auth_complete_redirect_tab" + idPrefix}>Auth Complete Redirect</Tab>
                <Tab tabFor={"ci_oidc_tab" + idPrefix}>CI OIDC (deprecated)</Tab>
                <Tab tabFor={"eai_tab" + idPrefix}>EAI</Tab>
                <Tab tabFor={"oauth_tab" + idPrefix}>OAuth</Tab>
                <Tab tabFor={"oidc_tab" + idPrefix}>Oidc</Tab>
              </TabList>
              <TabPanel style={{width:'100%', overflow:'auto'}} tabId={"auth_challenge_redirect_tab" + idPrefix}>
                <div className= {"iag_form_elem iag_tab_heading identity_div" + idPrefix}>
                  <span className="iag_breadcrumb">Identity : </span><br/>                  <h2>Auth Challenge Redirect Settings</h2><hr/>
                  <Collapsible tabIndex="0" trigger="These entries can be used to override the default authentication challenge which unauthenticated clients will be redirected to when first accessing the reverse proxy">
                    <p>These entries can be used to override the default authentication challenge which unauthenticated clients will be redirected to when first accessing the reverse proxy.<br/>If an OIDC identity source is configured, this entry will default to the OIDC authentication URI "/pkmsoidc?iss=default".</p>
                  </Collapsible>

                </div>
                <div className={"iag--simple-div identity_div" + idPrefix}>
                <div className= {"iag_form_elem identity_div" + idPrefix}>
  <h3 tabIndex="0"  data-tooltip-id={"identity_auth_challenge_redirect_parameters_tooltip_id" + idPrefix} >Parameters</h3><hr/>
</div>
          <ReactTooltip id={"identity_auth_challenge_redirect_parameters_tooltip_id" + idPrefix} clickable={true} place="top" effect="solid" ><div style={{ maxWidth: 300 }}>Additional parameters which can be included in the redirect URI as query string arguments.<br/></div></ReactTooltip>

                <div id={"identity_auth_challenge_redirect_parametersTableDiv" + idPrefix} style={{marginLeft:"10px",marginBottom:"10px"}}>
                  <div className={"iag_form_elem identity_div" + idPrefix}>
                    <DataTable id={"identity_auth_challenge_redirect_parametersTable" + idPrefix} isSortable
                        headers={identity_auth_challenge_redirect_parametersheaderData}
                        rows={identity_auth_challenge_redirect_parametersrowData.identity_auth_challenge_redirect_parameters}
                        render={({
                          rows,
                          headers,
                          getHeaderProps,
                          getRowProps,
                          getTableProps,
                          getToolbarProps,
                          onInputChange,
                          getTableContainerProps
                    }) => (
                      <TableContainer>
                        <TableToolbar aria-label="data table toolbar">
                          <TableToolbarContent>
                            <Button onClick={() => {identity_auth_challenge_redirect_parametershandleAdd(idPrefix, [setidentity_auth_challenge_redirect_parameters_name(''),    setidentity_auth_challenge_redirect_parameters_source(''),    setidentity_auth_challenge_redirect_parameters_source_valid(true),    setidentity_auth_challenge_redirect_parameters_value(''),    setidentity_auth_challenge_redirect_parameters_value_valid(true),]);}}>Add</Button>
                          </TableToolbarContent>
                        </TableToolbar>
                        <Table size='normal' {...getTableProps()}>
                          <TableHead>
                            <TableRow>
                              {headers.map(header => (
                                <TableHeader {...getHeaderProps({ header })}>
                                  {header.header}
                                </TableHeader>
                              ))}
                              <TableHeader>
                                  Actions
                              </TableHeader>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {rows.map(row => (
                              <TableRow key={row.id}>
                                {row.cells.map(cell => (
                                  <TableCell key={cell.id}>{cell.value}</TableCell>
                                ))}
                                <TableCell>
                                  <Suspense fallback={<div></div>}>
                                    <IdentityauthChallengeRedirectparametersDeleteModal row={row} loadGrid={identity_auth_challenge_redirect_parametersloadGrid} />
                                  </Suspense>
                                  <Suspense fallback={<div></div>}>
                                    <IdentityauthChallengeRedirectparametersEdit  data={identity_auth_challenge_redirect_parametersrowData.identity_auth_challenge_redirect_parameters} setData={setDataMain} row={row} loadGrid={identity_auth_challenge_redirect_parametersloadGrid} dataLoad={dataLoad} editing={true} name={"identity_auth_challenge_redirect_parameters"} idPrefix={idPrefix + "_edit"} parentIdPrefix={idPrefix} 
            updateidentity_auth_challenge_redirect_parameters_name={updateidentity_auth_challenge_redirect_parameters_name} identity_auth_challenge_redirect_parameters_name={identity_auth_challenge_redirect_parameters_name}
            updateidentity_auth_challenge_redirect_parameters_source={updateidentity_auth_challenge_redirect_parameters_source} identity_auth_challenge_redirect_parameters_source={identity_auth_challenge_redirect_parameters_source}
            identity_auth_challenge_redirect_parameters_source_valid={identity_auth_challenge_redirect_parameters_source_valid}
            identity_auth_challenge_redirect_parameters_source_invalid_text={identity_auth_challenge_redirect_parameters_source_invalid_text}
            updateidentity_auth_challenge_redirect_parameters_value={updateidentity_auth_challenge_redirect_parameters_value} identity_auth_challenge_redirect_parameters_value={identity_auth_challenge_redirect_parameters_value}
            identity_auth_challenge_redirect_parameters_value_valid={identity_auth_challenge_redirect_parameters_value_valid}
            identity_auth_challenge_redirect_parameters_value_invalid_text={identity_auth_challenge_redirect_parameters_value_invalid_text}
                                    />
                                  </Suspense>
                                </TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>)}
                    />
                  </div>
                </div>

                <div className= {"iag_form_elem identity_div" + idPrefix}>
          <TextInput  value={identity_auth_challenge_redirect_url}  id={"identity_auth_challenge_redirect_url_id" + idPrefix}  data-tooltip-id={"identity_auth_challenge_redirect_url_tooltip_id" + idPrefix}  labelText="URL" onChange={(evt) => { updateidentity_auth_challenge_redirect_url(evt); handleChange(); }}/>
          <ReactTooltip id={"identity_auth_challenge_redirect_url_tooltip_id" + idPrefix} clickable={true} place="top" effect="solid" ><div style={{ maxWidth: 300 }}>The URI which a client will be redirected to in order to start the authentication process. This URI can be absolute or server relative.<br/></div></ReactTooltip>
        </div>

                </div>
              </TabPanel>
              <TabPanel style={{width:'100%', overflow:'auto'}} tabId={"auth_complete_redirect_tab" + idPrefix}>
                <div className= {"iag_form_elem iag_tab_heading identity_div" + idPrefix}>
                  <span className="iag_breadcrumb">Identity : </span><br/>                  <h2>Auth Complete Redirect Settings</h2><hr/>
                  These entries can be used to override the default post authentication URL which clients will be redirected to once they have successfully authenticated.
                </div>
                <div className={"iag--simple-div identity_div" + idPrefix}>
                <div className= {"iag_form_elem identity_div" + idPrefix}>
  <h3 tabIndex="0"  data-tooltip-id={"identity_auth_complete_redirect_parameters_tooltip_id" + idPrefix} >Parameters</h3><hr/>
</div>
          <ReactTooltip id={"identity_auth_complete_redirect_parameters_tooltip_id" + idPrefix} clickable={true} place="top" effect="solid" ><div style={{ maxWidth: 300 }}>Additional parameters which can be included in the redirect URI as query string arguments.<br/></div></ReactTooltip>

                <div id={"identity_auth_complete_redirect_parametersTableDiv" + idPrefix} style={{marginLeft:"10px",marginBottom:"10px"}}>
                  <div className={"iag_form_elem identity_div" + idPrefix}>
                    <DataTable id={"identity_auth_complete_redirect_parametersTable" + idPrefix} isSortable
                        headers={identity_auth_complete_redirect_parametersheaderData}
                        rows={identity_auth_complete_redirect_parametersrowData.identity_auth_complete_redirect_parameters}
                        render={({
                          rows,
                          headers,
                          getHeaderProps,
                          getRowProps,
                          getTableProps,
                          getToolbarProps,
                          onInputChange,
                          getTableContainerProps
                    }) => (
                      <TableContainer>
                        <TableToolbar aria-label="data table toolbar">
                          <TableToolbarContent>
                            <Button onClick={() => {identity_auth_complete_redirect_parametershandleAdd(idPrefix, [setidentity_auth_complete_redirect_parameters_name(''),    setidentity_auth_complete_redirect_parameters_source(''),    setidentity_auth_complete_redirect_parameters_source_valid(true),    setidentity_auth_complete_redirect_parameters_value(''),    setidentity_auth_complete_redirect_parameters_value_valid(true),]);}}>Add</Button>
                          </TableToolbarContent>
                        </TableToolbar>
                        <Table size='normal' {...getTableProps()}>
                          <TableHead>
                            <TableRow>
                              {headers.map(header => (
                                <TableHeader {...getHeaderProps({ header })}>
                                  {header.header}
                                </TableHeader>
                              ))}
                              <TableHeader>
                                  Actions
                              </TableHeader>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {rows.map(row => (
                              <TableRow key={row.id}>
                                {row.cells.map(cell => (
                                  <TableCell key={cell.id}>{cell.value}</TableCell>
                                ))}
                                <TableCell>
                                  <Suspense fallback={<div></div>}>
                                    <IdentityauthCompleteRedirectparametersDeleteModal row={row} loadGrid={identity_auth_complete_redirect_parametersloadGrid} />
                                  </Suspense>
                                  <Suspense fallback={<div></div>}>
                                    <IdentityauthCompleteRedirectparametersEdit  data={identity_auth_complete_redirect_parametersrowData.identity_auth_complete_redirect_parameters} setData={setDataMain} row={row} loadGrid={identity_auth_complete_redirect_parametersloadGrid} dataLoad={dataLoad} editing={true} name={"identity_auth_complete_redirect_parameters"} idPrefix={idPrefix + "_edit"} parentIdPrefix={idPrefix} 
            updateidentity_auth_complete_redirect_parameters_name={updateidentity_auth_complete_redirect_parameters_name} identity_auth_complete_redirect_parameters_name={identity_auth_complete_redirect_parameters_name}
            updateidentity_auth_complete_redirect_parameters_source={updateidentity_auth_complete_redirect_parameters_source} identity_auth_complete_redirect_parameters_source={identity_auth_complete_redirect_parameters_source}
            identity_auth_complete_redirect_parameters_source_valid={identity_auth_complete_redirect_parameters_source_valid}
            identity_auth_complete_redirect_parameters_source_invalid_text={identity_auth_complete_redirect_parameters_source_invalid_text}
            updateidentity_auth_complete_redirect_parameters_value={updateidentity_auth_complete_redirect_parameters_value} identity_auth_complete_redirect_parameters_value={identity_auth_complete_redirect_parameters_value}
            identity_auth_complete_redirect_parameters_value_valid={identity_auth_complete_redirect_parameters_value_valid}
            identity_auth_complete_redirect_parameters_value_invalid_text={identity_auth_complete_redirect_parameters_value_invalid_text}
                                    />
                                  </Suspense>
                                </TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>)}
                    />
                  </div>
                </div>

                <div className= {"iag_form_elem identity_div" + idPrefix}>
          <TextInput  value={identity_auth_complete_redirect_url}  id={"identity_auth_complete_redirect_url_id" + idPrefix}  data-tooltip-id={"identity_auth_complete_redirect_url_tooltip_id" + idPrefix}  labelText="URL" onChange={(evt) => { updateidentity_auth_complete_redirect_url(evt); handleChange(); }}/>
          <ReactTooltip id={"identity_auth_complete_redirect_url_tooltip_id" + idPrefix} clickable={true} place="top" effect="solid" ><div style={{ maxWidth: 300 }}>The URI which a client will be redirected to upon successful authentication. This URI can be absolute or server relative.<br/></div></ReactTooltip>
        </div>

                </div>
              </TabPanel>
              <TabPanel style={{width:'100%', overflow:'auto'}} tabId={"ci_oidc_tab" + idPrefix}>
                <div className= {"iag_form_elem iag_tab_heading identity_div" + idPrefix}>
                  <span className="iag_breadcrumb">Identity : </span><br/>                  <h2>CI OIDC (deprecated) Settings</h2><hr/>
                  <Collapsible tabIndex="0" trigger="The configuration entries in this section allow the reverse proxy to act as an OIDC relying party to IBM Security Verify">
                    <p>The configuration entries in this section allow the reverse proxy to act as an OIDC relying party to IBM Security Verify.<br/><br/><h4> Notice of Deprecation</h4><br/><br/>This identity module is no longer preferred and will be removed in a future version. Use the OIDC identity module.<br/><br/>When using the OIDC identity module, `discovery_endpoint` is given rather than `hostname`.<br/><br/><br/>The format for an IBM Security Verify `discovery_endpoint` is:<br/><br/>`https://&lt;hostname&gt;/oidc/endpoint/default/.well-known/openid-configuration`<br/><br/>For example, refer to the IBM Security Verify OIDC configuration below:<br/><br/><span>YAML Example</span><br/><div style={{outline:'2px solid', backgroundColor:'#dcd7d7', padding:'10px', whiteSpace:'pre-wrap'}}><br/>  identity:<br/>    ci_oidc:<br/>      hostname: www.test.com<br/>      client_id: 11111111-2222-3333-4444-5a5a5a5a5a5a5a<br/>      <h2> ...</h2><br/></div><br/><br/>The equivalent OIDC configuration is:<br/><br/><span>YAML Example</span><br/><div style={{outline:'2px solid', backgroundColor:'#dcd7d7', padding:'10px', whiteSpace:'pre-wrap'}}><br/>  identity:<br/>    oidc:<br/>      discovery_endpoint: https://www.test.com/oidc/endpoint/default/.well-known/openid-configuration<br/>      client_id: 11111111-2222-3333-4444-5a5a5a5a5a5a5a<br/>      <h2> ...</h2><br/></div><br/><br/><h4> Response Type Values</h4><br/><table style={{textAlign:'left', border:'1px solid black'}}><tbody><tr style={{textAlign:'left', border:'1px solid black'}}><th style={{borderRight:'1px solid black', padding: '10px'}}>Name </th><th style={{borderRight:'1px solid black', padding: '10px'}}> Description</th></tr><tr><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}>code </td><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> The authorization code flow will be used to retrieve both an access token and identity token.</td></tr><tr><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}>id_token </td><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> The implicit flow will be used to retrieve the identity token.</td></tr><tr><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}>id_token token </td><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> The implicit flow will be used to retrieve both an access token and identity token.</td></tr></tbody></table><br/><h4> Bearer Token Attrs Format</h4><br/>A JSON data element from the bearer token response which should be included or excluded in the credential as an extended attribute.<br/>The format of the configuration entry is:<br/><br/><table style={{textAlign:'left', border:'1px solid black'}}><tbody><tr style={{textAlign:'left', border:'1px solid black'}}><th style={{borderRight:'1px solid black', padding: '10px'}}>`[+</th><th style={{borderRight:'1px solid black', padding: '10px'}}>-]&lt;json-data&gt;`</th></tr></tbody></table><br/>where:<br/><br/><table style={{textAlign:'left', border:'1px solid black'}}><tbody><tr style={{textAlign:'left', border:'1px solid black'}}><th style={{borderRight:'1px solid black', padding: '10px'}}>Element </th><th style={{borderRight:'1px solid black', padding: '10px'}}> Description</th></tr><tr><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}>+ </td><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> Indicates that this JSON data should be added to the credential.</td></tr><tr><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}>- </td><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> Indicates that this JSON data should not be added to the credential.</td></tr><tr><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}>&lt;json-data&gt; </td><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> The corresponding JSON data name, which can also contain pattern matching characters (i.e. * ?).</td></tr></tbody></table><br/>For example the value "-access_token" indicates that the access_token should not be added to the credential.<br/><br/>When a bearer token is received each JSON data element will be evaluated against each rule in sequence until a match is found.<br/>The corresponding code (+|-) will then be used to determine whether the JSON data will be added to the credential or not.<br/>If the JSON data name does not match a configured rule it will by default be added to the credential.<br/><br/><h4> ID Token Attrs Format</h4><br/>A claim from the ID token response which should be included or excluded in the credential as an extended attribute.<br/>The format of the configuration entry is:<br/><br/><table style={{textAlign:'left', border:'1px solid black'}}><tbody><tr style={{textAlign:'left', border:'1px solid black'}}><th style={{borderRight:'1px solid black', padding: '10px'}}>`[+</th><th style={{borderRight:'1px solid black', padding: '10px'}}>-]&lt;claim&gt;`</th></tr></tbody></table><br/>where:<br/><br/><table style={{textAlign:'left', border:'1px solid black'}}><tbody><tr style={{textAlign:'left', border:'1px solid black'}}><th style={{borderRight:'1px solid black', padding: '10px'}}>Element </th><th style={{borderRight:'1px solid black', padding: '10px'}}> Description</th></tr><tr><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}>+ </td><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> Indicates that this claim should be added to the credential.</td></tr><tr><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}>- </td><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> Indicates that this claim should not be added to the credential.</td></tr><tr><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}>&lt;claim&gt; </td><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> The corresponding claim name, which can also contain pattern matching characters (i.e. * ?).</td></tr></tbody></table><br/>For example the value "-email" indicates that the email claim should not be added to the credential.<br/><br/>When an ID token is received each claim will be evaluated against each rule in sequence until a match is found.<br/>The corresponding code (+|-) will then be used to determine whether the claim will be added to the credential or not.<br/>If the claim name does not match a configured rule it will by default be added to the credential.</p>
                  </Collapsible>

                </div>
                <div className={"iag--simple-div identity_div" + idPrefix}>
                <div className= {"iag_form_elem identity_div" + idPrefix}>
  <h3 tabIndex="0"  data-tooltip-id={"identity_ci_oidc_allowed_query_args_tooltip_id" + idPrefix} >Allowed Query Arguments</h3><hr/>
</div>
          <ReactTooltip id={"identity_ci_oidc_allowed_query_args_tooltip_id" + idPrefix} clickable={true} place="top" effect="solid" ><div style={{ maxWidth: 300 }}>Additional query string arguments can be provided to the authentication kick-off URL which will in turn be appended to the corresponding authentication request. This entry is used to define a list of allowed query string arguments. Any other arguments passed to the kick-off URL will be ignored.<br/></div></ReactTooltip>

                <div id={"identity_ci_oidc_allowed_query_argsTableDiv" + idPrefix} style={{marginLeft:"10px",marginBottom:"10px"}}>
                  <div className={"iag_form_elem identity_div" + idPrefix}>
                    <DataTable id={"identity_ci_oidc_allowed_query_argsTable" + idPrefix} isSortable
                        headers={identity_ci_oidc_allowed_query_argsheaderData}
                        rows={identity_ci_oidc_allowed_query_argsrowData.identity_ci_oidc_allowed_query_args}
                        render={({
                          rows,
                          headers,
                          getHeaderProps,
                          getRowProps,
                          getTableProps,
                          getToolbarProps,
                          onInputChange,
                          getTableContainerProps
                    }) => (
                      <TableContainer>
                        <TableToolbar aria-label="data table toolbar">
                          <TableToolbarContent>
                            <Button onClick={() => {identity_ci_oidc_allowed_query_argshandleAdd(idPrefix, [setidentity_ci_oidc_allowed_query_args_allowed_query_args(''),    setidentity_ci_oidc_allowed_query_args_allowed_query_args_valid(true),]);}}>Add</Button>
                          </TableToolbarContent>
                        </TableToolbar>
                        <Table size='normal' {...getTableProps()}>
                          <TableHead>
                            <TableRow>
                              {headers.map(header => (
                                <TableHeader {...getHeaderProps({ header })}>
                                  {header.header}
                                </TableHeader>
                              ))}
                              <TableHeader>
                                  Actions
                              </TableHeader>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {rows.map(row => (
                              <TableRow key={row.id}>
                                {row.cells.map(cell => (
                                  <TableCell key={cell.id}>{cell.value}</TableCell>
                                ))}
                                <TableCell>
                                  <Suspense fallback={<div></div>}>
                                    <IdentityciOidcallowedQueryArgsDeleteModal row={row} loadGrid={identity_ci_oidc_allowed_query_argsloadGrid} />
                                  </Suspense>
                                  <Suspense fallback={<div></div>}>
                                    <IdentityciOidcallowedQueryArgsEdit  data={identity_ci_oidc_allowed_query_argsrowData.identity_ci_oidc_allowed_query_args} setData={setDataMain} row={row} loadGrid={identity_ci_oidc_allowed_query_argsloadGrid} dataLoad={dataLoad} editing={true} name={"identity_ci_oidc_allowed_query_args"} idPrefix={idPrefix + "_edit"} parentIdPrefix={idPrefix} 
            updateidentity_ci_oidc_allowed_query_args_allowed_query_args={updateidentity_ci_oidc_allowed_query_args_allowed_query_args} identity_ci_oidc_allowed_query_args_allowed_query_args={identity_ci_oidc_allowed_query_args_allowed_query_args}
            identity_ci_oidc_allowed_query_args_allowed_query_args_valid={identity_ci_oidc_allowed_query_args_allowed_query_args_valid}
            identity_ci_oidc_allowed_query_args_allowed_query_args_invalid_text={identity_ci_oidc_allowed_query_args_allowed_query_args_invalid_text}
                                    />
                                  </Suspense>
                                </TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>)}
                    />
                  </div>
                </div>

                <div className= {"iag_form_elem identity_div" + idPrefix}>
  <h3 tabIndex="0"  data-tooltip-id={"identity_ci_oidc_bearer_token_attrs_tooltip_id" + idPrefix} >Bearer Token Attributes</h3><hr/>
</div>
          <ReactTooltip id={"identity_ci_oidc_bearer_token_attrs_tooltip_id" + idPrefix} clickable={true} place="top" effect="solid" ><div style={{ maxWidth: 300 }}>A list of JSON data elements from the bearer token response which should be included or excluded in the credential as an extended attribute. See the Bearer Token Attrs Format table for a  description of the expected format.<br/></div></ReactTooltip>

                <div id={"identity_ci_oidc_bearer_token_attrsTableDiv" + idPrefix} style={{marginLeft:"10px",marginBottom:"10px"}}>
                  <div className={"iag_form_elem identity_div" + idPrefix}>
                    <DataTable id={"identity_ci_oidc_bearer_token_attrsTable" + idPrefix} isSortable
                        headers={identity_ci_oidc_bearer_token_attrsheaderData}
                        rows={identity_ci_oidc_bearer_token_attrsrowData.identity_ci_oidc_bearer_token_attrs}
                        render={({
                          rows,
                          headers,
                          getHeaderProps,
                          getRowProps,
                          getTableProps,
                          getToolbarProps,
                          onInputChange,
                          getTableContainerProps
                    }) => (
                      <TableContainer>
                        <TableToolbar aria-label="data table toolbar">
                          <TableToolbarContent>
                            <Button onClick={() => {identity_ci_oidc_bearer_token_attrshandleAdd(idPrefix, [setidentity_ci_oidc_bearer_token_attrs_bearer_token_attrs(''),    setidentity_ci_oidc_bearer_token_attrs_bearer_token_attrs_valid(true),]);}}>Add</Button>
                          </TableToolbarContent>
                        </TableToolbar>
                        <Table size='normal' {...getTableProps()}>
                          <TableHead>
                            <TableRow>
                              {headers.map(header => (
                                <TableHeader {...getHeaderProps({ header })}>
                                  {header.header}
                                </TableHeader>
                              ))}
                              <TableHeader>
                                  Actions
                              </TableHeader>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {rows.map(row => (
                              <TableRow key={row.id}>
                                {row.cells.map(cell => (
                                  <TableCell key={cell.id}>{cell.value}</TableCell>
                                ))}
                                <TableCell>
                                  <Suspense fallback={<div></div>}>
                                    <IdentityciOidcbearerTokenAttrsDeleteModal row={row} loadGrid={identity_ci_oidc_bearer_token_attrsloadGrid} />
                                  </Suspense>
                                  <Suspense fallback={<div></div>}>
                                    <IdentityciOidcbearerTokenAttrsEdit  data={identity_ci_oidc_bearer_token_attrsrowData.identity_ci_oidc_bearer_token_attrs} setData={setDataMain} row={row} loadGrid={identity_ci_oidc_bearer_token_attrsloadGrid} dataLoad={dataLoad} editing={true} name={"identity_ci_oidc_bearer_token_attrs"} idPrefix={idPrefix + "_edit"} parentIdPrefix={idPrefix} 
            updateidentity_ci_oidc_bearer_token_attrs_bearer_token_attrs={updateidentity_ci_oidc_bearer_token_attrs_bearer_token_attrs} identity_ci_oidc_bearer_token_attrs_bearer_token_attrs={identity_ci_oidc_bearer_token_attrs_bearer_token_attrs}
            identity_ci_oidc_bearer_token_attrs_bearer_token_attrs_valid={identity_ci_oidc_bearer_token_attrs_bearer_token_attrs_valid}
            identity_ci_oidc_bearer_token_attrs_bearer_token_attrs_invalid_text={identity_ci_oidc_bearer_token_attrs_bearer_token_attrs_invalid_text}
                                    />
                                  </Suspense>
                                </TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>)}
                    />
                  </div>
                </div>

                <div className= {"iag_form_elem identity_div" + idPrefix}>
          <TextInput  value={identity_ci_oidc_client_id}  id={"identity_ci_oidc_client_id_id" + idPrefix}  data-tooltip-id={"identity_ci_oidc_client_id_tooltip_id" + idPrefix}  labelText="Client ID" onChange={(evt) => { updateidentity_ci_oidc_client_id(evt); handleChange(); }}/>
          <ReactTooltip id={"identity_ci_oidc_client_id_tooltip_id" + idPrefix} clickable={true} place="top" effect="solid" ><div style={{ maxWidth: 300 }}>The client identity registered with IBM Security Verify.<br/></div></ReactTooltip>
        </div>

                <div className= {"iag_form_elem identity_div" + idPrefix}>
          <TextInput  value={identity_ci_oidc_client_secret}  id={"identity_ci_oidc_client_secret_id" + idPrefix}  data-tooltip-id={"identity_ci_oidc_client_secret_tooltip_id" + idPrefix}  labelText="Client Secret" onChange={(evt) => { updateidentity_ci_oidc_client_secret(evt); handleChange(); }}/>
          <ReactTooltip id={"identity_ci_oidc_client_secret_tooltip_id" + idPrefix} clickable={true} place="top" effect="solid" ><div style={{ maxWidth: 300 }}>The client secret registered with IBM Security Verify.<br/></div></ReactTooltip>
        </div>

                <div className= {"iag_form_elem identity_div" + idPrefix}>
          <TextInput  value={identity_ci_oidc_hostname}  id={"identity_ci_oidc_hostname_id" + idPrefix}  data-tooltip-id={"identity_ci_oidc_hostname_tooltip_id" + idPrefix}  labelText="Hostname" onChange={(evt) => { updateidentity_ci_oidc_hostname(evt); handleChange(); }}/>
          <ReactTooltip id={"identity_ci_oidc_hostname_tooltip_id" + idPrefix} clickable={true} place="top" effect="solid" ><div style={{ maxWidth: 300 }}>The fully qualified host name of the IBM Security Verify tenant.<br/></div></ReactTooltip>
        </div>

                <div className= {"iag_form_elem identity_div" + idPrefix}>
  <h3 tabIndex="0"  data-tooltip-id={"identity_ci_oidc_id_token_attrs_tooltip_id" + idPrefix} >ID Token Attributes</h3><hr/>
</div>
          <ReactTooltip id={"identity_ci_oidc_id_token_attrs_tooltip_id" + idPrefix} clickable={true} place="top" effect="solid" ><div style={{ maxWidth: 300 }}>A list of claims from the ID token response which should be included or excluded in the credential as an extended attribute. See the  ID Token Attrs Format table for a description  of the expected format.<br/></div></ReactTooltip>

                <div id={"identity_ci_oidc_id_token_attrsTableDiv" + idPrefix} style={{marginLeft:"10px",marginBottom:"10px"}}>
                  <div className={"iag_form_elem identity_div" + idPrefix}>
                    <DataTable id={"identity_ci_oidc_id_token_attrsTable" + idPrefix} isSortable
                        headers={identity_ci_oidc_id_token_attrsheaderData}
                        rows={identity_ci_oidc_id_token_attrsrowData.identity_ci_oidc_id_token_attrs}
                        render={({
                          rows,
                          headers,
                          getHeaderProps,
                          getRowProps,
                          getTableProps,
                          getToolbarProps,
                          onInputChange,
                          getTableContainerProps
                    }) => (
                      <TableContainer>
                        <TableToolbar aria-label="data table toolbar">
                          <TableToolbarContent>
                            <Button onClick={() => {identity_ci_oidc_id_token_attrshandleAdd(idPrefix, [setidentity_ci_oidc_id_token_attrs_id_token_attrs(''),    setidentity_ci_oidc_id_token_attrs_id_token_attrs_valid(true),]);}}>Add</Button>
                          </TableToolbarContent>
                        </TableToolbar>
                        <Table size='normal' {...getTableProps()}>
                          <TableHead>
                            <TableRow>
                              {headers.map(header => (
                                <TableHeader {...getHeaderProps({ header })}>
                                  {header.header}
                                </TableHeader>
                              ))}
                              <TableHeader>
                                  Actions
                              </TableHeader>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {rows.map(row => (
                              <TableRow key={row.id}>
                                {row.cells.map(cell => (
                                  <TableCell key={cell.id}>{cell.value}</TableCell>
                                ))}
                                <TableCell>
                                  <Suspense fallback={<div></div>}>
                                    <IdentityciOidcidTokenAttrsDeleteModal row={row} loadGrid={identity_ci_oidc_id_token_attrsloadGrid} />
                                  </Suspense>
                                  <Suspense fallback={<div></div>}>
                                    <IdentityciOidcidTokenAttrsEdit  data={identity_ci_oidc_id_token_attrsrowData.identity_ci_oidc_id_token_attrs} setData={setDataMain} row={row} loadGrid={identity_ci_oidc_id_token_attrsloadGrid} dataLoad={dataLoad} editing={true} name={"identity_ci_oidc_id_token_attrs"} idPrefix={idPrefix + "_edit"} parentIdPrefix={idPrefix} 
            updateidentity_ci_oidc_id_token_attrs_id_token_attrs={updateidentity_ci_oidc_id_token_attrs_id_token_attrs} identity_ci_oidc_id_token_attrs_id_token_attrs={identity_ci_oidc_id_token_attrs_id_token_attrs}
            identity_ci_oidc_id_token_attrs_id_token_attrs_valid={identity_ci_oidc_id_token_attrs_id_token_attrs_valid}
            identity_ci_oidc_id_token_attrs_id_token_attrs_invalid_text={identity_ci_oidc_id_token_attrs_id_token_attrs_invalid_text}
                                    />
                                  </Suspense>
                                </TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>)}
                    />
                  </div>
                </div>

                <div className= {"iag_form_elem identity_div" + idPrefix}>
          <TextInput  value={identity_ci_oidc_mapped_identity}  id={"identity_ci_oidc_mapped_identity_id" + idPrefix}  data-tooltip-id={"identity_ci_oidc_mapped_identity_tooltip_id" + idPrefix}  labelText="Mapped Identity" onChange={(evt) => { updateidentity_ci_oidc_mapped_identity(evt); handleChange(); }}/>
          <ReactTooltip id={"identity_ci_oidc_mapped_identity_tooltip_id" + idPrefix} clickable={true} place="top" effect="solid" ><div style={{ maxWidth: 300 }}>A formatted string which is used to construct the credential principal name from elements of the ID token. Claims can be added to the identity string, surrounded by `&#123;}`, for example:<br/>  &#123;iss}/&#123;sub} - would construct a principal name like the following:<br/>  https://server.example.com/248289761001<br/></div></ReactTooltip>
        </div>

                <div className= {"iag_form_elem identity_div" + idPrefix}>
          <TextInput  value={identity_ci_oidc_proxy}  id={"identity_ci_oidc_proxy_id" + idPrefix}  data-tooltip-id={"identity_ci_oidc_proxy_tooltip_id" + idPrefix}  labelText="Proxy" onChange={(evt) => { updateidentity_ci_oidc_proxy(evt); handleChange(); }}/>
          <ReactTooltip id={"identity_ci_oidc_proxy_tooltip_id" + idPrefix} clickable={true} place="top" effect="solid" ><div style={{ maxWidth: 300 }}>Specifies the proxy, if any, which is used to reach IBM Security Verify. The proxy configuration entry should be in URL format. Eg: `http[s]://&lt;address&gt;:&lt;port&gt;`<br/></div></ReactTooltip>
        </div>

                <div className= {"iag_form_elem identity_div" + idPrefix}>
          <TextInput  value={identity_ci_oidc_redirect_uri_host}  id={"identity_ci_oidc_redirect_uri_host_id" + idPrefix}  data-tooltip-id={"identity_ci_oidc_redirect_uri_host_tooltip_id" + idPrefix}  labelText="Redirect URI Host" onChange={(evt) => { updateidentity_ci_oidc_redirect_uri_host(evt); handleChange(); }}/>
          <ReactTooltip id={"identity_ci_oidc_redirect_uri_host_tooltip_id" + idPrefix} clickable={true} place="top" effect="solid" ><div style={{ maxWidth: 300 }}>This is the host which is used in the redirect URI registered with the OIDC OP. If no redirect URI host is configured the host header from the request will be used. The format of the redirect URI will be: `http[s]://&lt;host&gt;/pkmsoidc`.<br/></div></ReactTooltip>
        </div>

                <div className= {"iag_form_elem identity_div" + idPrefix}>
                <Select
                  value={identity_ci_oidc_response_mode}
                   id={"identity_ci_oidc_response_mode_id" + idPrefix}
 data-tooltip-id={"identity_ci_oidc_response_mode_tooltip_id" + idPrefix}                   labelText="Response Mode"
                  onChange={(evt) => { updateidentity_ci_oidc_response_mode(evt); handleChange(); }}>
                  <SelectItem text="" value="" />
                  <SelectItem text="query" value="query" />
                  <SelectItem text="fragment" value="fragment" />
                  <SelectItem text="form_post" value="form_post" />
                </Select>
          <ReactTooltip id={"identity_ci_oidc_response_mode_tooltip_id" + idPrefix} clickable={true} place="top" effect="solid" ><div style={{ maxWidth: 300 }}>The required response mode for authentication responses. If no response mode is configured the response mode parameter will not be included in the authentication request.<br/></div></ReactTooltip>
                </div>

                <div className= {"iag_form_elem identity_div" + idPrefix}>
                <Select
                  value={identity_ci_oidc_response_type}
                   id={"identity_ci_oidc_response_type_id" + idPrefix}
 data-tooltip-id={"identity_ci_oidc_response_type_tooltip_id" + idPrefix}                   labelText="Response Type"
                  onChange={(evt) => { updateidentity_ci_oidc_response_type(evt); handleChange(); }}>
                  <SelectItem text="" value="" />
                  <SelectItem text="code" value="code" />
                  <SelectItem text="id_token" value="id_token" />
                  <SelectItem text="id_token token" value="id_token token" />
                </Select>
          <ReactTooltip id={"identity_ci_oidc_response_type_tooltip_id" + idPrefix} clickable={true} place="top" effect="solid" ><div style={{ maxWidth: 300 }}>The required response type for authentication responses. See the Response Type Values table for a description  of the available values.<br/></div></ReactTooltip>
                </div>

                <div className= {"iag_form_elem identity_div" + idPrefix}>
  <h3 tabIndex="0"  data-tooltip-id={"identity_ci_oidc_scopes_tooltip_id" + idPrefix} >Scopes</h3><hr/>
</div>
          <ReactTooltip id={"identity_ci_oidc_scopes_tooltip_id" + idPrefix} clickable={true} place="top" effect="solid" ><div style={{ maxWidth: 300 }}>Any scopes to be sent in the authentication request in addition to the `openid` scope.<br/></div></ReactTooltip>

                <div id={"identity_ci_oidc_scopesTableDiv" + idPrefix} style={{marginLeft:"10px",marginBottom:"10px"}}>
                  <div className={"iag_form_elem identity_div" + idPrefix}>
                    <DataTable id={"identity_ci_oidc_scopesTable" + idPrefix} isSortable
                        headers={identity_ci_oidc_scopesheaderData}
                        rows={identity_ci_oidc_scopesrowData.identity_ci_oidc_scopes}
                        render={({
                          rows,
                          headers,
                          getHeaderProps,
                          getRowProps,
                          getTableProps,
                          getToolbarProps,
                          onInputChange,
                          getTableContainerProps
                    }) => (
                      <TableContainer>
                        <TableToolbar aria-label="data table toolbar">
                          <TableToolbarContent>
                            <Button onClick={() => {identity_ci_oidc_scopeshandleAdd(idPrefix, [setidentity_ci_oidc_scopes_scopes(''),    setidentity_ci_oidc_scopes_scopes_valid(true),]);}}>Add</Button>
                          </TableToolbarContent>
                        </TableToolbar>
                        <Table size='normal' {...getTableProps()}>
                          <TableHead>
                            <TableRow>
                              {headers.map(header => (
                                <TableHeader {...getHeaderProps({ header })}>
                                  {header.header}
                                </TableHeader>
                              ))}
                              <TableHeader>
                                  Actions
                              </TableHeader>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {rows.map(row => (
                              <TableRow key={row.id}>
                                {row.cells.map(cell => (
                                  <TableCell key={cell.id}>{cell.value}</TableCell>
                                ))}
                                <TableCell>
                                  <Suspense fallback={<div></div>}>
                                    <IdentityciOidcscopesDeleteModal row={row} loadGrid={identity_ci_oidc_scopesloadGrid} />
                                  </Suspense>
                                  <Suspense fallback={<div></div>}>
                                    <IdentityciOidcscopesEdit  data={identity_ci_oidc_scopesrowData.identity_ci_oidc_scopes} setData={setDataMain} row={row} loadGrid={identity_ci_oidc_scopesloadGrid} dataLoad={dataLoad} editing={true} name={"identity_ci_oidc_scopes"} idPrefix={idPrefix + "_edit"} parentIdPrefix={idPrefix} 
            updateidentity_ci_oidc_scopes_scopes={updateidentity_ci_oidc_scopes_scopes} identity_ci_oidc_scopes_scopes={identity_ci_oidc_scopes_scopes}
            identity_ci_oidc_scopes_scopes_valid={identity_ci_oidc_scopes_scopes_valid}
            identity_ci_oidc_scopes_scopes_invalid_text={identity_ci_oidc_scopes_scopes_invalid_text}
                                    />
                                  </Suspense>
                                </TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>)}
                    />
                  </div>
                </div>

                </div>
              </TabPanel>
              <TabPanel style={{width:'100%', overflow:'auto'}} tabId={"eai_tab" + idPrefix}>
                <div className= {"iag_form_elem iag_tab_heading identity_div" + idPrefix}>
                  <span className="iag_breadcrumb">Identity : </span><br/>                  <h2>EAI Settings</h2><hr/>
                  <Collapsible tabIndex="0" trigger="External Authentication Interface, which allows an application to assert client identity information to the IBM Application Gateway container">
                    <p>External Authentication Interface, which allows an application to assert client identity information to the IBM Application Gateway container.<br/>Please note that an access policy which allows unauthenticated access to this resource must be created. The URL string patterns are case-sensitive and may contain wild card patterns.<br/><br/>The format for a regular path-based application is: `&lt;URL pattern&gt;`<br/>The format for a Virtual Host application is: `http[s]://virtual-host-name[:port]/&lt;URL pattern&gt;`<br/>For Virtual Host applications to match a trigger they must also have the same protocol (http[s] = TCP/SSL) and have the same `virtual-host-name` and `port` as the trigger.</p>
                  </Collapsible>

                </div>
                <div className={"iag--simple-div identity_div" + idPrefix}>
                <div className= {"iag_form_elem identity_div" + idPrefix}>
  <h3 tabIndex="0"  data-tooltip-id={"identity_eai_triggers_tooltip_id" + idPrefix} >Triggers</h3><hr/>
</div>
          <ReactTooltip id={"identity_eai_triggers_tooltip_id" + idPrefix} clickable={true} place="top" effect="solid" ><div style={{ maxWidth: 300 }}>The list of URLs for which the response could potentially contain authentication information.<br/></div></ReactTooltip>

                <div id={"identity_eai_triggersTableDiv" + idPrefix} style={{marginLeft:"10px",marginBottom:"10px"}}>
                  <div className={"iag_form_elem identity_div" + idPrefix}>
                    <DataTable id={"identity_eai_triggersTable" + idPrefix} isSortable
                        headers={identity_eai_triggersheaderData}
                        rows={identity_eai_triggersrowData.identity_eai_triggers}
                        render={({
                          rows,
                          headers,
                          getHeaderProps,
                          getRowProps,
                          getTableProps,
                          getToolbarProps,
                          onInputChange,
                          getTableContainerProps
                    }) => (
                      <TableContainer>
                        <TableToolbar aria-label="data table toolbar">
                          <TableToolbarContent>
                            <Button onClick={() => {identity_eai_triggershandleAdd(idPrefix, [setidentity_eai_triggers_triggers(''),    setidentity_eai_triggers_triggers_valid(true),]);}}>Add</Button>
                          </TableToolbarContent>
                        </TableToolbar>
                        <Table size='normal' {...getTableProps()}>
                          <TableHead>
                            <TableRow>
                              {headers.map(header => (
                                <TableHeader {...getHeaderProps({ header })}>
                                  {header.header}
                                </TableHeader>
                              ))}
                              <TableHeader>
                                  Actions
                              </TableHeader>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {rows.map(row => (
                              <TableRow key={row.id}>
                                {row.cells.map(cell => (
                                  <TableCell key={cell.id}>{cell.value}</TableCell>
                                ))}
                                <TableCell>
                                  <Suspense fallback={<div></div>}>
                                    <IdentityeaitriggersDeleteModal row={row} loadGrid={identity_eai_triggersloadGrid} />
                                  </Suspense>
                                  <Suspense fallback={<div></div>}>
                                    <IdentityeaitriggersEdit  data={identity_eai_triggersrowData.identity_eai_triggers} setData={setDataMain} row={row} loadGrid={identity_eai_triggersloadGrid} dataLoad={dataLoad} editing={true} name={"identity_eai_triggers"} idPrefix={idPrefix + "_edit"} parentIdPrefix={idPrefix} 
            updateidentity_eai_triggers_triggers={updateidentity_eai_triggers_triggers} identity_eai_triggers_triggers={identity_eai_triggers_triggers}
            identity_eai_triggers_triggers_valid={identity_eai_triggers_triggers_valid}
            identity_eai_triggers_triggers_invalid_text={identity_eai_triggers_triggers_invalid_text}
                                    />
                                  </Suspense>
                                </TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>)}
                    />
                  </div>
                </div>

                </div>
              </TabPanel>
              <TabPanel style={{width:'100%', overflow:'auto'}} tabId={"oidc_tab" + idPrefix}>
                <div className= {"iag_form_elem iag_tab_heading identity_div" + idPrefix}>
                  <span className="iag_breadcrumb">Identity : </span><br/>                  <h2>Oidc Settings</h2><hr/>
                </div>
                <div className={"iag--simple-div identity_div" + idPrefix}>
                <div className= {"iag_form_elem identity_div" + idPrefix}>
  <h3 tabIndex="0"  data-tooltip-id={"identity_oidc_tooltip_id" + idPrefix} >Oidc</h3><hr/>
</div>
          <ReactTooltip id={"identity_oidc_tooltip_id" + idPrefix} clickable={true} place="top" effect="solid" ><div style={{ maxWidth: 300 }}><br/></div></ReactTooltip>

                <div id={"identity_oidcTableDiv" + idPrefix} style={{marginLeft:"10px",marginBottom:"10px"}}>
                  <div className={"iag_form_elem identity_div" + idPrefix}>
                    <DataTable id={"identity_oidcTable" + idPrefix} isSortable
                        headers={identity_oidcheaderData}
                        rows={identity_oidcrowData.identity_oidc}
                        render={({
                          rows,
                          headers,
                          getHeaderProps,
                          getRowProps,
                          getTableProps,
                          getToolbarProps,
                          onInputChange,
                          getTableContainerProps
                    }) => (
                      <TableContainer>
                        <TableToolbar aria-label="data table toolbar">
                          <TableToolbarContent>
                            <Button onClick={() => {identity_oidchandleAdd(idPrefix, [setidentity_oidc_client_id(''),    setidentity_oidc_client_secret(''),    setidentity_oidc_discovery_endpoint(''),    setidentity_oidc_discovery_endpoint_valid(true),    setidentity_oidc_mapped_identity('{sub}'),    setidentity_oidc_name('default'),    setidentity_oidc_pkce(),    setidentity_oidc_proxy(''),    setidentity_oidc_redirect_uri_host(''),    setidentity_oidc_response_mode(''),    setidentity_oidc_response_type('code'),]);}}>Add</Button>
                          </TableToolbarContent>
                        </TableToolbar>
                        <Table size='normal' {...getTableProps()}>
                          <TableHead>
                            <TableRow>
                              {headers.map(header => (
                                <TableHeader {...getHeaderProps({ header })}>
                                  {header.header}
                                </TableHeader>
                              ))}
                              <TableHeader>
                                  Actions
                              </TableHeader>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {rows.map(row => (
                              <TableRow key={row.id}>
                                {row.cells.map(cell => (
                                  <TableCell key={cell.id}>{cell.value}</TableCell>
                                ))}
                                <TableCell>
                                  <Suspense fallback={<div></div>}>
                                    <IdentityoidcDeleteModal row={row} loadGrid={identity_oidcloadGrid} />
                                  </Suspense>
                                  <Suspense fallback={<div></div>}>
                                    <IdentityoidcEdit  data={identity_oidcrowData.identity_oidc} setData={setDataMain} row={row} loadGrid={identity_oidcloadGrid} dataLoad={dataLoad} editing={true} name={"identity_oidc"} idPrefix={idPrefix + "_edit"} parentIdPrefix={idPrefix} 
            updateidentity_oidc_client_id={updateidentity_oidc_client_id} identity_oidc_client_id={identity_oidc_client_id}
            updateidentity_oidc_client_secret={updateidentity_oidc_client_secret} identity_oidc_client_secret={identity_oidc_client_secret}
            updateidentity_oidc_discovery_endpoint={updateidentity_oidc_discovery_endpoint} identity_oidc_discovery_endpoint={identity_oidc_discovery_endpoint}
            identity_oidc_discovery_endpoint_valid={identity_oidc_discovery_endpoint_valid}
            identity_oidc_discovery_endpoint_invalid_text={identity_oidc_discovery_endpoint_invalid_text}
            updateidentity_oidc_mapped_identity={updateidentity_oidc_mapped_identity} identity_oidc_mapped_identity={identity_oidc_mapped_identity}
            updateidentity_oidc_name={updateidentity_oidc_name} identity_oidc_name={identity_oidc_name}
            updateidentity_oidc_pkce={updateidentity_oidc_pkce} identity_oidc_pkce={identity_oidc_pkce}
            updateidentity_oidc_proxy={updateidentity_oidc_proxy} identity_oidc_proxy={identity_oidc_proxy}
            updateidentity_oidc_redirect_uri_host={updateidentity_oidc_redirect_uri_host} identity_oidc_redirect_uri_host={identity_oidc_redirect_uri_host}
            updateidentity_oidc_response_mode={updateidentity_oidc_response_mode} identity_oidc_response_mode={identity_oidc_response_mode}
            updateidentity_oidc_response_type={updateidentity_oidc_response_type} identity_oidc_response_type={identity_oidc_response_type}
                                    />
                                  </Suspense>
                                </TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>)}
                    />
                  </div>
                </div>

                </div>
              </TabPanel>
              <TabPanel style={{width:'100%', overflow:'auto'}} tabId={"oauth_tab" + idPrefix}>
                <div className= {"iag_form_elem iag_tab_heading identity_div" + idPrefix}>
                  <span className="iag_breadcrumb">Identity : </span><br/>                  <h2>OAuth Settings</h2><hr/>
                </div>
                <div className={"iag--simple-div identity_div" + idPrefix}>
                <div className= {"iag_form_elem identity_div" + idPrefix}>
  <h3 tabIndex="0"  data-tooltip-id={"identity_oauth_tooltip_id" + idPrefix} >OAuth</h3><hr/>
</div>
          <ReactTooltip id={"identity_oauth_tooltip_id" + idPrefix} clickable={true} place="top" effect="solid" class="tooltipScroll" delayHide={500}><div style={{ maxWidth: '50vw', maxHeight: 300, overflowY: 'scroll' }}>The configuration entries in this section allow the reverse proxy to accept an OAuth bearer token and use the configured OAuth introspection endpoints to validate the token and create an authenticated session.<br/>IBM Security Verify, IBM Security Verify Access and IBM Security Access Manager 9.0.7.0+ provide supported OAuth introspection endpoints.<br/>Multiple introspection endpoints may be different so that different providers can be enabled for different resource servers.<br/><br/><h4> Attributes Format</h4><br/>A JSON data element from the introspection response token which should be included or excluded in the credential as an extended attribute.<br/>The format of the configuration entry is:<br/><br/><table style={{textAlign:'left', border:'1px solid black'}}><tbody><tr style={{textAlign:'left', border:'1px solid black'}}><th style={{borderRight:'1px solid black', padding: '10px'}}>`[+</th><th style={{borderRight:'1px solid black', padding: '10px'}}>-]&lt;json-data&gt;`</th></tr></tbody></table><br/>where:<br/><br/><table style={{textAlign:'left', border:'1px solid black'}}><tbody><tr style={{textAlign:'left', border:'1px solid black'}}><th style={{borderRight:'1px solid black', padding: '10px'}}>Element </th><th style={{borderRight:'1px solid black', padding: '10px'}}> Description</th></tr><tr><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}>+ </td><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> Indicates that this JSON data should be added to the credential.</td></tr><tr><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}>- </td><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> Indicates that this JSON data should not be added to the credential.</td></tr><tr><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}>&lt;json-data&gt; </td><td style={{borderRight:'1px solid black', paddingLeft: '10px'}}> The corresponding JSON data name, which can also contain pattern matching characters (i.e. * ?).</td></tr></tbody></table><br/>For example the value "-exp" indicates that the expiry time of the token should not be added to the credential.<br/><br/>When an introspection response token is received each JSON data element will be evaluated against each rule in sequence until a match is found.<br/>The corresponding code (+|-) will then be used to determine whether the JSON data will be added to the credential or not.<br/>If the JSON data name does not match a configured rule it will by default be added to the credential.<br/></div></ReactTooltip>

                <div id={"identity_oauthTableDiv" + idPrefix} style={{marginLeft:"10px",marginBottom:"10px"}}>
                  <div className={"iag_form_elem identity_div" + idPrefix}>
                    <DataTable id={"identity_oauthTable" + idPrefix} isSortable
                        headers={identity_oauthheaderData}
                        rows={identity_oauthrowData.identity_oauth}
                        render={({
                          rows,
                          headers,
                          getHeaderProps,
                          getRowProps,
                          getTableProps,
                          getToolbarProps,
                          onInputChange,
                          getTableContainerProps
                    }) => (
                      <TableContainer>
                        <TableToolbar aria-label="data table toolbar">
                          <TableToolbarContent>
                            <Button onClick={() => {identity_oauthhandleAdd(idPrefix, [setidentity_oauth_auth_method('client_secret_post'),    setidentity_oauth_client_id(''),    setidentity_oauth_client_id_hdr(''),    setidentity_oauth_client_secret(''),    setidentity_oauth_introspection_endpoint(''),    setidentity_oauth_mapped_identity('{sub}'),    setidentity_oauth_multi_valued_scope(true),    setidentity_oauth_name(''),    setidentity_oauth_name_valid(true),    setidentity_oauth_proxy(''),    setidentity_oauth_restricted(false),    setidentity_oauth_token_type_hint('access_token'),]);}}>Add</Button>
                          </TableToolbarContent>
                        </TableToolbar>
                        <Table size='normal' {...getTableProps()}>
                          <TableHead>
                            <TableRow>
                              {headers.map(header => (
                                <TableHeader {...getHeaderProps({ header })}>
                                  {header.header}
                                </TableHeader>
                              ))}
                              <TableHeader>
                                  Actions
                              </TableHeader>
                            </TableRow>
                          </TableHead>
                          <TableBody>
                            {rows.map(row => (
                              <TableRow key={row.id}>
                                {row.cells.map(cell => (
                                  <TableCell key={cell.id}>{cell.value}</TableCell>
                                ))}
                                <TableCell>
                                  <Suspense fallback={<div></div>}>
                                    <IdentityoauthDeleteModal row={row} loadGrid={identity_oauthloadGrid} />
                                  </Suspense>
                                  <Suspense fallback={<div></div>}>
                                    <IdentityoauthEdit  data={identity_oauthrowData.identity_oauth} setData={setDataMain} row={row} loadGrid={identity_oauthloadGrid} dataLoad={dataLoad} editing={true} name={"identity_oauth"} idPrefix={idPrefix + "_edit"} parentIdPrefix={idPrefix} 
            updateidentity_oauth_auth_method={updateidentity_oauth_auth_method} identity_oauth_auth_method={identity_oauth_auth_method}
            updateidentity_oauth_client_id={updateidentity_oauth_client_id} identity_oauth_client_id={identity_oauth_client_id}
            updateidentity_oauth_client_id_hdr={updateidentity_oauth_client_id_hdr} identity_oauth_client_id_hdr={identity_oauth_client_id_hdr}
            updateidentity_oauth_client_secret={updateidentity_oauth_client_secret} identity_oauth_client_secret={identity_oauth_client_secret}
            updateidentity_oauth_introspection_endpoint={updateidentity_oauth_introspection_endpoint} identity_oauth_introspection_endpoint={identity_oauth_introspection_endpoint}
            updateidentity_oauth_mapped_identity={updateidentity_oauth_mapped_identity} identity_oauth_mapped_identity={identity_oauth_mapped_identity}
            updateidentity_oauth_multi_valued_scope={updateidentity_oauth_multi_valued_scope} identity_oauth_multi_valued_scope={identity_oauth_multi_valued_scope}
            updateidentity_oauth_name={updateidentity_oauth_name} identity_oauth_name={identity_oauth_name}
            identity_oauth_name_valid={identity_oauth_name_valid}
            identity_oauth_name_invalid_text={identity_oauth_name_invalid_text}
            updateidentity_oauth_proxy={updateidentity_oauth_proxy} identity_oauth_proxy={identity_oauth_proxy}
            updateidentity_oauth_restricted={updateidentity_oauth_restricted} identity_oauth_restricted={identity_oauth_restricted}
            updateidentity_oauth_token_type_hint={updateidentity_oauth_token_type_hint} identity_oauth_token_type_hint={identity_oauth_token_type_hint}
                                    />
                                  </Suspense>
                                </TableCell>
                              </TableRow>
                            ))}
                          </TableBody>
                        </Table>
                      </TableContainer>)}
                    />
                  </div>
                </div>

                </div>
              </TabPanel>
            </Tabs>
                  <Suspense fallback={<div></div>}>
                    <IdentityauthChallengeRedirectparametersAdd loadGrid={identity_auth_challenge_redirect_parametersloadGrid} doClose={() => {closeAdd(idPrefix);}} idPrefix={idPrefix} 
            updateidentity_auth_challenge_redirect_parameters_name={updateidentity_auth_challenge_redirect_parameters_name} identity_auth_challenge_redirect_parameters_name={identity_auth_challenge_redirect_parameters_name}
            updateidentity_auth_challenge_redirect_parameters_source={updateidentity_auth_challenge_redirect_parameters_source} identity_auth_challenge_redirect_parameters_source={identity_auth_challenge_redirect_parameters_source}
            identity_auth_challenge_redirect_parameters_source_valid={identity_auth_challenge_redirect_parameters_source_valid}
            identity_auth_challenge_redirect_parameters_source_invalid_text={identity_auth_challenge_redirect_parameters_source_invalid_text}
            updateidentity_auth_challenge_redirect_parameters_value={updateidentity_auth_challenge_redirect_parameters_value} identity_auth_challenge_redirect_parameters_value={identity_auth_challenge_redirect_parameters_value}
            identity_auth_challenge_redirect_parameters_value_valid={identity_auth_challenge_redirect_parameters_value_valid}
            identity_auth_challenge_redirect_parameters_value_invalid_text={identity_auth_challenge_redirect_parameters_value_invalid_text}
                    />
                  </Suspense>
                  <Suspense fallback={<div></div>}>
                    <IdentityauthChallengeRedirectparametersEdit  loadGrid={identity_auth_challenge_redirect_parametersloadGrid} dataLoad={dataLoad} name={"identity_auth_challenge_redirect_parameters"} idPrefix={idPrefix + "_edit"} parentIdPrefix={idPrefix} 
            updateidentity_auth_challenge_redirect_parameters_name={updateidentity_auth_challenge_redirect_parameters_name} identity_auth_challenge_redirect_parameters_name={identity_auth_challenge_redirect_parameters_name}
            updateidentity_auth_challenge_redirect_parameters_source={updateidentity_auth_challenge_redirect_parameters_source} identity_auth_challenge_redirect_parameters_source={identity_auth_challenge_redirect_parameters_source}
            identity_auth_challenge_redirect_parameters_source_valid={identity_auth_challenge_redirect_parameters_source_valid}
            identity_auth_challenge_redirect_parameters_source_invalid_text={identity_auth_challenge_redirect_parameters_source_invalid_text}
            updateidentity_auth_challenge_redirect_parameters_value={updateidentity_auth_challenge_redirect_parameters_value} identity_auth_challenge_redirect_parameters_value={identity_auth_challenge_redirect_parameters_value}
            identity_auth_challenge_redirect_parameters_value_valid={identity_auth_challenge_redirect_parameters_value_valid}
            identity_auth_challenge_redirect_parameters_value_invalid_text={identity_auth_challenge_redirect_parameters_value_invalid_text}
                    />
                  </Suspense>
                  <Suspense fallback={<div></div>}>
                    <IdentityauthCompleteRedirectparametersAdd loadGrid={identity_auth_complete_redirect_parametersloadGrid} doClose={() => {closeAdd(idPrefix);}} idPrefix={idPrefix} 
            updateidentity_auth_complete_redirect_parameters_name={updateidentity_auth_complete_redirect_parameters_name} identity_auth_complete_redirect_parameters_name={identity_auth_complete_redirect_parameters_name}
            updateidentity_auth_complete_redirect_parameters_source={updateidentity_auth_complete_redirect_parameters_source} identity_auth_complete_redirect_parameters_source={identity_auth_complete_redirect_parameters_source}
            identity_auth_complete_redirect_parameters_source_valid={identity_auth_complete_redirect_parameters_source_valid}
            identity_auth_complete_redirect_parameters_source_invalid_text={identity_auth_complete_redirect_parameters_source_invalid_text}
            updateidentity_auth_complete_redirect_parameters_value={updateidentity_auth_complete_redirect_parameters_value} identity_auth_complete_redirect_parameters_value={identity_auth_complete_redirect_parameters_value}
            identity_auth_complete_redirect_parameters_value_valid={identity_auth_complete_redirect_parameters_value_valid}
            identity_auth_complete_redirect_parameters_value_invalid_text={identity_auth_complete_redirect_parameters_value_invalid_text}
                    />
                  </Suspense>
                  <Suspense fallback={<div></div>}>
                    <IdentityauthCompleteRedirectparametersEdit  loadGrid={identity_auth_complete_redirect_parametersloadGrid} dataLoad={dataLoad} name={"identity_auth_complete_redirect_parameters"} idPrefix={idPrefix + "_edit"} parentIdPrefix={idPrefix} 
            updateidentity_auth_complete_redirect_parameters_name={updateidentity_auth_complete_redirect_parameters_name} identity_auth_complete_redirect_parameters_name={identity_auth_complete_redirect_parameters_name}
            updateidentity_auth_complete_redirect_parameters_source={updateidentity_auth_complete_redirect_parameters_source} identity_auth_complete_redirect_parameters_source={identity_auth_complete_redirect_parameters_source}
            identity_auth_complete_redirect_parameters_source_valid={identity_auth_complete_redirect_parameters_source_valid}
            identity_auth_complete_redirect_parameters_source_invalid_text={identity_auth_complete_redirect_parameters_source_invalid_text}
            updateidentity_auth_complete_redirect_parameters_value={updateidentity_auth_complete_redirect_parameters_value} identity_auth_complete_redirect_parameters_value={identity_auth_complete_redirect_parameters_value}
            identity_auth_complete_redirect_parameters_value_valid={identity_auth_complete_redirect_parameters_value_valid}
            identity_auth_complete_redirect_parameters_value_invalid_text={identity_auth_complete_redirect_parameters_value_invalid_text}
                    />
                  </Suspense>
                  <Suspense fallback={<div></div>}>
                    <IdentityciOidcallowedQueryArgsAdd loadGrid={identity_ci_oidc_allowed_query_argsloadGrid} doClose={() => {closeAdd(idPrefix);}} idPrefix={idPrefix} 
            updateidentity_ci_oidc_allowed_query_args_allowed_query_args={updateidentity_ci_oidc_allowed_query_args_allowed_query_args} identity_ci_oidc_allowed_query_args_allowed_query_args={identity_ci_oidc_allowed_query_args_allowed_query_args}
            identity_ci_oidc_allowed_query_args_allowed_query_args_valid={identity_ci_oidc_allowed_query_args_allowed_query_args_valid}
            identity_ci_oidc_allowed_query_args_allowed_query_args_invalid_text={identity_ci_oidc_allowed_query_args_allowed_query_args_invalid_text}
                    />
                  </Suspense>
                  <Suspense fallback={<div></div>}>
                    <IdentityciOidcallowedQueryArgsEdit  loadGrid={identity_ci_oidc_allowed_query_argsloadGrid} dataLoad={dataLoad} name={"identity_ci_oidc_allowed_query_args"} idPrefix={idPrefix + "_edit"} parentIdPrefix={idPrefix} 
            updateidentity_ci_oidc_allowed_query_args_allowed_query_args={updateidentity_ci_oidc_allowed_query_args_allowed_query_args} identity_ci_oidc_allowed_query_args_allowed_query_args={identity_ci_oidc_allowed_query_args_allowed_query_args}
            identity_ci_oidc_allowed_query_args_allowed_query_args_valid={identity_ci_oidc_allowed_query_args_allowed_query_args_valid}
            identity_ci_oidc_allowed_query_args_allowed_query_args_invalid_text={identity_ci_oidc_allowed_query_args_allowed_query_args_invalid_text}
                    />
                  </Suspense>
                  <Suspense fallback={<div></div>}>
                    <IdentityciOidcbearerTokenAttrsAdd loadGrid={identity_ci_oidc_bearer_token_attrsloadGrid} doClose={() => {closeAdd(idPrefix);}} idPrefix={idPrefix} 
            updateidentity_ci_oidc_bearer_token_attrs_bearer_token_attrs={updateidentity_ci_oidc_bearer_token_attrs_bearer_token_attrs} identity_ci_oidc_bearer_token_attrs_bearer_token_attrs={identity_ci_oidc_bearer_token_attrs_bearer_token_attrs}
            identity_ci_oidc_bearer_token_attrs_bearer_token_attrs_valid={identity_ci_oidc_bearer_token_attrs_bearer_token_attrs_valid}
            identity_ci_oidc_bearer_token_attrs_bearer_token_attrs_invalid_text={identity_ci_oidc_bearer_token_attrs_bearer_token_attrs_invalid_text}
                    />
                  </Suspense>
                  <Suspense fallback={<div></div>}>
                    <IdentityciOidcbearerTokenAttrsEdit  loadGrid={identity_ci_oidc_bearer_token_attrsloadGrid} dataLoad={dataLoad} name={"identity_ci_oidc_bearer_token_attrs"} idPrefix={idPrefix + "_edit"} parentIdPrefix={idPrefix} 
            updateidentity_ci_oidc_bearer_token_attrs_bearer_token_attrs={updateidentity_ci_oidc_bearer_token_attrs_bearer_token_attrs} identity_ci_oidc_bearer_token_attrs_bearer_token_attrs={identity_ci_oidc_bearer_token_attrs_bearer_token_attrs}
            identity_ci_oidc_bearer_token_attrs_bearer_token_attrs_valid={identity_ci_oidc_bearer_token_attrs_bearer_token_attrs_valid}
            identity_ci_oidc_bearer_token_attrs_bearer_token_attrs_invalid_text={identity_ci_oidc_bearer_token_attrs_bearer_token_attrs_invalid_text}
                    />
                  </Suspense>
                  <Suspense fallback={<div></div>}>
                    <IdentityciOidcidTokenAttrsAdd loadGrid={identity_ci_oidc_id_token_attrsloadGrid} doClose={() => {closeAdd(idPrefix);}} idPrefix={idPrefix} 
            updateidentity_ci_oidc_id_token_attrs_id_token_attrs={updateidentity_ci_oidc_id_token_attrs_id_token_attrs} identity_ci_oidc_id_token_attrs_id_token_attrs={identity_ci_oidc_id_token_attrs_id_token_attrs}
            identity_ci_oidc_id_token_attrs_id_token_attrs_valid={identity_ci_oidc_id_token_attrs_id_token_attrs_valid}
            identity_ci_oidc_id_token_attrs_id_token_attrs_invalid_text={identity_ci_oidc_id_token_attrs_id_token_attrs_invalid_text}
                    />
                  </Suspense>
                  <Suspense fallback={<div></div>}>
                    <IdentityciOidcidTokenAttrsEdit  loadGrid={identity_ci_oidc_id_token_attrsloadGrid} dataLoad={dataLoad} name={"identity_ci_oidc_id_token_attrs"} idPrefix={idPrefix + "_edit"} parentIdPrefix={idPrefix} 
            updateidentity_ci_oidc_id_token_attrs_id_token_attrs={updateidentity_ci_oidc_id_token_attrs_id_token_attrs} identity_ci_oidc_id_token_attrs_id_token_attrs={identity_ci_oidc_id_token_attrs_id_token_attrs}
            identity_ci_oidc_id_token_attrs_id_token_attrs_valid={identity_ci_oidc_id_token_attrs_id_token_attrs_valid}
            identity_ci_oidc_id_token_attrs_id_token_attrs_invalid_text={identity_ci_oidc_id_token_attrs_id_token_attrs_invalid_text}
                    />
                  </Suspense>
                  <Suspense fallback={<div></div>}>
                    <IdentityciOidcscopesAdd loadGrid={identity_ci_oidc_scopesloadGrid} doClose={() => {closeAdd(idPrefix);}} idPrefix={idPrefix} 
            updateidentity_ci_oidc_scopes_scopes={updateidentity_ci_oidc_scopes_scopes} identity_ci_oidc_scopes_scopes={identity_ci_oidc_scopes_scopes}
            identity_ci_oidc_scopes_scopes_valid={identity_ci_oidc_scopes_scopes_valid}
            identity_ci_oidc_scopes_scopes_invalid_text={identity_ci_oidc_scopes_scopes_invalid_text}
                    />
                  </Suspense>
                  <Suspense fallback={<div></div>}>
                    <IdentityciOidcscopesEdit  loadGrid={identity_ci_oidc_scopesloadGrid} dataLoad={dataLoad} name={"identity_ci_oidc_scopes"} idPrefix={idPrefix + "_edit"} parentIdPrefix={idPrefix} 
            updateidentity_ci_oidc_scopes_scopes={updateidentity_ci_oidc_scopes_scopes} identity_ci_oidc_scopes_scopes={identity_ci_oidc_scopes_scopes}
            identity_ci_oidc_scopes_scopes_valid={identity_ci_oidc_scopes_scopes_valid}
            identity_ci_oidc_scopes_scopes_invalid_text={identity_ci_oidc_scopes_scopes_invalid_text}
                    />
                  </Suspense>
                  <Suspense fallback={<div></div>}>
                    <IdentityeaitriggersAdd loadGrid={identity_eai_triggersloadGrid} doClose={() => {closeAdd(idPrefix);}} idPrefix={idPrefix} 
            updateidentity_eai_triggers_triggers={updateidentity_eai_triggers_triggers} identity_eai_triggers_triggers={identity_eai_triggers_triggers}
            identity_eai_triggers_triggers_valid={identity_eai_triggers_triggers_valid}
            identity_eai_triggers_triggers_invalid_text={identity_eai_triggers_triggers_invalid_text}
                    />
                  </Suspense>
                  <Suspense fallback={<div></div>}>
                    <IdentityeaitriggersEdit  loadGrid={identity_eai_triggersloadGrid} dataLoad={dataLoad} name={"identity_eai_triggers"} idPrefix={idPrefix + "_edit"} parentIdPrefix={idPrefix} 
            updateidentity_eai_triggers_triggers={updateidentity_eai_triggers_triggers} identity_eai_triggers_triggers={identity_eai_triggers_triggers}
            identity_eai_triggers_triggers_valid={identity_eai_triggers_triggers_valid}
            identity_eai_triggers_triggers_invalid_text={identity_eai_triggers_triggers_invalid_text}
                    />
                  </Suspense>
                  <Suspense fallback={<div></div>}>
                    <IdentityoauthAdd loadGrid={identity_oauthloadGrid} doClose={() => {closeAdd(idPrefix);}} idPrefix={idPrefix} 
            updateidentity_oauth_auth_method={updateidentity_oauth_auth_method} identity_oauth_auth_method={identity_oauth_auth_method}
            updateidentity_oauth_client_id={updateidentity_oauth_client_id} identity_oauth_client_id={identity_oauth_client_id}
            updateidentity_oauth_client_id_hdr={updateidentity_oauth_client_id_hdr} identity_oauth_client_id_hdr={identity_oauth_client_id_hdr}
            updateidentity_oauth_client_secret={updateidentity_oauth_client_secret} identity_oauth_client_secret={identity_oauth_client_secret}
            updateidentity_oauth_introspection_endpoint={updateidentity_oauth_introspection_endpoint} identity_oauth_introspection_endpoint={identity_oauth_introspection_endpoint}
            updateidentity_oauth_mapped_identity={updateidentity_oauth_mapped_identity} identity_oauth_mapped_identity={identity_oauth_mapped_identity}
            updateidentity_oauth_multi_valued_scope={updateidentity_oauth_multi_valued_scope} identity_oauth_multi_valued_scope={identity_oauth_multi_valued_scope}
            updateidentity_oauth_name={updateidentity_oauth_name} identity_oauth_name={identity_oauth_name}
            identity_oauth_name_valid={identity_oauth_name_valid}
            identity_oauth_name_invalid_text={identity_oauth_name_invalid_text}
            updateidentity_oauth_proxy={updateidentity_oauth_proxy} identity_oauth_proxy={identity_oauth_proxy}
            updateidentity_oauth_restricted={updateidentity_oauth_restricted} identity_oauth_restricted={identity_oauth_restricted}
            updateidentity_oauth_token_type_hint={updateidentity_oauth_token_type_hint} identity_oauth_token_type_hint={identity_oauth_token_type_hint}
                    />
                  </Suspense>
                  <Suspense fallback={<div></div>}>
                    <IdentityoauthEdit  loadGrid={identity_oauthloadGrid} dataLoad={dataLoad} name={"identity_oauth"} idPrefix={idPrefix + "_edit"} parentIdPrefix={idPrefix} 
            updateidentity_oauth_auth_method={updateidentity_oauth_auth_method} identity_oauth_auth_method={identity_oauth_auth_method}
            updateidentity_oauth_client_id={updateidentity_oauth_client_id} identity_oauth_client_id={identity_oauth_client_id}
            updateidentity_oauth_client_id_hdr={updateidentity_oauth_client_id_hdr} identity_oauth_client_id_hdr={identity_oauth_client_id_hdr}
            updateidentity_oauth_client_secret={updateidentity_oauth_client_secret} identity_oauth_client_secret={identity_oauth_client_secret}
            updateidentity_oauth_introspection_endpoint={updateidentity_oauth_introspection_endpoint} identity_oauth_introspection_endpoint={identity_oauth_introspection_endpoint}
            updateidentity_oauth_mapped_identity={updateidentity_oauth_mapped_identity} identity_oauth_mapped_identity={identity_oauth_mapped_identity}
            updateidentity_oauth_multi_valued_scope={updateidentity_oauth_multi_valued_scope} identity_oauth_multi_valued_scope={identity_oauth_multi_valued_scope}
            updateidentity_oauth_name={updateidentity_oauth_name} identity_oauth_name={identity_oauth_name}
            identity_oauth_name_valid={identity_oauth_name_valid}
            identity_oauth_name_invalid_text={identity_oauth_name_invalid_text}
            updateidentity_oauth_proxy={updateidentity_oauth_proxy} identity_oauth_proxy={identity_oauth_proxy}
            updateidentity_oauth_restricted={updateidentity_oauth_restricted} identity_oauth_restricted={identity_oauth_restricted}
            updateidentity_oauth_token_type_hint={updateidentity_oauth_token_type_hint} identity_oauth_token_type_hint={identity_oauth_token_type_hint}
                    />
                  </Suspense>
                  <Suspense fallback={<div></div>}>
                    <IdentityoidcAdd loadGrid={identity_oidcloadGrid} doClose={() => {closeAdd(idPrefix);}} idPrefix={idPrefix} 
            updateidentity_oidc_client_id={updateidentity_oidc_client_id} identity_oidc_client_id={identity_oidc_client_id}
            updateidentity_oidc_client_secret={updateidentity_oidc_client_secret} identity_oidc_client_secret={identity_oidc_client_secret}
            updateidentity_oidc_discovery_endpoint={updateidentity_oidc_discovery_endpoint} identity_oidc_discovery_endpoint={identity_oidc_discovery_endpoint}
            identity_oidc_discovery_endpoint_valid={identity_oidc_discovery_endpoint_valid}
            identity_oidc_discovery_endpoint_invalid_text={identity_oidc_discovery_endpoint_invalid_text}
            updateidentity_oidc_mapped_identity={updateidentity_oidc_mapped_identity} identity_oidc_mapped_identity={identity_oidc_mapped_identity}
            updateidentity_oidc_name={updateidentity_oidc_name} identity_oidc_name={identity_oidc_name}
            updateidentity_oidc_pkce={updateidentity_oidc_pkce} identity_oidc_pkce={identity_oidc_pkce}
            updateidentity_oidc_proxy={updateidentity_oidc_proxy} identity_oidc_proxy={identity_oidc_proxy}
            updateidentity_oidc_redirect_uri_host={updateidentity_oidc_redirect_uri_host} identity_oidc_redirect_uri_host={identity_oidc_redirect_uri_host}
            updateidentity_oidc_response_mode={updateidentity_oidc_response_mode} identity_oidc_response_mode={identity_oidc_response_mode}
            updateidentity_oidc_response_type={updateidentity_oidc_response_type} identity_oidc_response_type={identity_oidc_response_type}
                    />
                  </Suspense>
                  <Suspense fallback={<div></div>}>
                    <IdentityoidcEdit  loadGrid={identity_oidcloadGrid} dataLoad={dataLoad} name={"identity_oidc"} idPrefix={idPrefix + "_edit"} parentIdPrefix={idPrefix} 
            updateidentity_oidc_client_id={updateidentity_oidc_client_id} identity_oidc_client_id={identity_oidc_client_id}
            updateidentity_oidc_client_secret={updateidentity_oidc_client_secret} identity_oidc_client_secret={identity_oidc_client_secret}
            updateidentity_oidc_discovery_endpoint={updateidentity_oidc_discovery_endpoint} identity_oidc_discovery_endpoint={identity_oidc_discovery_endpoint}
            identity_oidc_discovery_endpoint_valid={identity_oidc_discovery_endpoint_valid}
            identity_oidc_discovery_endpoint_invalid_text={identity_oidc_discovery_endpoint_invalid_text}
            updateidentity_oidc_mapped_identity={updateidentity_oidc_mapped_identity} identity_oidc_mapped_identity={identity_oidc_mapped_identity}
            updateidentity_oidc_name={updateidentity_oidc_name} identity_oidc_name={identity_oidc_name}
            updateidentity_oidc_pkce={updateidentity_oidc_pkce} identity_oidc_pkce={identity_oidc_pkce}
            updateidentity_oidc_proxy={updateidentity_oidc_proxy} identity_oidc_proxy={identity_oidc_proxy}
            updateidentity_oidc_redirect_uri_host={updateidentity_oidc_redirect_uri_host} identity_oidc_redirect_uri_host={identity_oidc_redirect_uri_host}
            updateidentity_oidc_response_mode={updateidentity_oidc_response_mode} identity_oidc_response_mode={identity_oidc_response_mode}
            updateidentity_oidc_response_type={updateidentity_oidc_response_type} identity_oidc_response_type={identity_oidc_response_type}
                    />
                  </Suspense>
              </div>
            </div>
          </div>
        </div>
    );
};
export default IdentityPage;
